
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5CNGn", function(module, exports) {

var $1ydBT = parcelRequire("1ydBT");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $jtuBN = parcelRequire("jtuBN");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $aqBZ0 = parcelRequire("aqBZ0");


var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});



var $deTj5 = parcelRequire("deTj5");


var $8SCD6 = parcelRequire("8SCD6");


var $fNzRA = parcelRequire("fNzRA");


var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");





var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");








var $aSsfA = parcelRequire("aSsfA");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $eTcMK = parcelRequire("eTcMK");


var $ifBRq = parcelRequire("ifBRq");

const $90365d58d6587547$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $90365d58d6587547$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
// Maximum wait time for scroll operations (in milliseconds)
const $90365d58d6587547$var$SCROLL_TIMEOUT_MS = 4000;
// Minimum time page must be stable before scrolling (in milliseconds)
const $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS = 500;
// Wait for document height to stabilize (tables may have async layout)
const $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS = 150;
const $90365d58d6587547$var$ObjectCommentQueryParamsListenerComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount } = t0;
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (scrollTimeoutRef.current !== null) {
                if (typeof scrollTimeoutRef.current === "number") {
                    if (typeof window !== "undefined" && "cancelIdleCallback" in window && typeof window.cancelIdleCallback === "function") window.cancelIdleCallback(scrollTimeoutRef.current);
                } else clearTimeout(scrollTimeoutRef.current);
                scrollTimeoutRef.current = null;
            }
        };
        $[0] = t1;
    } else t1 = $[0];
    const clearScrollTimeout = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (mutationObserverRef.current) {
                mutationObserverRef.current.disconnect();
                mutationObserverRef.current = null;
            }
        };
        $[1] = t2;
    } else t2 = $[1];
    const cleanupMutationObserver = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (mutationObserverRef.current) cleanupMutationObserver();
            if (scrollTimeoutRef.current !== null) clearScrollTimeout();
        };
        $[2] = t3;
    } else t3 = $[2];
    const cleanupScrollResources = t3;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isDataProcessed: isDataProcessed, allComments: allComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const focusedCommentId = $90365d58d6587547$var$useFocusedCommentIdQueryParam();
    const replyToComment = $90365d58d6587547$var$useReplyToCommentQueryParam();
    const commentId = focusedCommentId || replyToComment;
    const t4 = commentId || "";
    const t5 = contentId || "";
    let t6;
    if ($[3] !== pageMode) {
        t6 = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        $[3] = pageMode;
        $[4] = t6;
    } else t6 = $[4];
    const t7 = !commentId;
    let t8;
    if ($[5] !== t7) {
        t8 = {
            skip: t7
        };
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t8) {
        t9 = {
            commentId: t4,
            contentId: t5,
            contentStatus: t6,
            options: t8
        };
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)(t9);
    let isResolved;
    let parentId;
    if ($[12] !== comment || $[13] !== commentError) {
        isResolved = undefined;
        parentId = undefined;
        if (comment && !commentError) {
            const location = comment.location;
            isResolved = Boolean(location?.commentResolveProperties?.resolved);
            parentId = comment.parentId;
        }
        $[12] = comment;
        $[13] = commentError;
        $[14] = isResolved;
        $[15] = parentId;
    } else {
        isResolved = $[14];
        parentId = $[15];
    }
    let t10;
    if ($[16] !== allComments || $[17] !== allObjectCommentsRendered || $[18] !== comment || $[19] !== commentError || $[20] !== commentId || $[21] !== focusedCommentId || $[22] !== hasLoadedObjectComments || $[23] !== hasScrolledToFocusedComment || $[24] !== hasScrolledToReplyComment || $[25] !== isDataProcessed || $[26] !== isResolved || $[27] !== parentId || $[28] !== replyToComment || $[29] !== setCurrentlySelectedThreadKey || $[30] !== setReplyToCommentId || $[31] !== showCommentsPanel) {
        t10 = ()=>{
            const hasData = comment && !commentError;
            if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                let rootCommentId;
                if (isDataProcessed && allComments.length > 0) {
                    const rootComment = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId);
                    rootCommentId = rootComment?.id;
                }
                if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
            }
            if (hasData && commentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_queryparam_selection", "isEnabled", true)) {
                const location_0 = comment?.location;
                if (location_0 && "type" in location_0 && location_0.type === "INLINE") return;
            }
            if (commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
                if (isResolved) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    setCurrentlySelectedThreadKey(commentId, (0, $kgNLQ.CommentType).GENERAL);
                    if (focusedCommentId) setHasScrolledToFocusedComment(true);
                    else setHasScrolledToReplyComment(true);
                } else {
                    const commentElementId = `footer-comment-thread-${commentId}-container`;
                    const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                    const commentElement = document.getElementById(commentElementId);
                    const replyCommentElement = document.getElementById(replyCommentElementId);
                    const element = commentElement || replyCommentElement;
                    let threadToBeSelected = commentId;
                    if (parentId && (0, $6mKj3.expValEquals)("confluence_comment_deeplink_thread_selection", "isEnabled", true)) {
                        let rootCommentId_0;
                        if (isDataProcessed && allComments.length > 0) {
                            const rootComment_0 = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId);
                            rootCommentId_0 = rootComment_0?.id;
                        }
                        threadToBeSelected = rootCommentId_0 ?? parentId;
                    }
                    if (commentId) {
                        if ((0, $6mKj3.expValEquals)("confluence_comment_deeplink_delay_scroll", "isEnabled", true)) {
                            if (replyToComment) {
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                const commentWithAuthor = comment;
                                const author = commentWithAuthor?.author;
                                setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)("confluence_comment_expand_reply_editor", "isEnabled", true)));
                                setHasScrolledToReplyComment(true);
                                return;
                            }
                            cleanupMutationObserver();
                            const getDocumentScrollHeight = $90365d58d6587547$var$_temp;
                            const scrollToComment = ()=>{
                                const element_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (element_0 && (0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) getDocumentScrollHeight();
                                (0, $9FoVw.handleFooterCommentsNavigation)({
                                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                    block: "center",
                                    inline: "center",
                                    commentId: commentId,
                                    navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                                });
                                setHasScrolledToFocusedComment(true);
                                setCurrentlySelectedThreadKey(threadToBeSelected);
                                cleanupMutationObserver();
                            };
                            const performScrollAndCleanup = ()=>{
                                clearScrollTimeout();
                                if ((0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) requestAnimationFrame(()=>{
                                    requestAnimationFrame(scrollToComment);
                                });
                                else scrollToComment();
                            };
                            const checkHeightStabilityThenScroll = ()=>{
                                if (!(0, $9wGTI.fg)("confluence_comment_footer_scrolling_fix")) {
                                    performScrollAndCleanup();
                                    return;
                                }
                                const h1 = getDocumentScrollHeight();
                                scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    const h2 = getDocumentScrollHeight();
                                    if (h1 === h2) performScrollAndCleanup();
                                    else scheduleScroll();
                                }, $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS);
                            };
                            const scheduleScroll = ()=>{
                                clearScrollTimeout();
                                lastMutationTimeRef.current = Date.now();
                                if (typeof window !== "undefined" && "requestIdleCallback" in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                    const checkStabilityAndScroll = ()=>{
                                        const timeSinceLastMutation = Date.now() - lastMutationTimeRef.current;
                                        if (timeSinceLastMutation >= $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS) checkHeightStabilityThenScroll();
                                        else scrollTimeoutRef.current = setTimeout(()=>{
                                            scrollTimeoutRef.current = null;
                                            checkStabilityAndScroll();
                                        }, $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS - timeSinceLastMutation);
                                    };
                                    checkStabilityAndScroll();
                                });
                                else scrollTimeoutRef.current = setTimeout(()=>{
                                    scrollTimeoutRef.current = null;
                                    checkHeightStabilityThenScroll();
                                }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                            };
                            const getElementAndCheckReady = ()=>{
                                const foundElement = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                                if (!foundElement) return {
                                    element: null,
                                    isReady: false
                                };
                                const rect = foundElement.getBoundingClientRect();
                                const elementIsReady = foundElement.offsetHeight > 0 && foundElement.offsetWidth > 0 && rect.height > 0 && rect.width > 0;
                                return {
                                    element: foundElement,
                                    isReady: elementIsReady
                                };
                            };
                            const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                            if (currentElement && isReady) scheduleScroll();
                            else {
                                mutationObserverRef.current = new MutationObserver(()=>{
                                    lastMutationTimeRef.current = Date.now();
                                    const { element: foundElement_0, isReady: foundIsReady } = getElementAndCheckReady();
                                    if (foundElement_0 && foundIsReady) scheduleScroll();
                                });
                                if (currentElement) {
                                    mutationObserverRef.current.observe(currentElement, {
                                        childList: true,
                                        subtree: true,
                                        attributes: true,
                                        attributeFilter: [
                                            "style",
                                            "class"
                                        ]
                                    });
                                    const parentContainer = currentElement.parentElement;
                                    if (parentContainer) mutationObserverRef.current.observe(parentContainer, {
                                        childList: true,
                                        subtree: true
                                    });
                                } else mutationObserverRef.current.observe(document.body, {
                                    childList: true,
                                    subtree: true
                                });
                                setTimeout(()=>{
                                    if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                                }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                            }
                        } else if (element) {
                            (0, $9FoVw.handleFooterCommentsNavigation)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                block: "center",
                                inline: "center",
                                commentId: commentId,
                                navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                        }
                    }
                }
            }
        };
        $[16] = allComments;
        $[17] = allObjectCommentsRendered;
        $[18] = comment;
        $[19] = commentError;
        $[20] = commentId;
        $[21] = focusedCommentId;
        $[22] = hasLoadedObjectComments;
        $[23] = hasScrolledToFocusedComment;
        $[24] = hasScrolledToReplyComment;
        $[25] = isDataProcessed;
        $[26] = isResolved;
        $[27] = parentId;
        $[28] = replyToComment;
        $[29] = setCurrentlySelectedThreadKey;
        $[30] = setReplyToCommentId;
        $[31] = showCommentsPanel;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== allComments || $[34] !== allObjectCommentsRendered || $[35] !== comment || $[36] !== commentBatchCount || $[37] !== commentBatchRendered || $[38] !== commentError || $[39] !== commentId || $[40] !== focusedCommentId || $[41] !== hasLoadedObjectComments || $[42] !== hasScrolledToFocusedComment || $[43] !== hasScrolledToReplyComment || $[44] !== isDataProcessed || $[45] !== isResolved || $[46] !== parentId || $[47] !== replyToComment || $[48] !== setCurrentlySelectedThreadKey || $[49] !== setReplyToCommentId || $[50] !== showCommentsPanel) {
        t11 = [
            comment,
            commentError,
            hasLoadedObjectComments,
            commentId,
            focusedCommentId,
            replyToComment,
            allObjectCommentsRendered,
            commentBatchRendered,
            commentBatchCount,
            setCurrentlySelectedThreadKey,
            setReplyToCommentId,
            isResolved,
            showCommentsPanel,
            hasScrolledToFocusedComment,
            hasScrolledToReplyComment,
            parentId,
            isDataProcessed,
            allComments
        ];
        $[33] = allComments;
        $[34] = allObjectCommentsRendered;
        $[35] = comment;
        $[36] = commentBatchCount;
        $[37] = commentBatchRendered;
        $[38] = commentError;
        $[39] = commentId;
        $[40] = focusedCommentId;
        $[41] = hasLoadedObjectComments;
        $[42] = hasScrolledToFocusedComment;
        $[43] = hasScrolledToReplyComment;
        $[44] = isDataProcessed;
        $[45] = isResolved;
        $[46] = parentId;
        $[47] = replyToComment;
        $[48] = setCurrentlySelectedThreadKey;
        $[49] = setReplyToCommentId;
        $[50] = showCommentsPanel;
        $[51] = t11;
    } else t11 = $[51];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            setHasScrolledToFocusedComment(false);
            setHasScrolledToReplyComment(false);
            cleanupScrollResources();
        };
        $[52] = t12;
    } else t12 = $[52];
    let t13;
    if ($[53] !== focusedCommentId || $[54] !== replyToComment) {
        t13 = [
            focusedCommentId,
            replyToComment,
            cleanupScrollResources
        ];
        $[53] = focusedCommentId;
        $[54] = replyToComment;
        $[55] = t13;
    } else t13 = $[55];
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>()=>{
                cleanupScrollResources();
            };
        t15 = [
            cleanupScrollResources
        ];
        $[56] = t14;
        $[57] = t15;
    } else {
        t14 = $[56];
        t15 = $[57];
    }
    (0, $cozmU.useEffect)(t14, t15);
    return null;
} : ({ hasLoadedObjectComments: hasLoadedObjectComments, allObjectCommentsRendered: allObjectCommentsRendered, commentBatchRendered: commentBatchRendered, commentBatchCount: commentBatchCount })=>{
    const [hasScrolledToFocusedComment, setHasScrolledToFocusedComment] = (0, $cozmU.useState)(false);
    const [hasScrolledToReplyComment, setHasScrolledToReplyComment] = (0, $cozmU.useState)(false);
    const mutationObserverRef = (0, $cozmU.useRef)(null);
    const scrollTimeoutRef = (0, $cozmU.useRef)(null);
    const lastMutationTimeRef = (0, $cozmU.useRef)(0);
    // Helper function to clear scroll timeout/callback
    const clearScrollTimeout = ()=>{
        if (scrollTimeoutRef.current !== null) {
            if (typeof scrollTimeoutRef.current === 'number') // requestIdleCallback ID
            {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(scrollTimeoutRef.current);
            } else // setTimeout ID
            clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }
    };
    // Helper function to clean up MutationObserver
    const cleanupMutationObserver = ()=>{
        if (mutationObserverRef.current) {
            mutationObserverRef.current.disconnect();
            mutationObserverRef.current = null;
        }
    };
    // Helper function to clean up both observer and timeout (only if they were set up)
    const cleanupScrollResources = (0, $cozmU.useCallback)(()=>{
        if (mutationObserverRef.current) cleanupMutationObserver();
        if (scrollTimeoutRef.current !== null) clearScrollTimeout();
    }, []); // Empty deps: only uses refs which don't change
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isDataProcessed: isDataProcessed, allComments: allComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const focusedCommentId = $90365d58d6587547$var$useFocusedCommentIdQueryParam();
    const replyToComment = $90365d58d6587547$var$useReplyToCommentQueryParam();
    const commentId = focusedCommentId || replyToComment;
    // Read the focused/reply comment
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: !commentId
        }
    });
    let isResolved = undefined;
    let parentId = undefined;
    // Extract resolved status and parentId from the comment
    if (comment && !commentError) {
        const location = comment.location;
        isResolved = Boolean(location?.commentResolveProperties?.resolved);
        parentId = comment.parentId;
    }
    // Handle scrolling to focused comment or replyToComment after the data is loaded
    (0, $cozmU.useEffect)(()=>{
        // Determine if we have comment data
        const hasData = comment && !commentError;
        // Update currentlySelectedThreadKey to root comment ID when data becomes available
        // This runs even after scroll has happened to ensure correct thread highlighting
        if (parentId && (hasScrolledToFocusedComment || hasScrolledToReplyComment) && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
            let rootCommentId;
            if (isDataProcessed && allComments.length > 0) {
                const rootComment = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId);
                rootCommentId = rootComment?.id;
            }
            if (rootCommentId && rootCommentId !== parentId) setCurrentlySelectedThreadKey(rootCommentId);
        }
        // Early return if comment type is INLINE - this component only handles footer/object comments
        if (hasData && commentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_queryparam_selection', 'isEnabled', true)) {
            const location_0 = comment?.location;
            if (location_0 && 'type' in location_0 && location_0.type === 'INLINE') return;
        }
        if (// Note that if the commentId is not found, the query will return an error and we don't
        // have to scroll to the comment
        commentId && hasData && hasLoadedObjectComments && allObjectCommentsRendered && !hasScrolledToFocusedComment && !hasScrolledToReplyComment) {
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                setCurrentlySelectedThreadKey(commentId, (0, $kgNLQ.CommentType).GENERAL);
                if (focusedCommentId) setHasScrolledToFocusedComment(true);
                else setHasScrolledToReplyComment(true);
            } else {
                const commentElementId = `footer-comment-thread-${commentId}-container`;
                const replyCommentElementId = `footer-comment-thread-${commentId}-replies`;
                const commentElement = document.getElementById(commentElementId);
                const replyCommentElement = document.getElementById(replyCommentElementId);
                const element = commentElement || replyCommentElement;
                // When experiment is enabled, select the root thread (for replies) or the comment itself
                // This ensures the entire thread is highlighted when deep-linking to a reply
                let threadToBeSelected = commentId;
                if (parentId && (0, $6mKj3.expValEquals)('confluence_comment_deeplink_thread_selection', 'isEnabled', true)) {
                    // Try to find the root comment ID from available data sources
                    let rootCommentId_0;
                    if (isDataProcessed && allComments.length > 0) {
                        const rootComment_0 = (0, $kgNLQ.findRootCommentForReply)(allComments, parentId);
                        rootCommentId_0 = rootComment_0?.id;
                    }
                    threadToBeSelected = rootCommentId_0 ?? parentId;
                }
                // Use unified navigation for scrolling
                if (commentId) {
                    if ((0, $6mKj3.expValEquals)('confluence_comment_deeplink_delay_scroll', 'isEnabled', true)) {
                        if (replyToComment) {
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            // Get author information from comment data
                            const commentWithAuthor = comment;
                            const author = commentWithAuthor?.author;
                            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToComment, (0, $i6UMJ.LocationValue).FOOTER, author, (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true)));
                            setHasScrolledToReplyComment(true);
                            return;
                        }
                        // Use MutationObserver to watch for when the element is ready
                        // Clean up any existing observer first
                        cleanupMutationObserver();
                        const getDocumentScrollHeight = ()=>Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
                        const scrollToComment = ()=>{
                            const element_0 = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                            if (element_0 && (0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                element_0.offsetTop;
                                getDocumentScrollHeight();
                            }
                            (0, $9FoVw.handleFooterCommentsNavigation)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                block: 'center',
                                inline: 'center',
                                commentId: commentId,
                                navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                            });
                            setHasScrolledToFocusedComment(true);
                            setCurrentlySelectedThreadKey(threadToBeSelected);
                            cleanupMutationObserver();
                        };
                        // Perform scroll; when FG on: double rAF + force reflow for correct layout
                        const performScrollAndCleanup = ()=>{
                            clearScrollTimeout();
                            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                            if ((0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) requestAnimationFrame(()=>{
                                requestAnimationFrame(scrollToComment);
                            });
                            else scrollToComment();
                        };
                        // When FG on: check document height stable (tables may have async layout)
                        const checkHeightStabilityThenScroll = ()=>{
                            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                            if (!(0, $9wGTI.fg)('confluence_comment_footer_scrolling_fix')) {
                                performScrollAndCleanup();
                                return;
                            }
                            const h1 = getDocumentScrollHeight();
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                const h2 = getDocumentScrollHeight();
                                if (h1 === h2) performScrollAndCleanup();
                                else scheduleScroll();
                            }, $90365d58d6587547$var$HEIGHT_STABILITY_CHECK_MS);
                        };
                        // Schedule scroll when page is idle/stable
                        const scheduleScroll = ()=>{
                            clearScrollTimeout();
                            // Track when we detected the element is ready
                            lastMutationTimeRef.current = Date.now();
                            // Use requestIdleCallback if available, otherwise fallback to setTimeout
                            if (typeof window !== 'undefined' && 'requestIdleCallback' in window) scrollTimeoutRef.current = window.requestIdleCallback(()=>{
                                const checkStabilityAndScroll = ()=>{
                                    const timeSinceLastMutation = Date.now() - lastMutationTimeRef.current;
                                    if (timeSinceLastMutation >= $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS) // Mutations stable - when FG on: check height stable, then scroll
                                    checkHeightStabilityThenScroll();
                                    else // Not stable yet - wait and re-check (don't scroll blindly)
                                    scrollTimeoutRef.current = setTimeout(()=>{
                                        scrollTimeoutRef.current = null;
                                        checkStabilityAndScroll();
                                    }, $90365d58d6587547$var$PAGE_STABILITY_DELAY_MS - timeSinceLastMutation);
                                };
                                checkStabilityAndScroll();
                            });
                            else // Fallback for browsers without requestIdleCallback (e.g., Safari)
                            scrollTimeoutRef.current = setTimeout(()=>{
                                scrollTimeoutRef.current = null;
                                checkHeightStabilityThenScroll();
                            }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                        };
                        // Check if element exists and is ready (has content and is visible)
                        const getElementAndCheckReady = ()=>{
                            const foundElement = document.getElementById(commentElementId) || document.getElementById(replyCommentElementId);
                            if (!foundElement) return {
                                element: null,
                                isReady: false
                            };
                            const rect = foundElement.getBoundingClientRect();
                            const elementIsReady = foundElement.offsetHeight > 0 && foundElement.offsetWidth > 0 && rect.height > 0 && rect.width > 0;
                            return {
                                element: foundElement,
                                isReady: elementIsReady
                            };
                        };
                        const { element: currentElement, isReady: isReady } = getElementAndCheckReady();
                        // If element exists and is already ready, schedule scroll with delay
                        if (currentElement && isReady) scheduleScroll();
                        else {
                            // Set up MutationObserver to watch for when element appears or becomes ready
                            mutationObserverRef.current = new MutationObserver(()=>{
                                // Update last mutation time when DOM changes
                                lastMutationTimeRef.current = Date.now();
                                const { element: foundElement_0, isReady: foundIsReady } = getElementAndCheckReady();
                                if (foundElement_0 && foundIsReady) scheduleScroll();
                            });
                            // If element exists, observe it and its parent
                            if (currentElement) {
                                mutationObserverRef.current.observe(currentElement, {
                                    childList: true,
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: [
                                        'style',
                                        'class'
                                    ]
                                });
                                const parentContainer = currentElement.parentElement;
                                if (parentContainer) mutationObserverRef.current.observe(parentContainer, {
                                    childList: true,
                                    subtree: true
                                });
                            } else // If element doesn't exist yet, observe document.body to detect when it appears
                            mutationObserverRef.current.observe(document.body, {
                                childList: true,
                                subtree: true
                            });
                            // Fallback timeout in case MutationObserver doesn't detect changes
                            setTimeout(()=>{
                                if (mutationObserverRef.current) checkHeightStabilityThenScroll();
                            }, $90365d58d6587547$var$SCROLL_TIMEOUT_MS);
                        }
                    } else if (element) {
                        (0, $9FoVw.handleFooterCommentsNavigation)({
                            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                            block: 'center',
                            inline: 'center',
                            commentId: commentId,
                            navigationContext: parentId ? (0, $9FoVw.NavigationContext).REPLY : undefined
                        });
                        setHasScrolledToFocusedComment(true);
                        setCurrentlySelectedThreadKey(threadToBeSelected);
                    }
                }
            }
        }
    }, [
        comment,
        commentError,
        hasLoadedObjectComments,
        commentId,
        focusedCommentId,
        replyToComment,
        allObjectCommentsRendered,
        commentBatchRendered,
        commentBatchCount,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        isResolved,
        showCommentsPanel,
        hasScrolledToFocusedComment,
        hasScrolledToReplyComment,
        parentId,
        isDataProcessed,
        allComments
    ]);
    // Reset scroll tracking when focusedCommentId or replyToComment changes
    (0, $cozmU.useEffect)(()=>{
        setHasScrolledToFocusedComment(false);
        setHasScrolledToReplyComment(false);
        // Clean up scroll resources when comment ID changes (only if they were set up)
        cleanupScrollResources();
    }, [
        focusedCommentId,
        replyToComment,
        cleanupScrollResources
    ]);
    // Clean up MutationObserver and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanupScrollResources();
        };
    }, [
        cleanupScrollResources
    ]);
    return null;
};
const $90365d58d6587547$var$withObjectCommentQueryParamUnification = (Component)=>(props)=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_comment_param_unification')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ifBRq.CommentQueryParamsListener), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
    };
const $90365d58d6587547$export$1e65952d87b47593 = $90365d58d6587547$var$withObjectCommentQueryParamUnification($90365d58d6587547$var$ObjectCommentQueryParamsListenerComponent);
function $90365d58d6587547$var$_temp() {
    return Math.max(document.documentElement?.scrollHeight ?? 0, document.body?.scrollHeight ?? 0);
}



var $8i27m = parcelRequire("8i27m");





var $6lAIr = parcelRequire("6lAIr");





var $aHcFH = parcelRequire("aHcFH");


var $lFkRf = parcelRequire("lFkRf");


var $FBfum = parcelRequire("FBfum");


var $isEtk = parcelRequire("isEtk");


var $5vi32 = parcelRequire("5vi32");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");





var $1xpoY = parcelRequire("1xpoY");


var $7aRa9 = parcelRequire("7aRa9");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $jmjWc = parcelRequire("jmjWc");


var $b0EGa = parcelRequire("b0EGa");





var $htsj6 = parcelRequire("htsj6");


var $cD1qu = parcelRequire("cD1qu");





var $jAfH5 = parcelRequire("jAfH5");





var $1P7Cq = parcelRequire("1P7Cq");


var $fHAwL = parcelRequire("fHAwL");








var $eCryJ = parcelRequire("eCryJ");





var $5kqgA = parcelRequire("5kqgA");


var $bQm3c = parcelRequire("bQm3c");


var $6FXhW = parcelRequire("6FXhW");


var $3a1bc = parcelRequire("3a1bc");


var $cvIm8 = parcelRequire("cvIm8");

// Delay before deleting the per-user `cc-agent-mention-sessions` marker when the sessions query
// is empty. Derived from the sessions-poll schedule so it always outlasts the final poll (+2s
// margin): a freshly-mentioned comment's session is created asynchronously by the backend, so the
// query is briefly empty while usePageCommentAgentSessionsInner polls. Deriving it from
// SESSION_REFETCH_DELAYS_MS (rather than hardcoding) keeps the two in lockstep if the poll
// schedule ever changes.
const $ac96fb5095c0413f$var$MARKER_DELETE_DELAY_MS = Math.max(...(0, $cvIm8.SESSION_REFETCH_DELAYS_MS)) + 2000;
/**
 * Inner component — calls useLazyLoadQuery (may suspend or throw on error).
 * Must not be rendered directly; always wrap with AgentSessionsFetcher.
 */ function $ac96fb5095c0413f$var$AgentSessionsFetcherInner({ pageId: pageId, children: children, refetchOnMount: refetchOnMount, preserveEmptyMarker: preserveEmptyMarker }) {
    const { sessionMap: sessionMap, conversationMap: conversationMap, hasConfirmedNoSessions: hasConfirmedNoSessions } = (0, $cvIm8.usePageCommentAgentSessionsInner)(pageId, {
        refetchOnMount: refetchOnMount
    });
    const conversationSignature = (0, $cozmU.useMemo)(()=>JSON.stringify(Array.from(conversationMap).sort()), [
        conversationMap
    ]);
    // The query builds a fresh map every render; only publish changed associations.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const stableConversationMap = (0, $cozmU.useMemo)(()=>conversationMap, [
        conversationSignature
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: pageId,
        contentType: 'page'
    });
    (0, $cozmU.useEffect)(()=>{
        if (sessionMap.size > 0 || !userId || preserveEmptyMarker) return;
        // An empty map is not proof that the page has no sessions — every row may have been
        // COMPLETED (filtered client-side), the connection may have come back null on a partial
        // error, or the content node may not have resolved. Deleting the marker on any of those
        // is a sticky failure: the mount gate in ObjectCommentContainer reads it to decide whether
        // to mount this fetcher at all, so the sessions never reappear on later loads either.
        // Only delete when the server positively reported zero rows. Ordered so the experiments
        // are evaluated last — exposure fires only when marker handling would differ.
        if (!hasConfirmedNoSessions && ((0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true))) return;
        // The sessions query came back empty. Don't delete the marker immediately: right after an
        // agent-mention comment is saved the backend creates the SessionAssociationPublic
        // asynchronously, so the query is briefly empty while usePageCommentAgentSessionsInner polls
        // for it. Defer the delete past that poll window — if a session shows up the map size
        // changes, this effect re-runs and the cleanup cancels the pending delete, so the
        // freshly-written marker is preserved (and the next page load still shows the session). Only
        // a marker that stays empty through the whole window is genuinely stale and gets cleaned up.
        const deleteMarkerTimer = setTimeout(()=>{
            updateContentProperty({
                propertyKey: `cc-agent-mention-sessions:${userId}`,
                isDelete: true
            });
        }, $ac96fb5095c0413f$var$MARKER_DELETE_DELAY_MS);
        return ()=>clearTimeout(deleteMarkerTimer);
    // Depend on sessionMap.size, not sessionMap: buildSessionMap returns a new Map
    // instance on every render even when data is unchanged, so using the Map reference
    // as a dep would fire this effect on every re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasConfirmedNoSessions,
        preserveEmptyMarker,
        sessionMap.size,
        updateContentProperty,
        userId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3a1bc.AgentSessionPollingProvider), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FXhW.AgentSessionsContext).Provider, {
        value: sessionMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6FXhW.CommentAgentConversationsContext).Provider, {
        value: stableConversationMap
    }, children)));
}
function $ac96fb5095c0413f$export$4d8c455866c22554({ pageId: pageId, children: children, refetchOnMount: refetchOnMount = false, preserveEmptyMarker: preserveEmptyMarker = false }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ac96fb5095c0413f$var$AgentSessionsFetcherInner, {
        pageId: pageId,
        refetchOnMount: refetchOnMount,
        preserveEmptyMarker: preserveEmptyMarker
    }, children)));
}



var $gXKuh = parcelRequire("gXKuh");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $90hCa = parcelRequire("90hCa");


var $cQbnm = parcelRequire("cQbnm");








var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");





























var $fs6LW = parcelRequire("fs6LW");











var $w6R6I = parcelRequire("w6R6I");


var $lpNn5 = parcelRequire("lpNn5");





var $hBYtq = parcelRequire("hBYtq");


var $famWw = parcelRequire("famWw");


var $dANtQ = parcelRequire("dANtQ");








var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $c5b321ea0eb33bcf$var$styles = {
    inputStyle: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn _0bjKvD8fU6 _2sNsIgmnOE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _4kiQYAUofl _2Zuz6Q8HPE _1Znuxb8HPE _37wbyuchRC _0hPCNLDIqT _39xV02N91d _0KLXrulfZc _1UtDYzKGUX",
    inputTextStyle: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
    enabledStyle: "_0ReiIHJxkL _1eOmH6d1Zr",
    disabledStyle: "_1YKVNsVx3j _0wOv4Qsyl5"
};
const $c5b321ea0eb33bcf$var$i18n = (0, $kSwu1.defineMessages)({
    addCommentTooltip: {
        id: "object-comments.footer.add-button-tooltip",
        defaultMessage: "Add comment"
    },
    addCommentPromptText: {
        id: "object-comments.add-comment-prompt.text",
        defaultMessage: "Add a comment"
    },
    addCommentPromptAriaLabel: {
        id: "object-comments.add-comment-prompt.aria-label",
        defaultMessage: "Add a general comment"
    }
});
// Space, same as the legacy trigger, so it never expands as a side effect of focus being
// restored here programmatically (e.g. after a discard-comment confirmation dialog closes).
// `isDisabled` already renders a native `disabled` button, which suppresses `onClick` for free.
const $c5b321ea0eb33bcf$var$NewAddCommentPrompt = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { onClick: onClick, autofocusRef: autofocusRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId || "");
    const buttonRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== autofocusRef) {
        t1 = ()=>{
            if (autofocusRef.current) {
                buttonRef.current?.focus({
                    preventScroll: true
                });
                autofocusRef.current = false;
            }
        };
        t2 = [
            autofocusRef
        ];
        $[0] = autofocusRef;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    const t3 = !canAddComments ? $c5b321ea0eb33bcf$var$styles.disabledStyle : $c5b321ea0eb33bcf$var$styles.enabledStyle;
    let t4;
    if ($[3] !== t3) {
        t4 = (0, $w6R6I.cx)($c5b321ea0eb33bcf$var$styles.inputStyle, t3);
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = !canAddComments;
    let t6;
    if ($[5] !== formatMessage) {
        t6 = formatMessage($c5b321ea0eb33bcf$var$i18n.addCommentPromptAriaLabel);
        $[5] = formatMessage;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== formatMessage) {
        t7 = formatMessage($c5b321ea0eb33bcf$var$i18n.addCommentPromptText);
        $[7] = formatMessage;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $c5b321ea0eb33bcf$var$styles.inputTextStyle
        }, t7);
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== onClick || $[12] !== t4 || $[13] !== t5 || $[14] !== t6 || $[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: t4,
            isDisabled: t5,
            onClick: onClick,
            testId: "add-comment-button",
            ref: buttonRef,
            "aria-label": t6
        }, t8);
        $[11] = onClick;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
};
const $c5b321ea0eb33bcf$export$ba63fdcb08237d72 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onClick: onClick, autofocusRef: autofocusRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
        };
        $[0] = t1;
    } else t1 = $[0];
    const addCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t1);
    const buttonRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[1] !== autofocusRef) {
        t2 = ()=>{
            if (autofocusRef.current) {
                buttonRef.current?.focus({
                    preventScroll: true
                });
                autofocusRef.current = false;
            }
        };
        t3 = [
            autofocusRef
        ];
        $[1] = autofocusRef;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    if ((0, $6mKj3.expValEquals)("confluence_footer_reactions_redesign", "isEnabled", true)) {
        let t4;
        if ($[4] !== autofocusRef || $[5] !== onClick) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5b321ea0eb33bcf$var$NewAddCommentPrompt, {
                onClick: onClick,
                autofocusRef: autofocusRef
            });
            $[4] = autofocusRef;
            $[5] = onClick;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    let t4;
    if ($[7] !== formatMessage) {
        t4 = (0, $6mKj3.expValEquals)("confluence_comments_cohiti_footer_tooltips", "isEnabled", true) ? formatMessage($c5b321ea0eb33bcf$var$i18n.addCommentTooltip) : undefined;
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== autofocusRef || $[10] !== onClick) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $famWw.AddCommentPromptButton), {
            onClick: onClick,
            autofocusRef: autofocusRef,
            testId: "add-comment-button"
        });
        $[9] = autofocusRef;
        $[10] = onClick;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== addCommentShortcutStrings || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t4,
            shortcut: addCommentShortcutStrings,
            position: "top"
        }, t5));
        $[12] = addCommentShortcutStrings;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};



var $dL5YQ = parcelRequire("dL5YQ");











var $b35Wv = parcelRequire("b35Wv");


var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $9sGCn = parcelRequire("9sGCn");





var $7QM6o = parcelRequire("7QM6o");




const $2c779d914e38fe28$var$i18n = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "object-comments.page.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "object-comments.page.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $2c779d914e38fe28$export$3b5f3f6ec721f20a = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { isOffline: t1, optimisticReactions: t2, onExpandedChange: onExpandedChange } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const optimisticReactions = t2 === undefined ? false : t2;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    let t3;
    if ($[0] !== contentId) {
        t3 = (0, $9sGCn.getCachedPageData)(contentId);
        $[0] = contentId;
        $[1] = t3;
    } else t3 = $[1];
    const { subType: subType } = t3;
    let t4;
    if ($[2] !== formatMessage) {
        t4 = formatMessage($2c779d914e38fe28$var$i18n.addReaction);
        $[2] = formatMessage;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: t4
        });
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const customIcon = t5;
    const t6 = contentId || "";
    const t7 = contentType === "blogpost" ? (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST : (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE;
    const t8 = spaceId || "";
    let t9;
    if ($[6] !== formatMessage) {
        t9 = formatMessage($2c779d914e38fe28$var$i18n.addNew);
        $[6] = formatMessage;
        $[7] = t9;
    } else t9 = $[7];
    const t10 = isReactionsEnabled ? customIcon : undefined;
    let t11;
    if ($[8] !== customIcon || $[9] !== isOffline || $[10] !== onExpandedChange || $[11] !== optimisticReactions || $[12] !== subType || $[13] !== t10 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1NF8X.ReactionsLoader), {
            contentId: t6,
            location: t7,
            containerId: t8,
            containerType: (0, $3FlVr.ReactionContainerType).SPACE,
            contentSubType: subType,
            summaryViewEnabled: true,
            summaryViewThreshold: 1,
            allowSelectFromSummaryView: true,
            useButtonAlignmentStyling: true,
            summaryViewPlacement: "bottom-end",
            readOnly: isOffline,
            isViewOnly: isOffline,
            isSubtle: true,
            reactionPickerTriggerIcon: customIcon,
            reactionPickerTriggerText: t9,
            useDefaultStyledContainer: false,
            hidePlaceholder: Boolean(window.__SSR_RENDERED__),
            noRelativeContainer: false,
            noFlexWrap: false,
            hoverableSummaryView: true,
            reactionPickerPlacement: "bottom-end",
            summaryButtonIconAfter: t10,
            optimisticallyLoadSummaryEmojis: optimisticReactions,
            renderParticleEffectOnSummaryView: true,
            onFooterReactionsExpandedChange: onExpandedChange
        });
        $[8] = customIcon;
        $[9] = isOffline;
        $[10] = onExpandedChange;
        $[11] = optimisticReactions;
        $[12] = subType;
        $[13] = t10;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
        $[18] = t11;
    } else t11 = $[18];
    return t11;
};



// chunk is produced even though each file defines it separately.
const $2998c7377d5266d6$var$FooterLabelsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zM3y-",
    name: "FooterLabelsLoader",
    loader: async ()=>(await (parcelRequire("l3kuI"))).FooterLabels
});
const $2998c7377d5266d6$var$styles = {
    addCommentContainerStyles: "_4FKVYE5zaO _2bqfgdOeNX _1mT5xdHE3j _0Bm75GPgdg _3iDTPbQ4SZ _39xV02N91d _0KLXrulfZc",
    addCommentClosedContainerStyles: "_39xV02N91d _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _3YEZNOdnbC",
    addCommentLeftGroupStyles: "_2mHwu82ADO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    addCommentLeftGroupNewStyles: "_2mHwu82ADO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIBY1A",
    addCommentReactionsContainerStyles: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS",
    addCommentReactionsContainerNewStyles: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuz9WS _39xV02N91d _4ouGXIdnbC",
    rightButtonContainerStyles: "_0hPCNLDIqT",
    rightButtonContainerNewStyles: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _0hPCNLDIqT _4ouGXIdnbC _3TGfC9LRg7",
    addCommentClosedContainerNewStyles: "_2mHwu8NHnM _39xV02N91d _3iDTPbQ4SZ _3TGfC9LRg7 _0hPCNLDIqT _3YEZNOdnbC",
    addCommentClosedContainerNewExpandedStyles: "_2mHwu8NHnM _39xV02N91d _3iDTPbQ4SZ _0aFT5vIDxV _0hPCNLFlnN _3YEZNOdnbC",
    newAddCommentAvatarStyles: "_39xV02cM5X _0jFU0VcM5X _3YEZNOdnbC"
};
// query only runs when this layout is the one actually rendering.
const $2998c7377d5266d6$var$NewAddCommentPromptContent = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { showReactions: showReactions, isOffline: isOffline, optimisticReactions: optimisticReactions, onExpand: onExpand, autofocusRef: autofocusRef } = t0;
    const authorInfo = (0, $dL5YQ.useCommentAuthorInfo)();
    const [reactionsExpanded, setReactionsExpanded] = (0, $cozmU.useState)(false);
    const t1 = reactionsExpanded ? $2998c7377d5266d6$var$styles.addCommentClosedContainerNewExpandedStyles : $2998c7377d5266d6$var$styles.addCommentClosedContainerNewStyles;
    let t2;
    if ($[0] !== authorInfo.accountId || $[1] !== authorInfo.avatarUrl || $[2] !== authorInfo.displayName || $[3] !== authorInfo.error || $[4] !== authorInfo.loading) {
        t2 = !authorInfo.loading && !authorInfo.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
            size: "small",
            canViewProfile: true,
            src: authorInfo.avatarUrl,
            userId: authorInfo.accountId,
            isAnonymous: !authorInfo.accountId,
            name: authorInfo.displayName,
            testId: "object-add-comment-prompt-avatar"
        });
        $[0] = authorInfo.accountId;
        $[1] = authorInfo.avatarUrl;
        $[2] = authorInfo.displayName;
        $[3] = authorInfo.error;
        $[4] = authorInfo.loading;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.newAddCommentAvatarStyles
        }, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== autofocusRef || $[9] !== onExpand) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5b321ea0eb33bcf$export$ba63fdcb08237d72), {
            onClick: onExpand,
            autofocusRef: autofocusRef
        });
        $[8] = autofocusRef;
        $[9] = onExpand;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.addCommentLeftGroupNewStyles
        }, t3, t4);
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== isOffline || $[15] !== optimisticReactions || $[16] !== showReactions) {
        t6 = showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            testId: "objectAddCommentContainer-rightButtonContainer",
            xcss: $2998c7377d5266d6$var$styles.rightButtonContainerNewStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.addCommentReactionsContainerNewStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline,
            optimisticReactions: optimisticReactions,
            onExpandedChange: setReactionsExpanded
        })));
        $[14] = isOffline;
        $[15] = optimisticReactions;
        $[16] = showReactions;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t1 || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t1
        }, t5, t6);
        $[18] = t1;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
};
const $2998c7377d5266d6$export$5ed9c7f27c15b7fe = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { showReactions: showReactions, showLabels: showLabels, isOffline: isOffline, optimisticReactions: t1 } = t0;
    const optimisticReactions = t1 === undefined ? false : t1;
    const shouldAutofocusPromptRef = (0, $cozmU.useRef)(false);
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== setFooterEditorEntry) {
        t2 = ()=>{
            expandCommentContainer({
                entryPoint: "pageFooter"
            });
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
        };
        $[0] = expandCommentContainer;
        $[1] = setFooterEditorEntry;
        $[2] = t2;
    } else t2 = $[2];
    const handleExpandCommentContainer = t2;
    let t3;
    if ($[3] !== contentId || $[4] !== expanded || $[5] !== handleExpandCommentContainer || $[6] !== isOffline || $[7] !== optimisticReactions || $[8] !== showLabels || $[9] !== showReactions) {
        t3 = !expanded && ((0, $6mKj3.expValEquals)("confluence_footer_reactions_redesign", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2998c7377d5266d6$var$NewAddCommentPromptContent, {
            showReactions: showReactions,
            isOffline: isOffline,
            optimisticReactions: optimisticReactions,
            onExpand: handleExpandCommentContainer,
            autofocusRef: shouldAutofocusPromptRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.addCommentClosedContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c5b321ea0eb33bcf$export$ba63fdcb08237d72), {
            onClick: handleExpandCommentContainer,
            autofocusRef: shouldAutofocusPromptRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.050",
            testId: "objectAddCommentContainer-rightButtonContainer",
            xcss: $2998c7377d5266d6$var$styles.rightButtonContainerStyles
        }, showLabels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2998c7377d5266d6$var$FooterLabelsLoader, null)), showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2998c7377d5266d6$var$styles.addCommentReactionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline,
            optimisticReactions: optimisticReactions
        })))));
        $[3] = contentId;
        $[4] = expanded;
        $[5] = handleExpandCommentContainer;
        $[6] = isOffline;
        $[7] = optimisticReactions;
        $[8] = showLabels;
        $[9] = showReactions;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            id: "addCommentButton",
            xcss: $2998c7377d5266d6$var$styles.addCommentContainerStyles,
            testId: "addCommentButton"
        }, t3);
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
};
const $2998c7377d5266d6$export$f3a35a1c0e5d2996 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})($2998c7377d5266d6$export$5ed9c7f27c15b7fe);






var $hekY6 = parcelRequire("hekY6");





var $3cu4A = parcelRequire("3cu4A");


var $7qvmT = parcelRequire("7qvmT");

















var $6Pqow = parcelRequire("6Pqow");


var $kA6Zo = parcelRequire("kA6Zo");


var $hMaHH = parcelRequire("hMaHH");





var $cAdj8 = parcelRequire("cAdj8");





var $3ejfs = parcelRequire("3ejfs");














var $i8TeS = parcelRequire("i8TeS");








var $4ywyi = parcelRequire("4ywyi");





var $7wP5b = parcelRequire("7wP5b");


var $ibqdE = parcelRequire("ibqdE");




/**
 * @generated SignedSource<<af601d1c4ff54d1ee14ab40f03d6343d>>
 * @relayHash 9fe996eb874f5dede5dfc631ede9be23
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006
const $db736b7a8747d643$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIdToDelete"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "deleteFrom"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentIdToDelete",
                    "variableName": "commentIdToDelete"
                },
                {
                    "kind": "Variable",
                    "name": "deleteFrom",
                    "variableName": "deleteFrom"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9fe996eb874f5dede5dfc631ede9be23",
            "id": "2fa3189beb0d12f2e99399a53106adbbd4a876cdd3959a0dd45b206edfab8006",
            "metadata": {},
            "name": "ObjectCommentDeleteGeneralCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentDeleteGeneralCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
        }
    };
}();
$db736b7a8747d643$var$node.hash = "70583226681dc587971b709a0fb5f1db";
var $db736b7a8747d643$export$2e2bcd8739ae039 = $db736b7a8747d643$var$node;


/**
 * @generated SignedSource<<ca37f2645dc8fcae1fb0169b2b6d90eb>>
 * @relayHash b4e5556f7ff0caaaa5f1f415e0fac219
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9fa83969df6abf4d4b492477645bde3a26b2e75d7cfa9ff354ba53793c159bf
const $c485e89730d7822c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ReopenCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentReopenCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceReopenCommentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_reopenComment",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b4e5556f7ff0caaaa5f1f415e0fac219",
            "id": "e9fa83969df6abf4d4b492477645bde3a26b2e75d7cfa9ff354ba53793c159bf",
            "metadata": {},
            "name": "ObjectCommentReopenCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentReopenCommentMutation($commentId:ID!,$cloudId:ID!){confluence_reopenComment(commentId:$commentId,cloudId:$cloudId){success,commentResolutionStates{commentId,status},errors{message,extensions{...on ReopenCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$c485e89730d7822c$var$node.hash = "08b0a438d17f5dfc7506b876a28c3269";
var $c485e89730d7822c$export$2e2bcd8739ae039 = $c485e89730d7822c$var$node;


/**
 * @generated SignedSource<<7671439f51f98ccffffbe6f6978d5c7d>>
 * @relayHash a8f662ea3948cbf66f23cd060b8803dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92
const $b2dfa720986474e4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentIds"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "commentIds",
            "variableName": "commentIds"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "ConfluenceCommentResolutionState",
        "kind": "LinkedField",
        "name": "commentResolutionStates",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "commentId"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "resolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedFriendlyDate"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "errorType"
            },
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ],
        "type": "ResolveCommentsMutationErrorExtension"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentResolveCommentMutation",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "ConfluenceResolveCommentsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_resolveComments",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a8f662ea3948cbf66f23cd060b8803dd",
            "id": "2ccc5bea86cc33406aa32467d323c904c73f7bdc731e44dfb1f2b74b491a4c92",
            "metadata": {},
            "name": "ObjectCommentResolveCommentMutation",
            "operationKind": "mutation",
            "text": "mutation ObjectCommentResolveCommentMutation($commentIds:[ID]!,$cloudId:ID!){confluence_resolveComments(commentIds:$commentIds,cloudId:$cloudId){success,commentResolutionStates{commentId,resolveProperties{resolvedTime,resolvedUser,resolvedFriendlyDate},status},errors{message,extensions{...on ResolveCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$b2dfa720986474e4$var$node.hash = "b22b5ff3d19850498d8af166b371db75";
var $b2dfa720986474e4$export$2e2bcd8739ae039 = $b2dfa720986474e4$var$node;









var $9DHhW = parcelRequire("9DHhW");





var $NYiei = parcelRequire("NYiei");


var $jbF1h = parcelRequire("jbF1h");








var $bSvtO = parcelRequire("bSvtO");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $1Sjzs = parcelRequire("1Sjzs");


var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");


var $cHfPA = parcelRequire("cHfPA");





var $liGyh = parcelRequire("liGyh");


var $7aw3q = parcelRequire("7aw3q");














var $9CnRS = parcelRequire("9CnRS");

















var $en1dX = parcelRequire("en1dX");





var $6tkbf = parcelRequire("6tkbf");





var $cTi4A = parcelRequire("cTi4A");


var $423Rl = parcelRequire("423Rl");





var $mzXSs = parcelRequire("mzXSs");


var $6Db1b = parcelRequire("6Db1b");


var $308Wd = parcelRequire("308Wd");

const $972174ea64671f70$var$ObjectCommentResolveCommentMutation = (0, $b2dfa720986474e4$export$2e2bcd8739ae039);
const $972174ea64671f70$var$ObjectCommentReopenCommentMutation = (0, $c485e89730d7822c$export$2e2bcd8739ae039);
const $972174ea64671f70$var$ObjectCommentDeleteGeneralCommentMutation = (0, $db736b7a8747d643$export$2e2bcd8739ae039);
const $972174ea64671f70$var$i18n = (0, $kSwu1.defineMessages)({
    commentReopenedFlagTitle: {
        id: "object-comments.comment.reopened.flag.title",
        defaultMessage: "Comment reopened"
    },
    commentReopenFailedFlagTitle: {
        id: "object-comments.comment.reopen.failed.flag.title",
        defaultMessage: "Failed to reopen comment"
    },
    commentReopenCacheUpdateFailedFlagTitle: {
        id: "object-comments.comment.reopen.cache-update.failed.flag.title",
        defaultMessage: "Failed to update reopened comment. Please refresh the page."
    },
    retryCTA: {
        id: "object-comments.comment.reopen.failed.flag.cta.retry",
        defaultMessage: "Retry now"
    }
});
const $972174ea64671f70$export$f8aa7c43d6421d1d = ({ comment: comment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, pageInfo: pageInfo, isUnread: isUnread = false, threadKey: threadKey, flags: flags, adjustForNestedReplies: adjustForNestedReplies = false, hideBranchingStyle: hideBranchingStyle = false, canAddComments: canAddComments = true, isParentCommentOpen: isParentCommentOpen, adjustForFooterNestedReplies: adjustForFooterNestedReplies = false, topLevelParentCommentId: topLevelParentCommentId, commentHasChildren: commentHasChildren = false, isLastNestedFooterReply: isLastNestedFooterReply = false, isOffline: isOffline = false, showRepliesWithCurvedBorders: showRepliesWithCurvedBorders, replyHasNestedObjects: replyHasNestedObjects = false })=>{
    // Store stable references to break circular dependency in useCallback
    const handleResolveCommentRef = (0, $cozmU.useRef)(null);
    const handleReopenCommentRef = (0, $cozmU.useRef)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Get cache operations
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // Get processed comments data
    const { hasNestedComments: hasNestedComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ currentlySelectedThreadKey: currentlySelectedThreadKey, footerEditCommentIds: footerEditCommentIds }, { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, addFooterEditCommentId: addFooterEditCommentId, removeFooterEditCommentId: removeFooterEditCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { focusedCommentId: focusedCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const [resolveCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentResolveCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    const resolveCommentMutationFn = resolveCommentFn;
    const [reopenCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentReopenCommentMutation, {
        refetchQueries: [],
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    // Get the update functions for the comments data manager - aliased to support the different
    // mutation's different result types
    const { updateCommentInCache: updateResolveCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { updateCommentInCache: updateReopenCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const [deleteGeneralCommentFn] = (0, $308Wd.useMutationInterop)($972174ea64671f70$var$ObjectCommentDeleteGeneralCommentMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "object-comments"
    });
    const userId = comment?.author?.accountId;
    const topCommentUserAvatar = comment?.author?.profilePicture?.path;
    const topCommentDisplayName = comment?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = comment?.id;
    const date = comment?.version?.when;
    const createdAt = comment?.createdAt?.value;
    const createdAtNonLocalized = comment?.createdAtNonLocalized;
    const versionByDisplayName = comment?.version?.by?.displayName;
    const versionDate = comment?.version?.when;
    const permissions = comment?.permissions;
    const content = comment?.body?.value;
    const permissionType = comment?.author?.permissionType ?? undefined;
    const parentCommentId = comment?.parentId;
    const isReply = !!parentCommentId;
    const isEdited = (comment?.version?.number || 0) > 1;
    const numReplies = comment?.replies?.length || 0;
    const commentUrl = comment?.links.webui ?? undefined;
    const parentReactionsSummary = comment?.reactionsSummary ?? null;
    const [refetchedReaction, setRefetchedReaction] = (0, $cozmU.useState)(null);
    const inheritedReactionsData = refetchedReaction && refetchedReaction.commentId === commentId && refetchedReaction.parentSummary === parentReactionsSummary ? refetchedReaction.summary : parentReactionsSummary;
    const handleReactionRefetch = (0, $cozmU.useCallback)((refetchedComment)=>{
        if (refetchedComment?.id && refetchedComment.id === commentId) setRefetchedReaction({
            commentId: refetchedComment.id,
            parentSummary: parentReactionsSummary,
            summary: refetchedComment.reactionsSummary
        });
    }, [
        commentId,
        parentReactionsSummary
    ]);
    const footerCommentLocation = comment?.location;
    const getResolvedProperties = (0, $cozmU.useCallback)(()=>{
        const properties = footerCommentLocation?.commentResolveProperties;
        if (!isReply) return properties || undefined;
        return undefined;
    }, [
        footerCommentLocation,
        isReply
    ]);
    const resolveProperties = getResolvedProperties();
    const deleteCommentInCacheOnUpdate = (0, $cozmU.useCallback)((removalCommentId)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                    error: err,
                    commentId: removalCommentId
                });
            },
            onCacheMiss: (_err)=>{
                flags?.showWarningFlag({
                    id: 'delete-comment-in-cache-error',
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).networkError)
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker,
        flags
    ]);
    const nonMemoizedHandleDeleteGeneralComment = ()=>{
        let deleteLocation;
        const deleteVariables = {
            variables: {
                commentIdToDelete: commentId,
                deleteFrom: deleteLocation
            },
            update: ()=>deleteCommentInCacheOnUpdate(commentId),
            optimisticResponse: {
                deleteComment: true
            }
        };
        deleteGeneralCommentFn({
            ...deleteVariables
        }).then(({ data: data })=>{
            if (!data || !data.deleteComment) throw new Error('No data returned from mutation');
            resetContentChanged();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    attributes: {
                        commentType: (0, $en1dX.CommentType).PAGE,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        pageMode: pageMode,
                        isReply: isReply
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err_0)=>{
            const parsedError = (0, $isdzP.parseError)(err_0);
            const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, commentId);
            if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
                flags?.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'alreadyDeleted',
                        actionSubject: 'comment',
                        actionSubjectId: commentId,
                        objectType: 'page',
                        objectId: contentId,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        attributes: {
                            commentType: (0, $kgNLQ.CommentType).GENERAL,
                            source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                            mode: pageMode,
                            isReply: isReply
                        }
                    }
                }).fire();
            } else // show an error flag to the user when optimistic deletion fails
            flags?.showErrorFlag({
                id: commentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).deleteError)
            });
            (0, $8dA1U.handleMutationFailure)({
                experienceTracker: experienceTracker,
                experienceName: (0, $irVI7.DELETE_PAGE_COMMENT_EXPERIENCE),
                error: err_0,
                commentId: commentId
            });
        });
    };
    const memoizedHandleDeleteGeneralComment = (0, $cozmU.useCallback)(nonMemoizedHandleDeleteGeneralComment, [
        commentId,
        createAnalyticsEvent,
        deleteGeneralCommentFn,
        deleteCommentInCacheOnUpdate,
        experienceTracker,
        flags,
        isReply,
        contentId,
        pageMode,
        resetContentChanged
    ]);
    /**
   * editComment, deleteComment, and resolveComment cause instability in CommentBody when rendering. Although
   * useStableCallback would be more ideal to simplify the overhead for consumers of CommentBody, these functions
   * as props are used as proxies for permissions meaning they could be undefined which violates the typing for useStableCallback
   */ const handleDeleteGeneralComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleDeleteGeneralComment : nonMemoizedHandleDeleteGeneralComment;
    const nonMemoHandleEditComment = ()=>{
        addFooterEditCommentId(commentId);
    };
    const memoizedHandleEditComment = (0, $cozmU.useCallback)(nonMemoHandleEditComment, [
        addFooterEditCommentId,
        commentId
    ]);
    const handleEditComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleEditComment : nonMemoHandleEditComment;
    const exitCommentEditor = ()=>{
        removeFooterEditCommentId(commentId);
    };
    const handleReplyToComment = (id)=>{
        setReplyToCommentId({
            // If we allow nested comments, reply directly to the comment (set in CommentActions)
            // Otherwise, reply to the to the parent comment
            parentCommentId: hasNestedComments ? id : topLevelParentCommentId || id,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            user: {
                // This field controls who we auto mention in the reply
                displayName: comment?.author?.displayName,
                accountId: comment?.author?.accountId
            }
        });
    };
    const handleReopenMutationFailure = (0, $cozmU.useCallback)(({ isCacheUpdateFailed: isCacheUpdateFailed })=>{
        // TODO: Add experience tracking for reopening, which will allow us to differentiate and
        // detect cache errors vs mutation errors by the error value in the stopOnError() experience
        // call.  When that is added, we can go back to having a single flag message.
        flags?.showErrorFlag({
            id: commentId,
            title: formatMessage(isCacheUpdateFailed ? $972174ea64671f70$var$i18n.commentReopenCacheUpdateFailedFlagTitle : $972174ea64671f70$var$i18n.commentReopenFailedFlagTitle),
            isAutoDismiss: true,
            actions: [
                {
                    content: formatMessage($972174ea64671f70$var$i18n.retryCTA),
                    onClick: ()=>{
                        flags.hideFlag(flags.state.flags[0]?.id);
                        handleReopenCommentRef.current?.();
                    }
                }
            ]
        });
    }, [
        commentId,
        flags,
        formatMessage
    ]);
    const reopenCommentUpdateFn = (0, $cozmU.useCallback)((_dataProxy, mutationResult)=>updateReopenCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.reopenCommentInCacheCallback),
            onError: ()=>handleReopenMutationFailure({
                    isCacheUpdateFailed: true
                })
        }), [
        commentId,
        handleReopenMutationFailure,
        updateReopenCommentInCache
    ]);
    const nonMemoHandleReopenComment = ()=>{
        // NOTE: The reopen experience is started in CommentActions.tsx
        reopenCommentFn({
            variables: {
                commentId: commentId,
                cloudId: cloudId
            },
            update: reopenCommentUpdateFn
        }).then(()=>{
            // Show the reopen flag
            flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage($972174ea64671f70$var$i18n.commentReopenedFlagTitle),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).OPEN
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).OPEN);
                            if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).OPEN,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleResolveCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
        }).catch(()=>{
            handleReopenMutationFailure({
                isCacheUpdateFailed: false
            });
        });
    };
    const memoHandleReopenComment = (0, $cozmU.useCallback)(nonMemoHandleReopenComment, [
        cloudId,
        commentId,
        flags,
        formatMessage,
        handleReopenMutationFailure,
        isCommentsPanelShown,
        reopenCommentFn,
        reopenCommentUpdateFn,
        setCurrentView,
        showCommentsPanel,
        threadKey
    ]);
    const handleResolveMutationFailure = (0, $cozmU.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE),
            error: resolveError
        });
    }, [
        experienceTracker
    ]);
    const resolveCommentsUpdateFn = (0, $cozmU.useCallback)((_dataProxy_0, mutationResult_0)=>updateResolveCommentInCache({
            mutationResult: mutationResult_0,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateResolveCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const nonMemoHandleResolveComment = ()=>{
        const mutationVariables = {
            commentIds: [
                commentId
            ],
            cloudId: cloudId
        };
        // NOTE: The RESOLVED experience is started in CommentActions.tsx
        resolveCommentMutationFn({
            variables: mutationVariables,
            update: resolveCommentsUpdateFn,
            // When a `optimisticResponse` is set, useMutation invokes the update function twice:
            // first immediately, and after mutation succeeds, a second time. If mutation fails,
            // the cache updated by the update function is rolled back.
            optimisticResponse: {
                confluence_resolveComments: {
                    commentResolutionStates: [
                        {
                            commentId: commentId,
                            status: true,
                            resolveProperties: {
                                // These 2 values will be updated to the correct value after mutation succeeds.
                                // - `resolvedUser` is only displayed in comments panel Resolved view,
                                //   inside a tooltip when hovered.
                                // - `resolvedFriendlyDate` is part of the mutation payload, but the current UI
                                //   displays `resolvedTime`.
                                // So setting it as empty optimistically won't affect the static UI.
                                resolvedUser: null,
                                resolvedFriendlyDate: '',
                                resolvedTime: Date.now(),
                                __typename: 'InlineCommentResolveProperties'
                            },
                            __typename: 'ConfluenceCommentResolutionState'
                        }
                    ],
                    success: true,
                    errors: [],
                    __typename: 'ConfluenceResolveCommentsPayload'
                }
            }
        }).then(()=>{
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: threadKey,
                pageId: contentId,
                pageMode: pageMode,
                source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                commentType: (0, $kgNLQ.CommentType).GENERAL,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (allowComments) flags?.showSuccessCircleFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolvedFlagText),
                isAutoDismiss: true,
                actions: [
                    {
                        content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                        onClick: ()=>{
                            if (!isCommentsPanelShown) showCommentsPanel({
                                openWithView: (0, $3mVfX.ViewValues).RESOLVED
                            });
                            else setCurrentView((0, $3mVfX.ViewValues).RESOLVED);
                            if ((0, $6mKj3.expValEquals)('confluence_comments_scrollto_resolve', 'isEnabled', true)) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                context: (0, $9FoVw.NavigationContext).PANEL,
                                block: 'center',
                                annotationId: threadKey,
                                commentType: 'FOOTER',
                                annotationClicked: true,
                                expectedView: (0, $3mVfX.ViewValues).RESOLVED,
                                commentId: commentId
                            });
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    },
                    {
                        content: formatMessage((0, $9CnRS.i18n).undoCTA),
                        onClick: ()=>{
                            handleReopenCommentRef.current?.();
                            flags.hideFlag(flags.state.flags[0]?.id);
                        }
                    }
                ]
            });
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_PAGE_COMMENT_EXPERIENCE)
            });
        }).catch((err_1)=>{
            // Show an error flag to user when resolve fails
            flags?.showErrorFlag({
                id: commentId,
                title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                description: formatMessage((0, $9CnRS.i18n).resolveError)
            });
            handleResolveMutationFailure(err_1);
        });
    };
    const memoizedHandleResolveComment = (0, $cozmU.useCallback)(nonMemoHandleResolveComment, [
        allowComments,
        cloudId,
        commentId,
        createAnalyticsEvent,
        experienceTracker,
        flags,
        formatMessage,
        handleResolveMutationFailure,
        isCommentsPanelShown,
        contentId,
        pageMode,
        resolveCommentMutationFn,
        resolveCommentsUpdateFn,
        setCurrentView,
        showCommentsPanel,
        threadKey
    ]);
    const handleResolveComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedHandleResolveComment : nonMemoHandleResolveComment;
    const handleReopenComment = (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoHandleReopenComment : nonMemoHandleReopenComment;
    // Update refs to break circular dependency
    handleResolveCommentRef.current = handleResolveComment;
    handleReopenCommentRef.current = handleReopenComment;
    const pageType = pageInfo?.type ?? '';
    // Agent session — wire SSE state for the agent-mention-in-comment feature.
    // Any comment (top-level OR reply) can be associated with an agent session, so
    // each comment looks up its OWN session by commentId from AgentSessionsContext
    // (the map is keyed by the numeric comment id parsed from the session's
    // subEntityId ARI, populated by the page-level fetch). When there is no session
    // the hook is a no-op. The experiment is inlined per
    // confluence-feature-gating/inline-usage and ordered last (gate-last).
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    const agentSession = commentId ? agentSessions.get(commentId) : undefined;
    const { state: agentSessionState, agentIdentity: optimisticAgentIdentity, sessionStatusRef: sessionStatusRef } = (0, $mzXSs.useCommentAgentSession)((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? commentId ?? '' : '', (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? agentSession?.conversationId : undefined, (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? agentSession?.state ?? undefined : undefined);
    // Agent reaction writes have no client notification; refresh the footer on session changes.
    (0, $6Db1b.useRefetchReactionsOnAgentSessionChange)({
        commentId: commentId,
        contentId: contentId,
        agentSessionState: agentSessionState,
        displayedReactionsSummary: inheritedReactionsData,
        onRefetch: handleReactionRefetch
    });
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    // User space permissions - only access when feature gate is on
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op_1)=>op_1?.operation === 'create' && op_1?.targetType === 'attachment') || spaceOperations.some((op_0)=>op_0?.operation === 'create' && op_0?.targetType === 'attachment');
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    // We only want to focus resolved comments because the 'active' comments have
    // their own treatment for when one is hovered/selected and could cause weird behavior
    const isCommentFocused = resolveProperties?.resolved && commentId === focusedCommentId;
    const commentContent = footerEditCommentIds?.has(commentId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auGhu.EditComment), {
        pageId: contentId,
        date: date ?? '',
        createdAtNonLocalized: createdAtNonLocalized,
        pageType: pageType,
        commentId: commentId,
        annotationId: threadKey,
        spaceId: spaceId,
        content: content ?? '',
        isReply: isReply,
        isDangling: false,
        displayCommentInViewMode: exitCommentEditor,
        avatarUrl: topCommentUserAvatar ?? '',
        displayName: topCommentDisplayName,
        dateUrl: commentUrl ?? '',
        versionByDisplayName: versionByDisplayName ?? '',
        versionDate: versionDate ?? '',
        mode: pageMode === (0, $cD1qu.PageMode).VIEW ? 'view' : 'edit',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        isFooterComment: true,
        commentType: (0, $kgNLQ.CommentType).GENERAL,
        adjustForFooterReplies: commentHasChildren || !isReply && numReplies > 0,
        isLastNestedFooterReply: isLastNestedFooterReply,
        isOffline: isOffline
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEmgx.CommentBody), {
        mode: "view",
        annotationId: threadKey,
        userId: userId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: date ?? '',
        dateUrl: commentUrl ?? '',
        createdAt: createdAt ?? '',
        createdAtNonLocalized: createdAtNonLocalized ?? '',
        versionByDisplayName: versionByDisplayName ?? '',
        versionDate: versionDate ?? '',
        pageId: contentId,
        pageType: pageType,
        commentId: commentId ?? '',
        agentChatMenuItem: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $423Rl.CommentAgentOpenChatMenuItemAsync), {
            commentId: commentId ?? ''
        }) : undefined,
        isReply: isReply,
        isEdited: isEdited,
        parentCommentId: parentCommentId,
        permissions: permissions,
        content: content ?? '',
        permissionType: permissionType ?? undefined,
        supportedActions: supportedTopLevelActions,
        deleteComment: handleDeleteGeneralComment,
        editComment: handleEditComment,
        resolveComment: handleResolveComment,
        numReplies: numReplies,
        isUnread: isUnread,
        isCommentActive: true,
        isCommentsPanel: true,
        isFocused: isCommentFocused,
        resolveProperties: resolveProperties,
        replyToComment: handleReplyToComment,
        inheritedReactionsData: inheritedReactionsData,
        currentlySelectedThreadKey: currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
        commentType: (0, $kgNLQ.CommentType).GENERAL,
        adjustForNestedReplies: adjustForNestedReplies,
        hideBranchingStyle: hideBranchingStyle,
        canAddComments: canAddComments,
        isParentCommentOpen: isParentCommentOpen,
        isFooterComment: true,
        adjustForFooterNestedReplies: adjustForFooterNestedReplies,
        isOffline: isOffline,
        showRepliesWithCurvedBorders: showRepliesWithCurvedBorders,
        replyHasNestedObjects: replyHasNestedObjects,
        contributors: (0, $cHfPA.hasContributors)(comment) ? comment.contributors : undefined
    });
    // When this comment (top-level or reply) has an associated agent session, attach
    // the AvatarWithActionButton (from AFM PR #370723) BELOW the comment — the comment
    // still renders normally. The component drives its label/action off agentState.
    // Interim — prop values will be refined once the design branch is fully merged.
    // Gate inlined and ordered last per confluence-feature-gating rules.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, commentContent, agentSessionState && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && (isReply ? // Nested replies: wrap the status row in the same curved branch a reply uses so it
    // attaches to the thread's connector line. Top-level comments render it unwrapped.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Sjzs.WithCurvedBranchingStyle), {
        showDefaultStyles: true,
        customStyles: {
            left: '-16px',
            height: '24px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTi4A.AvatarWithActionButtonAsync), {
        commentId: commentId,
        agentState: agentSessionState,
        agentIdentity: agentSession ?? optimisticAgentIdentity,
        conversationId: agentSession?.conversationId ?? '',
        userId: agentSession?.agentId ?? userId,
        avatarUrl: agentSession?.avatarUrl ?? topCommentUserAvatar,
        agentName: agentSession?.agentName ?? undefined,
        isReply: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTi4A.AvatarWithActionButtonAsync), {
        commentId: commentId,
        agentState: agentSessionState,
        agentIdentity: agentSession ?? optimisticAgentIdentity,
        conversationId: agentSession?.conversationId ?? '',
        userId: agentSession?.agentId ?? userId,
        avatarUrl: agentSession?.avatarUrl ?? topCommentUserAvatar,
        agentName: agentSession?.agentName ?? undefined,
        sessionStatusRef: sessionStatusRef,
        threadRail: (0, $kEmgx.drawsThreadRail)({
            hideBranchingStyle: hideBranchingStyle,
            numReplies: numReplies,
            canAddComments: canAddComments
        }) && (0, $6mKj3.expValEquals)('platform_editor_inline_agentic_comments', 'isEnabled', true) ? 'comment' : undefined
    })));
};















var $6faGq = parcelRequire("6faGq");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");











var $58Zuw = parcelRequire("58Zuw");


var $lLpk8 = parcelRequire("lLpk8");


var $enWGp = parcelRequire("enWGp");


var $8gR6k = parcelRequire("8gR6k");


var $jVIRU = parcelRequire("jVIRU");










/* ObjectCommentNestableReplies.tsx generated by @compiled/babel-plugin v3.0.2 */ 

















































var $g8bbY = parcelRequire("g8bbY");





var $hXzKU = parcelRequire("hXzKU");








var $ag51I = parcelRequire("ag51I");




















var $hl1Kw = parcelRequire("hl1Kw");




















var $emtVP = parcelRequire("emtVP");

const $7c5ea6bb1ec976c9$export$25e4139e54938aaf = (0, $7aRa9.withFlags)(({ flags: flags, pageInfo: pageInfo, pageMode: pageMode, setReplyView: setReplyView, parentComment: parentComment, threadKey: threadKey, replyToId: replyToId, isOffline: isOffline })=>{
    const replyEditorContainerId = `object-comment-reply-editor-${replyToId}`;
    const pageId = pageInfo?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    const spaceId = pageInfo?.space?.id ?? '';
    const commentType = parentComment.type;
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: pageId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $cozmU.useContext)((0, $8SCD6.ReactionsContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ replyToCommentId: replyToCommentId, replyToCommentUser: replyToCommentUser, replyToContributorUsers: replyToContributorUsers }, { setReplyToCommentId: setReplyToCommentId }] = (0, $3mVfX.useCommentsPanel)();
    const [, setCommentForEdit] = (0, $cozmU.useState)('');
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // User page permissions
    const operations = pageInfo?.operations || [];
    // User space permissions - only access when feature gate is on
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment');
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    const onEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        let experienceName = (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE);
        if (commentType === (0, $kgNLQ.CommentType).GENERAL) experienceName = (0, $irVI7.REPLY_TO_PAGE_COMMENT_LOAD_EXPERIENCE);
        experienceTracker.succeed({
            name: experienceName
        });
        const commentReplyContainer = typeof document !== 'undefined' ? document.getElementById(replyEditorContainerId) : null;
        if (!commentReplyContainer) return;
        // Check whether the bottom of the comment reply container is visible
        const isBottomOutOfView = commentReplyContainer.getBoundingClientRect().bottom > window.innerHeight;
        // Only scroll if we currently can't see the bottom of the comment reply container. It's annoying to always scroll
        if (isBottomOutOfView) commentReplyContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
        // Focus the editor to position cursor after the @mention
        if (editorActions?.focus) editorActions.focus();
    }, [
        commentType,
        experienceTracker,
        replyEditorContainerId
    ]);
    const handleCancelComment = (0, $cozmU.useCallback)(({ destroy: destroy = false } = {})=>{
        if (!destroy || replyToCommentId !== replyToId) setReplyToCommentId();
    }, [
        replyToCommentId,
        replyToId,
        setReplyToCommentId
    ]);
    const handleCacheMiss = (0, $cozmU.useCallback)((_error)=>{
        flags?.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).networkError)
        });
    }, [
        flags
    ]);
    const handleSaveComment = (0, $cozmU.useCallback)((adf, onSuccess)=>{
        // Wrap createObjectReplyFn to intercept the mutation result for agent mentions.
        // Using explicit if/else to avoid nested ternary (Sonar S3358).
        let wrappedCreateObjectReplyFn;
        if ((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) wrappedCreateObjectReplyFn = (...args)=>{
            const promise = createObjectCommentMutationFn(...args);
            promise?.then(({ data: data })=>{
                const commentId = data?.createFooterComment?.id ?? data?.createObjectComment?.id ?? replyToId;
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId, userId ?? undefined, 'footer');
            });
            return promise;
        };
        else wrappedCreateObjectReplyFn = createObjectCommentMutationFn;
        // comments-panel's SaveProps still describes the pre-Data-Manager callback
        // types. Runtime values are compatible; keep the bridge local until its
        // sibling cleanup migrates that public contract.
        return (0, $7qvmT.onSaveReply)({
            pageId: pageId,
            parentCommentId: replyToId,
            cloudId: cloudId,
            adf: adf,
            onSuccess: onSuccess,
            pageMode: pageMode,
            setCommentForEdit: setCommentForEdit,
            createAnalyticsEvent: createAnalyticsEvent,
            pageType: pageType,
            experienceTracker: experienceTracker,
            createObjectReplyFn: wrappedCreateObjectReplyFn,
            addCommentInCommentsDataManagerCacheFn: (props)=>{
                addCommentInCache({
                    ...props,
                    onCacheMiss: handleCacheMiss
                });
            },
            // comments-panel still requires this legacy callback. It is a no-op for
            // the launched Data Manager path.
            addReplyToCommentThread: ()=>{},
            threadKey: threadKey,
            commentType: commentType,
            searchSessionId: searchSessionId,
            isReactionsEnabled: isReactionsEnabled,
            setReplyView: setReplyView,
            setReplyToCommentId: setReplyToCommentId,
            resetContentChanged: resetContentChanged,
            analyticsSource: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
            isFooterComment: true,
            userId: userId,
            displayName: displayName
        });
    }, [
        threadKey,
        setReplyToCommentId,
        setReplyView,
        searchSessionId,
        resetContentChanged,
        replyToId,
        cloudId,
        commentType,
        createAnalyticsEvent,
        addCommentInCache,
        handleCacheMiss,
        createObjectCommentMutationFn,
        experienceTracker,
        isReactionsEnabled,
        pageId,
        pageMode,
        pageType,
        userId,
        displayName
    ]);
    const commentEditorCommentType = commentType === (0, $kgNLQ.CommentType).GENERAL ? 'page' : commentType;
    const commentEditorPageMode = pageMode === 'edit' ? 'edit' : 'view';
    const editorContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        id: replyEditorContainerId,
        testId: replyEditorContainerId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        content: (0, $7qvmT.getReplyEditorContent)({
            replyToCommentUser: replyToCommentUser,
            replyToContributorUsers: replyToContributorUsers
        }),
        appearance: "comment",
        EditorComponent: (0, $g8bbY.CommentEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        onEditorReady: onEditorReady,
        commentMode: "reply",
        commentType: commentEditorCommentType,
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: true,
        pageMode: commentEditorPageMode,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        topLevelCommentId: parentComment.id,
        shouldWarnOnInternalNavigation: true,
        onCancelComment: handleCancelComment,
        isCommentsPanel: false,
        isFooterComment: true,
        isOffline: isOffline
    }));
    if (!replyToCommentId) return null;
    return editorContainer;
});


'use no memo';
const $535a8f2c4921cd54$var$replyBoxStyles = null;
const $535a8f2c4921cd54$var$objectCommentWrapperStyles = null;
const $535a8f2c4921cd54$var$nestedReplyThreadBoxStyles = null;
const $535a8f2c4921cd54$var$nestedReplyWithChildrenStyles = null;
const $535a8f2c4921cd54$var$topLevelReplyThreadBoxStyles = null;
const $535a8f2c4921cd54$var$withLeftBorderStyle = null;
const $535a8f2c4921cd54$var$withLeftBorderStyleUpdated = null;
const $535a8f2c4921cd54$var$withLeftBoxShadow = null; // Curved branch styles for connecting replies
const $535a8f2c4921cd54$var$replyBranchStyles = null;
const $535a8f2c4921cd54$var$replyBranchStylesUpdated = null;
const $535a8f2c4921cd54$var$i18n = (0, $kSwu1.defineMessages)({
    replyAriaLabel: {
        id: "object-comments.reply.aria-label",
        defaultMessage: "Reply by {authorName}, {timestamp}"
    }
});
const $535a8f2c4921cd54$export$4c583da0a4f30f74 = ({ parentReplyId: parentReplyId, parentToRepliesMap: parentToRepliesMap, canAddComments: canAddComments, pageInfo: pageInfo, pageMode: pageMode, threadKey: threadKey, supportedTopLevelActions: supportedTopLevelActions, isTopLevelReply: isTopLevelReply, parentComment: parentComment, parentReplyButtonAllowed: parentReplyButtonAllowed, setReplyView: setReplyView, isOffline: isOffline, flags: flags, isEditorExpanded: isEditorExpanded, setReplyContainerRef: setReplyContainerRef })=>{
    const { replyToCommentId: replyToCommentId, location: location, footerEditCommentIds: footerEditCommentIds } = (0, $3mVfX.useCommentsPanelState)();
    const { hasNestedComments: hasNestedComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl; // A reply renders its agent-session status (AvatarWithActionButton) below itself. Read the
    // page's agent-session map so we can keep the thread's connector line visible for such a
    // reply (mirrors ObjectCommentThread's parentHasAgentSession for the top-level comment) —
    // otherwise the status floats with no line when the reply is the last in the thread.
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const isParentCommentOpen = parentComment.isOpen;
    const repliesToRender = parentToRepliesMap[parentReplyId];
    const optimisticSessions = (0, $4ywyi.useOptimisticCommentAgentSessions)(repliesToRender.map((reply)=>reply.id));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testId": "footer-reply-container",
        role: "list",
        className: (0, $hekY6.default)([
            isTopLevelReply ? "_3iDTPbQ4SZ _0aFT5vbt8w" : "_3iDTPbQ4SZ _0aFT5vbt8w _2XsHFM5zaO"
        ])
    }, repliesToRender.map((reply_0, idx)=>{
        // These all control the visibility of the reply editor and left border
        // Generally speaking, we want to show the left border at the thread level rather than from comment body (showLeftBorder)
        // However, if one of the comment's will not have a left border (for example, if it's the last reply), we need to show at the comment level (!hideBranchingStyle)
        const replyHasChildren = parentToRepliesMap[reply_0.id]?.length > 0;
        const isLastReply = idx === repliesToRender.length - 1;
        const isFooterReplyMatchingReplyToCommentParameter = reply_0.id === replyToCommentId && location === (0, $i6UMJ.LocationValue).FOOTER;
        const showReplyEditor = hasNestedComments && isFooterReplyMatchingReplyToCommentParameter;
        const parentReplyButtonVisible = parentReplyButtonAllowed && isTopLevelReply; // This reply renders an agent-session status row below it; used to keep the connector
        // line visible. Gate inlined, ordered last per feature-gating rules.
        const replyHasAgentSession = (Boolean(agentSessions.get(reply_0.id)) || optimisticSessions.has(reply_0.id)) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true);
        const replyHasNestedObjects = replyHasChildren || showReplyEditor; // The agent status row adds height below the reply that the thread's connector line
        // must span. Treat it like a nested object for the BORDER only (not the body margin
        // `replyHasNestedObjects`, which would shift layout) — otherwise the line breaks
        // between this reply's status row and the next reply.
        const replyHasNestedObjectsOrAgent = replyHasNestedObjects || replyHasAgentSession;
        const replyIsBeingEdited = footerEditCommentIds?.has(reply_0.id);
        const showLeftBorder = parentReplyButtonVisible || replyHasNestedObjectsOrAgent && !isLastReply || replyIsBeingEdited && !isLastReply; // Keep the connector line visible when the reply has an agent session, even when it is
        // the last reply (where branching is normally hidden), so the status row stays attached.
        const hideBranchingStyle = !replyHasAgentSession && isLastReply && (!isTopLevelReply || !isEditorExpanded); // This accounts for the 1px missing border offset of the last reply in a deeply nested thread
        const isLastNestedFooterReply = isLastReply && !isTopLevelReply; // Register replies at every nesting level so a newly revealed reply can receive focus.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: setReplyContainerRef ? (replyContainer)=>setReplyContainerRef(reply_0.id, replyContainer) : undefined,
            // is enabled, is the fake optimistic id first and then gets updated to the actual
            // new comment id after mutation succeeds.
            // When mutation succeeds, DOM tree is updated. If `key` stays the same, the update
            // is recognized as multiple individual "mutation:attribute" for known attributes
            // excluded from VC calculation (e.g. data-testid); if key changes, the update is
            // recognized as a replacement of the entire element tree and counted in VC.
            // Unlike `reply.id`, `idx` is stable as long as the reply's position in the list
            // does not change.
            key: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-replies-${idx}`,
            id: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${reply_0.id}-replies`,
            "data-testid": `comment-thread-${parentReplyId}-replies-${reply_0.id}`,
            role: "listitem",
            "aria-label": formatMessage($535a8f2c4921cd54$var$i18n.replyAriaLabel, {
                authorName: reply_0.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
                timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                    intl: intl,
                    dateString: reply_0.createdAtNonLocalized,
                    isReply: true
                })
            }),
            className: (0, $hekY6.default)([
                "_1LMyvKYbGa _1mT5xdRAKS _2Zuz6Q5zaO",
                "_1mT5xdRAKS _00byCDs6Tv _0iE3lMs6Tv _3Ku51Iogpp _3dCYwDWVPG _1L3m71dnbC _35I30BdnbC _3ScelFSIel _1lBcDcoWWg _11usGT8fU6 _2DsrY12Njc",
                (0, $9wGTI.fg)('confluence_comment_border_migration') && "_00byCDovc1 _0iE3lMovc1",
                showLeftBorder && replyHasNestedObjectsOrAgent && (!isLastReply || isLastReply && isEditorExpanded) && "_2OUyjtK7sX",
                replyIsBeingEdited && !isLastReply && "_2OUyjtK7sX"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                !replyIsBeingEdited && "_1wydGW2ADO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
            comment: reply_0,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(reply_0.id),
            threadKey: threadKey,
            hideBranchingStyle: hideBranchingStyle,
            adjustForNestedReplies: false,
            canAddComments: canAddComments,
            isParentCommentOpen: isParentCommentOpen,
            adjustForFooterNestedReplies: false,
            topLevelParentCommentId: parentComment.id,
            commentHasChildren: replyHasChildren,
            isLastNestedFooterReply: isLastNestedFooterReply,
            flags: flags,
            showRepliesWithCurvedBorders: false,
            replyHasNestedObjects: replyHasNestedObjects
        })), showReplyEditor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5vbt8w _2XsHFM5zaO",
                replyHasChildren && "_3Jzbaes6Tv",
                replyHasChildren && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                (0, $9wGTI.fg)('confluence_comment_border_migration') && "_3Jzbaeovc1",
                replyHasChildren && "_2Zuz6QkG2W"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
            pageInfo: pageInfo,
            pageMode: pageMode,
            setReplyView: setReplyView,
            parentComment: parentComment,
            threadKey: threadKey,
            replyToId: reply_0.id,
            isOffline: isOffline
        })), parentToRepliesMap[reply_0.id]?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($535a8f2c4921cd54$export$4c583da0a4f30f74, {
            parentReplyId: reply_0.id,
            parentToRepliesMap: parentToRepliesMap,
            canAddComments: canAddComments,
            pageInfo: pageInfo,
            pageMode: pageMode,
            threadKey: threadKey,
            supportedTopLevelActions: supportedTopLevelActions,
            isTopLevelReply: false,
            parentComment: parentComment,
            parentReplyButtonAllowed: false,
            setReplyView: setReplyView,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded,
            setReplyContainerRef: setReplyContainerRef
        }));
    }));
};



const $b210b13432f2522a$export$55de1ed49e182c87 = (t0)=>{
    const $ = (0, $bDgLe.c)(101);
    const { parentComment: parentComment, pageInfo: pageInfo, pageMode: pageMode, parentCommentId: parentCommentId, canAddComments: canAddComments, isOffline: t1, flags: flags, isEditorExpanded: isEditorExpanded } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    let t2;
    if ($[0] !== parentComment.replies) {
        t2 = parentComment.replies.filter($b210b13432f2522a$var$_temp);
        $[0] = parentComment.replies;
        $[1] = t2;
    } else t2 = $[1];
    const allReplies = t2;
    const numOfReplies = allReplies.length;
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    let t3;
    if ($[2] !== allReplies || $[3] !== unreadCommentIDSet) {
        let t4;
        if ($[5] !== unreadCommentIDSet) {
            t4 = (r_0)=>unreadCommentIDSet.has(r_0.id);
            $[5] = unreadCommentIDSet;
            $[6] = t4;
        } else t4 = $[6];
        t3 = allReplies.filter(t4).map($b210b13432f2522a$var$_temp2);
        $[2] = allReplies;
        $[3] = unreadCommentIDSet;
        $[4] = t3;
    } else t3 = $[4];
    const unreadReplyIds = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[7] = t4;
    } else t4 = $[7];
    const [legacyVisibleReplies, setVisibleReplies] = (0, $cozmU.useState)(t4);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const commentType = parentComment.type;
    const isParentCommentOpen = parentComment.isOpen;
    const [currentReplyView, setReplyView] = (0, $cozmU.useState)((0, $ibqdE.ViewReplyOptions).ALL);
    const threadKey = commentType === (0, $kgNLQ.CommentType).INLINE ? (parentComment?.location).inlineMarkerRef || "" : parentCommentId;
    let t5;
    if ($[8] !== isParentCommentOpen) {
        t5 = isParentCommentOpen ? [
            "edit",
            "resolve",
            "delete"
        ] : [
            "reopen"
        ];
        $[8] = isParentCommentOpen;
        $[9] = t5;
    } else t5 = $[9];
    const supportedTopLevelActions = t5;
    const expandReplyEditor = isEditorExpanded;
    let topLevelReplyToNestedChildrenMapInternal;
    if ($[10] !== allReplies || $[11] !== parentCommentId) {
        let t6;
        if ($[13] !== parentCommentId) {
            t6 = (reply)=>reply.parentId === parentCommentId;
            $[13] = parentCommentId;
            $[14] = t6;
        } else t6 = $[14];
        const topLevelReplyIds = new Set(allReplies.filter(t6).map($b210b13432f2522a$var$_temp3));
        topLevelReplyToNestedChildrenMapInternal = Array.from(topLevelReplyIds).reduce($b210b13432f2522a$var$_temp4, {});
        const replyIdToReplyMap = allReplies.reduce($b210b13432f2522a$var$_temp5, {});
        const filteredReplies = allReplies.filter((reply_2)=>!topLevelReplyIds.has(reply_2.id));
        for (const filteredReply of filteredReplies){
            let replyParentId = filteredReply.parentId;
            let circuitBreaker = 0;
            while(replyParentId && circuitBreaker < 100 && !topLevelReplyIds.has(replyParentId)){
                replyParentId = replyIdToReplyMap[replyParentId]?.parentId;
                circuitBreaker++;
            }
            if (replyParentId && replyParentId in topLevelReplyToNestedChildrenMapInternal) topLevelReplyToNestedChildrenMapInternal[replyParentId].push(filteredReply);
        }
        $[10] = allReplies;
        $[11] = parentCommentId;
        $[12] = topLevelReplyToNestedChildrenMapInternal;
    } else topLevelReplyToNestedChildrenMapInternal = $[12];
    const topLevelReplyToNestedChildrenMap = topLevelReplyToNestedChildrenMapInternal;
    let replies;
    if ($[15] !== allReplies || $[16] !== topLevelReplyToNestedChildrenMap) {
        replies = [];
        let t6;
        if ($[18] !== topLevelReplyToNestedChildrenMap) {
            t6 = (reply_3)=>reply_3.id in topLevelReplyToNestedChildrenMap;
            $[18] = topLevelReplyToNestedChildrenMap;
            $[19] = t6;
        } else t6 = $[19];
        const topLevelReplies = allReplies.filter(t6);
        topLevelReplies.sort($b210b13432f2522a$var$_temp6);
        for(let i = 0; i < (0, $ibqdE.DEFAULT_NUM_VISIBLE_REPLIES); i++)if (topLevelReplies.length > 0) {
            const reply_4 = topLevelReplies.pop();
            if (reply_4) replies.unshift(reply_4);
        }
        $[15] = allReplies;
        $[16] = topLevelReplyToNestedChildrenMap;
        $[17] = replies;
    } else replies = $[17];
    const latestReplies = replies;
    let latestAndNestedReplyIds;
    if ($[20] !== latestReplies || $[21] !== topLevelReplyToNestedChildrenMap) {
        latestAndNestedReplyIds = new Set();
        for (const reply_5 of latestReplies){
            latestAndNestedReplyIds.add(reply_5.id);
            for (const nestedReply of topLevelReplyToNestedChildrenMap[reply_5.id])latestAndNestedReplyIds.add(nestedReply.id);
        }
        $[20] = latestReplies;
        $[21] = topLevelReplyToNestedChildrenMap;
        $[22] = latestAndNestedReplyIds;
    } else latestAndNestedReplyIds = $[22];
    const latestReplyIds = latestAndNestedReplyIds;
    let parentToRepliesMapInternal;
    if ($[23] !== allReplies || $[24] !== parentCommentId) {
        parentToRepliesMapInternal = {
            [parentCommentId]: [],
            ...allReplies.reduce($b210b13432f2522a$var$_temp7, {})
        };
        for (const reply_7 of allReplies)if (reply_7.parentId && reply_7.parentId in parentToRepliesMapInternal) parentToRepliesMapInternal[reply_7.parentId].push(reply_7);
        $[23] = allReplies;
        $[24] = parentCommentId;
        $[25] = parentToRepliesMapInternal;
    } else parentToRepliesMapInternal = $[25];
    const parentToRepliesMap = parentToRepliesMapInternal;
    let t6;
    if ($[26] !== allReplies || $[27] !== currentReplyView || $[28] !== isParentCommentOpen || $[29] !== latestReplies || $[30] !== parentCommentId) {
        t6 = {
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            parentCommentId: parentCommentId,
            setVisibleReplies: setVisibleReplies,
            allowNestedReplies: true
        };
        $[26] = allReplies;
        $[27] = currentReplyView;
        $[28] = isParentCommentOpen;
        $[29] = latestReplies;
        $[30] = parentCommentId;
        $[31] = t6;
    } else t6 = $[31];
    (0, $8gR6k.useUpdateVisibleReplies)(t6);
    let t7;
    if ($[32] !== allReplies || $[33] !== currentReplyView || $[34] !== isParentCommentOpen || $[35] !== latestReplies || $[36] !== parentCommentId) {
        t7 = {
            allReplies: allReplies,
            isParentCommentOpen: isParentCommentOpen,
            currentReplyView: currentReplyView,
            latestReplies: latestReplies,
            parentCommentId: parentCommentId,
            allowNestedReplies: true
        };
        $[32] = allReplies;
        $[33] = currentReplyView;
        $[34] = isParentCommentOpen;
        $[35] = latestReplies;
        $[36] = parentCommentId;
        $[37] = t7;
    } else t7 = $[37];
    const derivedVisibleReplies = (0, $jVIRU.useVisibleReplies)(t7);
    let t8;
    if ($[38] !== derivedVisibleReplies || $[39] !== legacyVisibleReplies) {
        t8 = (0, $6mKj3.expValEquals)("confluence_fe_ssr_top_footer_comments", "isEnabled", true) ? derivedVisibleReplies : legacyVisibleReplies;
        $[38] = derivedVisibleReplies;
        $[39] = legacyVisibleReplies;
        $[40] = t8;
    } else t8 = $[40];
    const visibleReplies = t8;
    const { requestFocusOnRevealedReply: requestFocusOnRevealedReply, requestFocusOnShowReplies: requestFocusOnShowReplies, setReplyContainerRef: setReplyContainerRef, showRepliesButtonRef: showRepliesButtonRef } = (0, $enWGp.useReplyFocusRestoration)(visibleReplies);
    let t9;
    if ($[41] !== hasContentChanged || $[42] !== parentCommentId || $[43] !== resetContentChanged || $[44] !== setReplyToCommentId || $[45] !== showModal) {
        t9 = ()=>{
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    setReplyToCommentId({
                        parentCommentId: parentCommentId,
                        location: (0, $i6UMJ.LocationValue).FOOTER
                    });
                }
            });
            else setReplyToCommentId({
                parentCommentId: parentCommentId,
                location: (0, $i6UMJ.LocationValue).FOOTER
            });
        };
        $[41] = hasContentChanged;
        $[42] = parentCommentId;
        $[43] = resetContentChanged;
        $[44] = setReplyToCommentId;
        $[45] = showModal;
        $[46] = t9;
    } else t9 = $[46];
    const handleReplyButtonClick = t9;
    const canShowReplyButton = isParentCommentOpen && canAddComments;
    let t10;
    if ($[47] !== allReplies || $[48] !== canAddComments || $[49] !== commentType || $[50] !== currentReplyView || $[51] !== expandReplyEditor || $[52] !== isParentCommentOpen || $[53] !== latestReplyIds || $[54] !== requestFocusOnRevealedReply || $[55] !== showRepliesButtonRef || $[56] !== unreadReplyIds) {
        t10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58Zuw.RepliesToggler), {
                replies: allReplies,
                unreadReplyIds: unreadReplyIds,
                setReplyView: setReplyView,
                currentReplyView: currentReplyView,
                commentType: commentType,
                isParentOpen: isParentCommentOpen,
                canAddComments: canAddComments,
                latestReplyIds: latestReplyIds,
                analyticsSource: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                expandReplyEditor: expandReplyEditor,
                showRepliesButtonRef: showRepliesButtonRef,
                onShowHiddenReplies: requestFocusOnRevealedReply
            });
        $[47] = allReplies;
        $[48] = canAddComments;
        $[49] = commentType;
        $[50] = currentReplyView;
        $[51] = expandReplyEditor;
        $[52] = isParentCommentOpen;
        $[53] = latestReplyIds;
        $[54] = requestFocusOnRevealedReply;
        $[55] = showRepliesButtonRef;
        $[56] = unreadReplyIds;
        $[57] = t10;
    } else t10 = $[57];
    const renderRepliesToggler = t10;
    let t11;
    if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            display: "flex",
            flexDirection: "column",
            paddingLeft: "var(--ds-space-150, 12px)",
            paddingRight: "var(--ds-space-100, 8px)"
        };
        $[58] = t11;
    } else t11 = $[58];
    const repliesBoxStyle = t11;
    let t12;
    if ($[59] !== numOfReplies || $[60] !== renderRepliesToggler) {
        t12 = numOfReplies > 0 && renderRepliesToggler();
        $[59] = numOfReplies;
        $[60] = renderRepliesToggler;
        $[61] = t12;
    } else t12 = $[61];
    const t13 = `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-replies`;
    let t14;
    if ($[62] !== canAddComments || $[63] !== canShowReplyButton || $[64] !== flags || $[65] !== isEditorExpanded || $[66] !== isOffline || $[67] !== pageInfo || $[68] !== pageMode || $[69] !== parentComment || $[70] !== parentCommentId || $[71] !== parentToRepliesMap || $[72] !== setReplyContainerRef || $[73] !== supportedTopLevelActions || $[74] !== threadKey || $[75] !== visibleReplies.length) {
        t14 = visibleReplies.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $535a8f2c4921cd54$export$4c583da0a4f30f74), {
            parentReplyId: parentCommentId,
            parentToRepliesMap: parentToRepliesMap,
            canAddComments: canAddComments,
            pageInfo: pageInfo,
            pageMode: pageMode,
            threadKey: threadKey,
            supportedTopLevelActions: supportedTopLevelActions,
            isTopLevelReply: true,
            parentComment: parentComment,
            parentReplyButtonAllowed: canShowReplyButton,
            setReplyView: setReplyView,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded,
            setReplyContainerRef: setReplyContainerRef
        });
        $[62] = canAddComments;
        $[63] = canShowReplyButton;
        $[64] = flags;
        $[65] = isEditorExpanded;
        $[66] = isOffline;
        $[67] = pageInfo;
        $[68] = pageMode;
        $[69] = parentComment;
        $[70] = parentCommentId;
        $[71] = parentToRepliesMap;
        $[72] = setReplyContainerRef;
        $[73] = supportedTopLevelActions;
        $[74] = threadKey;
        $[75] = visibleReplies.length;
        $[76] = t14;
    } else t14 = $[76];
    const t15 = visibleReplies ? visibleReplies.length : 0;
    let t16;
    if ($[77] !== isOffline || $[78] !== pageInfo || $[79] !== pageMode || $[80] !== parentComment || $[81] !== parentCommentId || $[82] !== threadKey) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c5ea6bb1ec976c9$export$25e4139e54938aaf), {
            pageInfo: pageInfo,
            pageMode: pageMode,
            setReplyView: setReplyView,
            parentComment: parentComment,
            threadKey: threadKey,
            replyToId: parentCommentId,
            isOffline: isOffline
        });
        $[77] = isOffline;
        $[78] = pageInfo;
        $[79] = pageMode;
        $[80] = parentComment;
        $[81] = parentCommentId;
        $[82] = threadKey;
        $[83] = t16;
    } else t16 = $[83];
    let t17;
    if ($[84] !== currentReplyView || $[85] !== handleReplyButtonClick || $[86] !== isEditorExpanded || $[87] !== isOffline || $[88] !== isParentCommentOpen || $[89] !== parentCommentId || $[90] !== requestFocusOnShowReplies || $[91] !== t15 || $[92] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLpk8.RepliesFooter), {
            replyView: currentReplyView,
            setReplyView: setReplyView,
            isEditorExpanded: isEditorExpanded,
            isParentCommentOpen: isParentCommentOpen,
            requestFocusOnShowReplies: requestFocusOnShowReplies,
            handleReplyButtonClick: handleReplyButtonClick,
            numOfVisibleReplies: t15,
            isOffline: isOffline,
            scrollToId: parentCommentId,
            location: (0, $i6UMJ.LocationValue).FOOTER
        }, t16);
        $[84] = currentReplyView;
        $[85] = handleReplyButtonClick;
        $[86] = isEditorExpanded;
        $[87] = isOffline;
        $[88] = isParentCommentOpen;
        $[89] = parentCommentId;
        $[90] = requestFocusOnShowReplies;
        $[91] = t15;
        $[92] = t16;
        $[93] = t17;
    } else t17 = $[93];
    let t18;
    if ($[94] !== t13 || $[95] !== t14 || $[96] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": t13,
            style: repliesBoxStyle
        }, t14, t17);
        $[94] = t13;
        $[95] = t14;
        $[96] = t17;
        $[97] = t18;
    } else t18 = $[97];
    let t19;
    if ($[98] !== t12 || $[99] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, t18);
        $[98] = t12;
        $[99] = t18;
        $[100] = t19;
    } else t19 = $[100];
    return t19;
};
function $b210b13432f2522a$var$_temp(r) {
    return r !== null;
}
function $b210b13432f2522a$var$_temp2(r_1) {
    return r_1.id;
}
function $b210b13432f2522a$var$_temp3(reply_0) {
    return reply_0.id;
}
function $b210b13432f2522a$var$_temp4(acc, replyId) {
    acc[replyId] = [];
    return acc;
}
function $b210b13432f2522a$var$_temp5(acc_0, reply_1) {
    acc_0[reply_1.id] = reply_1;
    return acc_0;
}
function $b210b13432f2522a$var$_temp6(a, b) {
    const dateA = (0, $6faGq.getValidDate)(a?.createdAtNonLocalized);
    const dateB = (0, $6faGq.getValidDate)(b?.createdAtNonLocalized);
    return dateA.getTime() - dateB.getTime();
}
function $b210b13432f2522a$var$_temp7(acc_1, reply_6) {
    return {
        ...acc_1,
        [reply_6.id]: []
    };
}


const $e368ed9f3d927a75$var$commentThreadBoxStyles = (0, $buxP3.xcss)({
    listStyle: 'none',
    position: 'relative',
    paddingLeft: 'space.200',
    paddingRight: 'space.250',
    paddingTop: 'space.100',
    // On figma this is 200 but the object comment have 100px padding on top
    paddingBottom: 'space.200',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    // Focus styles with outline - better containment
    ':focus': {
        outlineOffset: 'space.negative.025'
    },
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    }
});
const $e368ed9f3d927a75$var$newCommentThreadBoxStyles = (0, $buxP3.xcss)({
    cursor: 'pointer'
});
const $e368ed9f3d927a75$var$commentTypeSeperatorStyle = (0, $buxP3.xcss)({
    display: 'flex',
    gap: 'space.050',
    paddingTop: 'space.300',
    paddingRight: 'space.300',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $e368ed9f3d927a75$var$commentBodyBoxStyles = (0, $buxP3.xcss)({
    listStyle: 'none',
    position: 'relative',
    marginRight: 'space.100'
});
const $e368ed9f3d927a75$var$isCurrentUserSelectedCommentStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $e368ed9f3d927a75$var$isThreadPressedStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input-hovered, #F8F8F8)"
});
const $e368ed9f3d927a75$var$i18n = (0, $kSwu1.defineMessages)({
    commentTypeSeperatorText: {
        id: "object-comments.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        id: "object-comments.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread"
    }
});
const $e368ed9f3d927a75$export$2ea19076574587a9 = (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { parentComment: parentComment, supportedTopLevelActions: supportedTopLevelActions, pageMode: pageMode, flags: flags, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, isLastThread: isLastThread, onLastThreadRendered: onLastThreadRendered, isOffline: isOffline } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t1, t2] = (0, $3mVfX.useCommentsPanel)();
    const { currentlySelectedThreadKey: currentlySelectedThreadKey, isCurrentlySelectedThreadOptimisticallyAdded: isCurrentlySelectedThreadOptimisticallyAdded } = t1;
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = t2;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const threadKey = parentComment.id;
    const agentSessions = (0, $6FXhW.useAgentSessionsContext)();
    let t3;
    if ($[0] !== parentComment.id) {
        t3 = [
            parentComment.id
        ];
        $[0] = parentComment.id;
        $[1] = t3;
    } else t3 = $[1];
    const optimisticSessions = (0, $4ywyi.useOptimisticCommentAgentSessions)(t3);
    let t4;
    if ($[2] !== agentSessions || $[3] !== optimisticSessions || $[4] !== parentComment.id) {
        t4 = (Boolean(agentSessions.get(parentComment.id)) || optimisticSessions.has(parentComment.id)) && (0, $6mKj3.expValEquals)("cc_ai_agent_mention_from_comment", "isEnabled", true);
        $[2] = agentSessions;
        $[3] = optimisticSessions;
        $[4] = parentComment.id;
        $[5] = t4;
    } else t4 = $[5];
    const parentHasAgentSession = t4;
    const [isThreadPressed, setIsThreadPressed] = (0, $cozmU.useState)(false);
    const isEditorExpanded = (0, $7wP5b.useIsEditorExpanded)(parentComment, (0, $i6UMJ.LocationValue).FOOTER);
    const commentRef = (0, $cozmU.useRef)(null);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey || parentComment.type === (0, $kgNLQ.CommentType).GENERAL && !!isCurrentlySelectedThreadOptimisticallyAdded && threadKey === (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID);
    const { canAddComments: conversationCanAddComments } = (0, $90hCa.useViewPageConversationData)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageInfo?.id ?? "", true, conversationCanAddComments);
    let t5;
    if ($[6] !== isCurrentSelectedComment || $[7] !== setCurrentlySelectedThreadKey || $[8] !== threadKey) {
        t5 = ()=>{
            if (!isCurrentSelectedComment) {
                if (!(0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true)) setIsThreadPressed(true);
                setCurrentlySelectedThreadKey(threadKey);
            }
        };
        $[6] = isCurrentSelectedComment;
        $[7] = setCurrentlySelectedThreadKey;
        $[8] = threadKey;
        $[9] = t5;
    } else t5 = $[9];
    const handleCommentThreadMouseDown = t5;
    let t6;
    if ($[10] !== currentlySelectedThreadKey || $[11] !== isCurrentSelectedComment || $[12] !== parentComment.replies) {
        t6 = ()=>{
            if (!(0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true)) {
                const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply?.id === currentlySelectedThreadKey);
                if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
                else setIsThreadPressed(false);
            }
        };
        $[10] = currentlySelectedThreadKey;
        $[11] = isCurrentSelectedComment;
        $[12] = parentComment.replies;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = parentComment?.replies;
    let t8;
    if ($[14] !== currentlySelectedThreadKey || $[15] !== isCurrentSelectedComment || $[16] !== t7) {
        t8 = [
            currentlySelectedThreadKey,
            isCurrentSelectedComment,
            t7
        ];
        $[14] = currentlySelectedThreadKey;
        $[15] = isCurrentSelectedComment;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    (0, $cozmU.useEffect)(t6, t8);
    let t10;
    let t9;
    if ($[18] !== isLastThread || $[19] !== onLastThreadRendered) {
        t9 = ()=>{
            if (isLastThread && onLastThreadRendered) {
                if (typeof isLastThread === "boolean") onLastThreadRendered();
            }
        };
        t10 = [
            isLastThread,
            onLastThreadRendered
        ];
        $[18] = isLastThread;
        $[19] = onLastThreadRendered;
        $[20] = t10;
        $[21] = t9;
    } else {
        t10 = $[20];
        t9 = $[21];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[22] !== isCommentsPanelShown || $[23] !== setCurrentlySelectedThreadKey || $[24] !== threadKey) {
        t11 = ()=>{
            setCurrentlySelectedThreadKey(threadKey);
            if (isCommentsPanelShown) (0, $9FoVw.handleCommentsPanelNavigation)({
                annotationId: threadKey,
                commentType: "FOOTER",
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: "center",
                context: (0, $9FoVw.NavigationContext).PANEL
            });
        };
        $[22] = isCommentsPanelShown;
        $[23] = setCurrentlySelectedThreadKey;
        $[24] = threadKey;
        $[25] = t11;
    } else t11 = $[25];
    const objectCommentThreadHandler = t11;
    let t12;
    if ($[26] !== flags || $[27] !== isOffline || $[28] !== supportedTopLevelActions) {
        t12 = (t13)=>{
            const { comment: comment, ...props } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
                ...props,
                comment: comment,
                supportedTopLevelActions: supportedTopLevelActions,
                flags: flags,
                isOffline: isOffline
            });
        };
        $[26] = flags;
        $[27] = isOffline;
        $[28] = supportedTopLevelActions;
        $[29] = t12;
    } else t12 = $[29];
    const commentComponent = t12;
    let t13;
    if ($[30] !== flags || $[31] !== isOffline) {
        t13 = (t14)=>{
            const { parentComment: comment_0, ...props_0 } = t14;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b210b13432f2522a$export$55de1ed49e182c87), {
                ...props_0,
                parentComment: comment_0,
                isOffline: isOffline,
                flags: flags
            });
        };
        $[30] = flags;
        $[31] = isOffline;
        $[32] = t13;
    } else t13 = $[32];
    const commentRepliesComponent = t13;
    let t14;
    if ($[33] !== canAddComments || $[34] !== commentComponent || $[35] !== commentRepliesComponent || $[36] !== flags || $[37] !== formatMessage || $[38] !== handleCommentThreadMouseDown || $[39] !== isCurrentSelectedComment || $[40] !== isEditorExpanded || $[41] !== isOffline || $[42] !== isThreadPressed || $[43] !== objectCommentThreadHandler || $[44] !== pageInfo || $[45] !== pageMode || $[46] !== parentComment || $[47] !== parentHasAgentSession || $[48] !== shouldRenderCommentTypeSeparator || $[49] !== supportedTopLevelActions || $[50] !== threadKey || $[51] !== unreadCommentIDSet) {
        t14 = (0, $6mKj3.expValEquals)("cc_comments_common_refactor", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i8TeS.BaseCommentThread), {
            commentThreadRef: commentRef,
            commentComponent: commentComponent,
            commentRepliesComponent: commentRepliesComponent,
            parentComment: parentComment,
            pageMode: pageMode,
            shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator,
            canAddComments: canAddComments,
            handleCommentThreadClick: objectCommentThreadHandler,
            handleCommentThreadMouseDown: handleCommentThreadMouseDown,
            testIdPrefix: (0, $i6UMJ.LocationValue).FOOTER,
            isEditorExpanded: isEditorExpanded,
            parentHasAgentSession: parentHasAgentSession
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $e368ed9f3d927a75$var$commentTypeSeperatorStyle,
            testId: "comment-section-separator",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            testId: "general-comment-page-icon",
            color: "var(--ds-icon-subtlest, #6B6E76)",
            label: formatMessage($e368ed9f3d927a75$var$i18n.commentTypeSeperatorText)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            color: "color.text.subtlest",
            weight: "medium"
        }, formatMessage($e368ed9f3d927a75$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ref: commentRef,
            id: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${threadKey}-container`,
            testId: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${threadKey}-container`,
            xcss: [
                $e368ed9f3d927a75$var$commentThreadBoxStyles,
                isCurrentSelectedComment && $e368ed9f3d927a75$var$isCurrentUserSelectedCommentStyles,
                !isCurrentSelectedComment && isThreadPressed && $e368ed9f3d927a75$var$isThreadPressedStyles,
                $e368ed9f3d927a75$var$newCommentThreadBoxStyles
            ],
            onClick: objectCommentThreadHandler,
            onMouseDown: handleCommentThreadMouseDown,
            onMouseUp: ()=>setIsThreadPressed(false),
            tabIndex: 0,
            "aria-label": formatMessage($e368ed9f3d927a75$var$i18n.threadContentAriaLabelWithName, {
                name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: `${(0, $i6UMJ.LocationValue).FOOTER}-comment-thread-${parentComment.id}-parent`,
            xcss: $e368ed9f3d927a75$var$commentBodyBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $972174ea64671f70$export$f8aa7c43d6421d1d), {
            comment: parentComment,
            supportedTopLevelActions: supportedTopLevelActions,
            pageInfo: pageInfo,
            pageMode: pageMode,
            isUnread: unreadCommentIDSet.has(parentComment.id),
            threadKey: threadKey,
            flags: flags,
            hideBranchingStyle: !parentHasAgentSession && parentComment.replies.length === 0 && !isEditorExpanded,
            canAddComments: canAddComments,
            isOffline: isOffline
        })), (0, $ibqdE.getShouldShowRepliesSection)({
            replies: parentComment.replies,
            isEditorExpanded: isEditorExpanded
        }) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b210b13432f2522a$export$55de1ed49e182c87), {
            parentComment: parentComment,
            pageInfo: pageInfo,
            pageMode: pageMode,
            parentCommentId: parentComment.id,
            canAddComments: canAddComments,
            isOffline: isOffline,
            flags: flags,
            isEditorExpanded: isEditorExpanded
        })));
        $[33] = canAddComments;
        $[34] = commentComponent;
        $[35] = commentRepliesComponent;
        $[36] = flags;
        $[37] = formatMessage;
        $[38] = handleCommentThreadMouseDown;
        $[39] = isCurrentSelectedComment;
        $[40] = isEditorExpanded;
        $[41] = isOffline;
        $[42] = isThreadPressed;
        $[43] = objectCommentThreadHandler;
        $[44] = pageInfo;
        $[45] = pageMode;
        $[46] = parentComment;
        $[47] = parentHasAgentSession;
        $[48] = shouldRenderCommentTypeSeparator;
        $[49] = supportedTopLevelActions;
        $[50] = threadKey;
        $[51] = unreadCommentIDSet;
        $[52] = t14;
    } else t14 = $[52];
    return t14;
};


const $fd40026d890a9ac0$var$listStyles = null; // this component holds a list of comments
const $fd40026d890a9ac0$export$b05be82c52775010 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { commentThreads: commentThreads, supportedTopLevelActions: supportedTopLevelActions, flags: flags, onAllCommentsRendered: onAllCommentsRendered, onCommentBatchRendered: onCommentBatchRendered, isOffline: isOffline } = t0;
    let t1;
    if ($[0] !== commentThreads) {
        t1 = (index)=>index === commentThreads.length - 1;
        $[0] = commentThreads;
        $[1] = t1;
    } else t1 = $[1];
    const isLastThread = t1;
    let t2;
    if ($[2] !== flags || $[3] !== isLastThread || $[4] !== isOffline || $[5] !== onAllCommentsRendered || $[6] !== onCommentBatchRendered || $[7] !== supportedTopLevelActions) {
        t2 = {
            supportedTopLevelActions: supportedTopLevelActions,
            flags: flags,
            onLastThreadRendered: onAllCommentsRendered,
            onCommentBatchRendered: onCommentBatchRendered,
            isLastThread: isLastThread,
            isOffline: isOffline
        };
        $[2] = flags;
        $[3] = isLastThread;
        $[4] = isOffline;
        $[5] = onAllCommentsRendered;
        $[6] = onCommentBatchRendered;
        $[7] = supportedTopLevelActions;
        $[8] = t2;
    } else t2 = $[8];
    const passThroughProps = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_2WAcuGYvD1 _4bt5LAYvD1 _2O5Vij7dHp _3iDTPbvLZJ"
        ]);
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== commentThreads || $[11] !== passThroughProps) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "object-comments-list-container",
            "data-testid": "object-comments-list-container",
            className: t3
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3cu4A.CommentBatchList), {
            commentsList: commentThreads,
            passThroughProps: passThroughProps,
            Component: (0, $e368ed9f3d927a75$export$2ea19076574587a9),
            getElementsToBatch: (0, $7qvmT.getCommentThreadsToBatch)
        }));
        $[10] = commentThreads;
        $[11] = passThroughProps;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
};


















var $I7hWB = parcelRequire("I7hWB");





const $f06f6da515cf7544$var$commentHeaderContainerStyles = (0, $buxP3.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    background: 'color.text.inverse',
    height: '64px',
    width: '100%',
    display: 'flex',
    padding: 'space.200',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch'
});
// Only reachable with the gate on — the "+N" toggle that drives `reactionsExpanded` only renders
// in the new footer layout — so gate-off always resolves to plain `commentHeaderContainerStyles`.
const $f06f6da515cf7544$var$commentHeaderContainerExpandedStyles = (0, $buxP3.xcss)({
    height: 'auto',
    flexDirection: 'column-reverse',
    alignItems: 'stretch',
    gap: 'space.100'
});
// Only applied with the gate on. The collapsed reactions row sizes itself to the pills that fit
// in the room beside the "Comments" heading, so the cluster must be allowed to shrink below its
// content size instead of overflowing the header.
const $f06f6da515cf7544$var$commentHeaderFitStyles = (0, $buxP3.xcss)({
    gap: 'space.200'
});
const $f06f6da515cf7544$var$commentHeaderReactionsContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    alignSelf: 'stretch'
});
const $f06f6da515cf7544$var$commentHeaderReactionsContainerFitStyles = (0, $buxP3.xcss)({
    flex: '0 1 auto',
    minWidth: '0px'
});
const $f06f6da515cf7544$var$i18n = (0, $kSwu1.defineMessages)({
    objectCommentHeaderText: {
        id: "object-comments.object-comment-header.text",
        defaultMessage: "Comments"
    }
});
const $f06f6da515cf7544$var$styles = {
    headerMessageStyle: "_2sNsIgWSk4 _1UtDYzZpcK _0WKd3GDG5a _1kk5Tkf7mX"
};
const $f06f6da515cf7544$export$32c2c28e641d3a4f = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { isOffline: t1, showReactions: showReactions } = t0;
    const isOffline = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [reactionsExpanded, setReactionsExpanded] = (0, $cozmU.useState)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_footer_reactions_redesign", "isEnabled", true) && $f06f6da515cf7544$var$commentHeaderFitStyles;
        $[0] = t2;
    } else t2 = $[0];
    const t3 = reactionsExpanded && $f06f6da515cf7544$var$commentHeaderContainerExpandedStyles;
    let t4;
    if ($[1] !== t3) {
        t4 = [
            $f06f6da515cf7544$var$commentHeaderContainerStyles,
            t2,
            t3
        ];
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== formatMessage) {
        t5 = formatMessage($f06f6da515cf7544$var$i18n.objectCommentHeaderText);
        $[3] = formatMessage;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $f06f6da515cf7544$var$styles.headerMessageStyle
        }, t5));
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== isOffline || $[8] !== showReactions) {
        t7 = showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: [
                $f06f6da515cf7544$var$commentHeaderReactionsContainerStyles,
                (0, $6mKj3.expValEquals)("confluence_footer_reactions_redesign", "isEnabled", true) && $f06f6da515cf7544$var$commentHeaderReactionsContainerFitStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c779d914e38fe28$export$3b5f3f6ec721f20a), {
            isOffline: isOffline,
            onExpandedChange: setReactionsExpanded
        }));
        $[7] = isOffline;
        $[8] = showReactions;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t4
        }, t6, t7);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
};












var $b4BfG = parcelRequire("b4BfG");





var $8Ss4E = parcelRequire("8Ss4E");


var $aJPUt = parcelRequire("aJPUt");














var $56QzY = parcelRequire("56QzY");









































var $gurMq = parcelRequire("gurMq");


var $4rKYp = parcelRequire("4rKYp");










const $2f75a8a3cc0f80c1$export$b65ed37f0eb1c56b = (0, $7aRa9.withFlags)(({ flags: flags, isOffline: isOffline, setAutoFocusPromptRef: setAutoFocusPromptRef, handleCancel: handleCancel })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setAddFooterCommentAdf: setAddFooterCommentAdf } = (0, $3mVfX.useCommentsPanelActions)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    });
    const hasShownFyiRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    // Ref to store editor actions for focusing when sticky draft is clicked
    const editorActionsRef = (0, $cozmU.useRef)(null);
    // Focus editor when opened from sticky draft (handles case when editor is already mounted)
    (0, $cozmU.useEffect)(()=>{
        if (footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT && editorActionsRef.current?.focus) editorActionsRef.current.focus();
    }, [
        footerEditorEntry
    ]);
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId || '',
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const createObjectCommentMutationFn = (0, $ag51I.useCreateObjectCommentMutation)();
    const clearAddFooterCommentAdf = (0, $cozmU.useCallback)(()=>{
        setAddFooterCommentAdf(undefined);
    }, [
        setAddFooterCommentAdf
    ]);
    const failPublishExperience = (0, $cozmU.useCallback)((error)=>{
        // Mark the experience as failed/aborted and include the error details
        experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const handleCacheMiss = (0, $cozmU.useCallback)((_error)=>{
        flags?.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).networkError)
        });
    }, [
        flags
    ]);
    const updateNewCommentInCache = (0, $cozmU.useCallback)((_dataProxy, mutationResult)=>{
        addCommentInCache({
            newComment: (0, $ag51I.addEmptyObjectRepliesAndReactions)(mutationResult.data.createFooterComment),
            onError: failPublishExperience,
            onCacheMiss: handleCacheMiss
        });
    }, [
        addCommentInCache,
        failPublishExperience,
        handleCacheMiss
    ]);
    const handleCommentsPanelSave = (adfObject, onSuccess)=>{
        const pageId = contentId || '';
        const { adf: adf } = adfObject;
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).EDITOR_PUBLISH
        });
        const mutationVariables = {
            cloudId: cloudId,
            input: {
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: (0, $ag51I.ADF_COMMENT_CONTENT_REPRESENTATION)
                },
                commentSource: (0, $ag51I.WEB_COMMENT_SOURCE),
                containerId: pageId
            }
        };
        const optimisticResponse = (0, $ag51I.getOptimisticResponse)({
            userId: userId ?? '',
            displayName: displayName ?? '',
            adf: adf,
            pageId: pageId,
            parentCommentId: null
        });
        const optimisticCommentId = optimisticResponse?.createFooterComment?.id;
        onSuccess && onSuccess();
        clearAddFooterCommentAdf();
        closeCommentContainer();
        // set the new comment as selected and scroll to it
        optimisticCommentId && setCurrentlySelectedThreadKey(optimisticCommentId, (0, $kgNLQ.CommentType).GENERAL);
        optimisticCommentId && (0, $9FoVw.handleFooterCommentsNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            inline: 'center',
            commentId: optimisticCommentId
        });
        const mutationPromise = createObjectCommentMutationFn({
            variables: {
                ...mutationVariables,
                pageId: pageId,
                includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
            },
            // @ts-ignore -- can't import type directly in update FN because it'd be circular
            update: updateNewCommentInCache,
            optimisticResponse: optimisticResponse
        });
        return mutationPromise.then(({ data: data })=>{
            const commentResult = data.createFooterComment;
            const comment = {
                ...commentResult,
                replies: [],
                // not included in the payload
                isOpen: true,
                type: (0, $kgNLQ.CommentType).GENERAL
            };
            resetContentChanged();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: comment.id,
                    // The newly created comment ID
                    objectType: contentType,
                    objectId: contentId,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    attributes: {
                        commentType: (0, $en1dX.CommentType).PAGE,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        pageMode: pageMode,
                        isReply: false,
                        pageType: contentType,
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        editor: 'v2',
                        searchSessionId: searchSessionId,
                        navdexPointType: (0, $56QzY.END),
                        parentCommentId: null,
                        // analytics event schema type expects string or null
                        isStickyFooter: footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT // Keeps track of where the actual create came from
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            // set the new comment as selected with its actual id
            setCurrentlySelectedThreadKey(comment.id, (0, $kgNLQ.CommentType).GENERAL, true);
            // Return the new comment ID so downstream consumers (e.g. PageCommentEditor)
            // can pass it to handleAgentMentionInComment without needing to re-fetch it.
            return {
                id: comment.id
            };
        }).catch((error)=>{
            const translatedError = (0, $lFkRf.getTranslatedError)(error);
            const isAbortableError = (0, $lFkRf.isCommentAbortableError)(translatedError);
            if (isAbortableError) {
                // TODO: show an error message to the user for create not permitted
                experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE),
                    reason: translatedError.id
                });
                // Abort parent experience too, since it's not automatically aborted when child is aborted.
                experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    reason: translatedError.id
                });
            } else failPublishExperience(error);
            return Promise.reject({
                error: translatedError
            });
        });
    };
    const handleCancelInternal = ({ isEditorAborted: isEditorAborted })=>{
        const doCancel = ()=>{
            if (isEditorAborted) {
                setAutoFocusPromptRef?.(true);
                experienceTracker.abort({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    reason: 'aborted because comment was cancelled'
                });
            }
            clearAddFooterCommentAdf();
            closeCommentContainer();
            handleCancel?.();
        };
        if (hasContentChanged) resetContentChanged();
        doCancel();
    };
    const handleOnEditorLoaded = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
        });
        const footerCommentContainer = renderServerPlaceholder || typeof document === 'undefined' ? null : document.querySelector('[data-testId="footerCommentEditor"]');
        if (!footerCommentContainer) return;
        footerCommentContainer.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    };
    const handleEditorReady = (editorActions)=>{
        handleOnEditorLoaded();
        // Store editor actions for later use (e.g., focusing from sticky draft)
        editorActionsRef.current = editorActions;
        // Focus the editor when opened from sticky draft
        if (footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT && editorActions?.focus) editorActions.focus();
    };
    // This is debounced at the editor level (at 150ms) to prevent constant updates hurting performance
    const handleEditorContentChangedWithData = (hasContent, content)=>{
        // Store the actual ADF content for real-time sync
        if (hasContent && content) setAddFooterCommentAdf(content);
        else setAddFooterCommentAdf(undefined);
        // Also call the original onChange handler
        onChange(hasContent);
        onAgentMentionContentChange(content);
    };
    const agentMentionFyiNudge = (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
        visible: showFyi,
        agent: agent
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), {
        banner: agentMentionFyiNudge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4BfG.PageCommentEditor), {
        mode: "create",
        saveHandler: handleCommentsPanelSave,
        cancelHandler: handleCancelInternal,
        onEditorLoaded: handleOnEditorLoaded,
        onEditorReady: handleEditorReady,
        onEditorContentChangedWithData: handleEditorContentChangedWithData,
        useNewExperienceAbort: true,
        expandEditor: true,
        isFooterComment: true,
        isOffline: isOffline,
        showAgentMentionFyiNudge: false
    }));
});



var $MJaSd = parcelRequire("MJaSd");

// GraphQL query for preloading first 3 footer comments
// NOTE: If you update the return type of this query, you need to update the type
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
const $0606d9a810dabf91$var$ObjectCommentContainerPreloadObjectCommentsQuery = (0, $1ydBT.default);
const $0606d9a810dabf91$var$commentPanelContainerStyles = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: '100%',
    width: '100%'
});
const $0606d9a810dabf91$var$wrapperStyle = (0, $buxP3.xcss)({
    position: 'relative',
    visibility: 'visible',
    minHeight: '50px',
    margin: '0 auto'
});
const $0606d9a810dabf91$var$baseEditorStyles = (0, $buxP3.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.200',
    position: 'relative'
});
const $0606d9a810dabf91$var$footerStickyWrapperStyle = (0, $buxP3.xcss)({
    zIndex: 'navigation',
    backgroundColor: 'elevation.surface',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 'space.0'
});
const $0606d9a810dabf91$var$viewPageFooterStyle = (0, $buxP3.xcss)({
    zIndex: '1',
    transform: 'unset',
    bottom: 'space.0'
});
const $0606d9a810dabf91$var$footerEditorStyle = (0, $buxP3.xcss)({
    left: 'space.0'
});
const $0606d9a810dabf91$var$fixedEditorStyles = (0, $buxP3.xcss)({
    position: 'fixed'
});
const $0606d9a810dabf91$var$stickyEditorStyles = (0, $buxP3.xcss)({
    position: 'sticky'
});
const $0606d9a810dabf91$var$placeholderStyle = (0, $buxP3.xcss)({
    width: '60%'
});
const $0606d9a810dabf91$var$incrementalLoadingPlaceholderStyle = (0, $buxP3.xcss)({
    width: '60%'
});
// No border here: `ObjectCommentHeader` (has-comments) and the sticky add-comment bar
// (no-comments) each already draw their own top divider directly below this row.
const $0606d9a810dabf91$var$footerLabelsRowStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingBottom: 'space.200'
});

// Same `webpackChunkName` as `ObjectAddCommentContainer`'s own copy of this loader, so no extra
// chunk is produced even though each file defines it separately.
const $0606d9a810dabf91$var$FooterLabelsLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JSCgI",
    name: "FooterLabelsLoader",
    loader: async ()=>(await (parcelRequire("l3kuI"))).FooterLabels
});
const $0606d9a810dabf91$var$addCommentContainerStyles = (0, $buxP3.xcss)({
    transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
    transformOrigin: 'top',
    position: 'sticky',
    bottom: 'space.0',
    zIndex: '1' // Required for create comment editor overflow to show on top of page content
});
const $0606d9a810dabf91$var$addCommentContainerAnimationHiddenStyles = (0, $buxP3.xcss)({
    transform: 'translateY(100%)',
    opacity: '0',
    pointerEvents: 'none'
});
const $0606d9a810dabf91$var$addCommentContainerAnimationShowStyles = (0, $buxP3.xcss)({
    transform: 'translateY(0)',
    opacity: '1',
    pointerEvents: 'auto'
});
const $0606d9a810dabf91$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $0606d9a810dabf91$var$useReplyToCommentQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $0606d9a810dabf91$var$ObjectCommentContainerComponent = (0, $7aRa9.withFlags)(({ flags: flags, pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline, hasCommentSessions: hasCommentSessions })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    // The footer mounts AgentSessionsFetcher only when the page-load `cc-agent-mention-sessions`
    // marker says sessions exist (hasCommentSessions, derived from ContentUnifiedQuery). But when
    // an agent is @-mentioned in a comment THIS session, the marker write (REST) isn't reflected
    // in the already-cached ContentUnifiedQuery, so hasCommentSessions stays false until a reload
    // and the footer never shows the new session. Optimistically flip this flag on the
    // comment-saved event so the fetcher mounts and its post-save poll surfaces the session
    // without a reload. (Panel/inline don't need this — they mount AgentSessionsProvider eagerly.)
    const [agentMentionedThisSession, setAgentMentionedThisSession] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        // Kill-switch: when the experiment is off, don't even register the listener — keep this
        // feature's production side effects fully gated, like the rest of it. The effect is still
        // called unconditionally (Rules of Hooks); only its body is guarded. expValEquals is
        // stable for the session, so reading it once on mount with empty deps is correct.
        if (!(0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) return;
        const handleAgentMentionCommentSaved = ()=>setAgentMentionedThisSession(true);
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionCommentSaved);
        return ()=>window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionCommentSaved);
    }, []);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [commentSectionTop, setCommentSectionTop] = (0, $cozmU.useState)(0);
    const [isInViewport, setIsInViewport] = (0, $cozmU.useState)(false);
    const [allCommentsRendered, setAllCommentsRendered] = (0, $cozmU.useState)(false);
    const [commentBatchRendered, setCommentBatchRendered] = (0, $cozmU.useState)(false);
    const [commentBatchCount, setCommentBatchCount] = (0, $cozmU.useState)(0);
    // Compatibility with the still-legacy query-param listener. The launched Data
    // Manager path owns loading, so this callback intentionally does nothing.
    const setForceLoadComments = (_value)=>undefined;
    const [shouldShowAddComment, setShouldShowAddComment] = (0, $cozmU.useState)(true);
    const [state] = (0, $isEtk.useContentState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isServer = (0, $1P7Cq.useIsSSROrHydrating)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const { expanded: expanded, width: width, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    // Hide OmniBar when the footer comment component is open (e.g. Comment button clicked)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (expanded) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        expanded,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    // Track page-content-only dimensions for layout alignment and blue background sizing
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    // Get processed comments data
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const focusedCommentId = $0606d9a810dabf91$var$useFocusedCommentIdQueryParam();
    const replyToComment = $0606d9a810dabf91$var$useReplyToCommentQueryParam();
    // Read the preloaded footer comments from cache. Query for all content statuses; filtering
    // happens after the fact.
    //
    // Read through the React-context Relay environment so streaming SSR and client hydration use
    // the same cache. This is a non-suspending, standby read with no network request or subscription.
    const { data: hookPreloadCacheData } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($0606d9a810dabf91$var$ObjectCommentContainerPreloadObjectCommentsQuery, {
        variables: (0, $cQbnm.buildPreloadObjectCommentsQueryVariables)(contentId ?? '', !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_data_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false), !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_comment_threads_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false), focusedCommentId, Boolean(focusedCommentId) && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_query') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false)),
        skip: !contentId,
        __callerPackage__: "object-comments"
    });
    const commentThreadsFragmentData = (0, $90hCa.useViewPageConversationCommentThreads)(!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_comment_threads_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false) ? hookPreloadCacheData?.comments?.conversationCommentThreads : null);
    const preloadCacheData = (0, $cozmU.useMemo)(()=>commentThreadsFragmentData && hookPreloadCacheData ? {
            ...hookPreloadCacheData,
            comments: commentThreadsFragmentData
        } : hookPreloadCacheData ?? null, [
        commentThreadsFragmentData,
        hookPreloadCacheData
    ]);
    const preloadAwareFooterDataResult = (0, $cozmU.useMemo)(()=>(0, $MJaSd.getPreloadAwareObjectComments)(processedCommentsData, preloadCacheData, contentStatusFilters), [
        processedCommentsData,
        preloadCacheData,
        contentStatusFilters
    ]);
    const [shouldRequeryArchivedComments, setShouldRequeryArchivedComments] = (0, $cozmU.useState)(false);
    const hasRequeriedArchivedComments = (0, $cozmU.useRef)(false);
    const startedExperience = (0, $cozmU.useRef)(false);
    const { replyToCommentId: replyToCommentId, currentlySelectedThreadKey: currentlySelectedThreadKey, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    const [{ isUnreadQueryLoading: isUnreadQueryLoading }] = (0, $fHAwL.useUnreadComments)();
    const [hasLoadedUnreadStatus, setHasLoadedUnreadStatus] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isContentReady = pageMode === (0, $cD1qu.PageMode).VIEW ? state.isContentReady : true;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Hide add comment container on archived pages
    (0, $cozmU.useEffect)(()=>{
        if (isArchived) {
            setShouldShowAddComment(false);
            setShouldRequeryArchivedComments(true);
        }
    }, [
        isArchived
    ]);
    // Close comment container when expanded and contentId changes
    (0, $cozmU.useEffect)(()=>{
        if (expanded && contentId) closeCommentContainer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // AKA - has the user scrolled to the bottom of the page?
    const isContentInViewport = isInViewport && isContentReady;
    // When preloading, we don't always have access to archived page state (depends on a race condition for cache hit / miss)
    // In those cases, we can incorrectly determine that the page is fully loaded with no comments, when really we just queried using the wrong vars
    // Given that archived are such a small percent of loads, just force a reload here (i.e. don't trust cache) to be safe
    const shouldForceReloadForArchivedComments = shouldRequeryArchivedComments && !hasRequeriedArchivedComments.current;
    const wasFullyLoaded = preloadAwareFooterDataResult.isUsingFullData || preloadAwareFooterDataResult.allDataPreloaded;
    const wasPartiallyPreloaded = preloadAwareFooterDataResult.isPreloadDataProcessed;
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const error = preloadAwareFooterDataResult.error;
    const data = (0, $cozmU.useMemo)(()=>({
            comments: {
                totalCount: preloadAwareFooterDataResult.commentCount,
                nodes: preloadAwareFooterDataResult.openFooterComments
            }
        }), [
        preloadAwareFooterDataResult.commentCount,
        preloadAwareFooterDataResult.openFooterComments
    ]);
    // Enhanced loading state that accounts for data manager processing
    // Only show loading if we're actually loading OR if data isn't processed yet
    const loading = preloadAwareFooterDataResult.isPreloadLoading || !preloadAwareFooterDataResult.isDataProcessed;
    // In cases where the first paint will be correct (i.e. will match SPA version because nothing controlled by a useEffect / DOM action), immediately render
    // Otherwise, this will just happen on first paint in SPA once the useEffects run
    const renderOnServer = isServer && data?.comments?.totalCount === 0;
    // TODO: Needs investigation; ignored because linting rules changed during feature gate cleanup.
    const noOpenObjectComments = (0, $cozmU.useMemo)(()=>{
        return data?.comments?.nodes?.length === 0 || true;
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- Preserve existing loading behavior; investigate separately.
    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-usememo-deps
    }, [
        data
    ]);
    // If we're forcing a reload for archived comments, we need to set the flag to true so we don't try to reload again
    (0, $cozmU.useEffect)(()=>{
        if (shouldForceReloadForArchivedComments && !loading && data) hasRequeriedArchivedComments.current = true;
    }, [
        data,
        loading,
        shouldForceReloadForArchivedComments
    ]);
    // AKA - are we done loading?
    const shouldShowComments = wasFullyLoaded || wasPartiallyPreloaded || renderOnServer;
    // Return null when we haven't loaded anything yet, we're not in the viewport, and we're not SSRed
    const shouldReturnNull = error && !(0, $i6UMJ.onlyHasReactionsSummaryErrors)(error) || !isContentInViewport && !shouldShowComments;
    // Show global placeholder (i.e. instead of comments header, etc) when we're in the viewport but are still loading, and we're not SSRed
    const shouldShowGlobalPlaceholder = isContentInViewport && !shouldShowComments;
    // Show incremental loading placeholder in SSR when preload is completed with comments
    // We can't show the comments themselves because commentThreads is set across multiple renders via sweet state
    // This also ensures that we either show the loading placeholder or the comment threads, never both
    // Without it, we can briefly show both threads & the placeholder, even if fully loaded
    // UPDATE: SSRing the incremental loading placeholder seems to slow down rendering of the
    // preloaded top footer comments on browser, leading to an increase in ViewPage VC90. Thus,
    // `confluence_fe_ssr_top_footer_comments` experiment disables it and instead renders the
    // actual top footer comments on server-side.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    const shouldShowIncrementalLoadingPlaceholderOnServer = isServer && preloadAwareFooterDataResult?.preloadCompletedWithComments && !(0, $6mKj3.expValEquals)('confluence_fe_ssr_top_footer_comments', 'isEnabled', true);
    // Show placeholder when we're in the viewport but are still loading the rest of the data
    const shouldShowIncrementalLoadingPlaceholder = shouldShowComments && loading && !wasFullyLoaded || shouldShowIncrementalLoadingPlaceholderOnServer;
    // Set up IntersectionObserver
    (0, $cozmU.useEffect)(()=>{
        if (isServer || !isContentReady) // Don't register observer if page content is not ready
        return;
        // eslint-disable-next-line no-restricted-syntax
        const observer = new IntersectionObserver(([entry])=>{
            const isIntersecting = entry.isIntersecting;
            if (isIntersecting) setIsInViewport(isIntersecting);
        }, {
            root: null,
            rootMargin: '10px',
            threshold: 0.1
        });
        if (wrapperRef.current) observer.observe(wrapperRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isServer,
        pageMode,
        state.isContentReady,
        isContentReady
    ]);
    // Add MutationObserver to detect when comments are actually rendered --- old logic for checking all comment rendered or not
    (0, $cozmU.useEffect)(()=>{
        if (isServer || !currentlySelectedThreadKey) return;
        const observer = new MutationObserver(()=>{
            const commentElementId = `footer-comment-thread-${currentlySelectedThreadKey}-container`;
            const commentElement = document.getElementById(commentElementId);
            if (commentElement) {
                setAllCommentsRendered(true);
                observer.disconnect(); // Disconnect once we find the element
            } else setAllCommentsRendered(false); // Reset if element not found
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Reset allCommentsRendered when unmounting or changing thread key
        return ()=>{
            setAllCommentsRendered(false);
            observer.disconnect();
        };
    }, [
        currentlySelectedThreadKey,
        isServer
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isUnreadQueryLoading && !hasLoadedUnreadStatus) setHasLoadedUnreadStatus(true);
    }, [
        isUnreadQueryLoading,
        hasLoadedUnreadStatus
    ]);
    // Handle spacing for Editor & LiveDoc modes by observing the size of editorTextArea
    (0, $cozmU.useEffect)(()=>{
        const editorTextArea = document.getElementById('ak-editor-textarea');
        if (editorTextArea) {
            if (hasRecs) {
                setCommentSectionTop(0);
                return;
            }
            const resizeObserver = new ResizeObserver(()=>{
                const newTop = (0, $aHcFH.getCommentPositionTopOfSectionEditor)();
                (0, $9kbTQ.flushSync)(()=>{
                    newTop !== undefined && setCommentSectionTop(newTop);
                });
            });
            // observe resize of editorTextArea to update spacing when content changes
            resizeObserver.observe(editorTextArea);
            // observe resize of document.body to update spacing when window height changes
            resizeObserver.observe(document.body);
            return ()=>resizeObserver.disconnect();
        }
    }, [
        hasRecs
    ]);
    const commentsDataMap = preloadAwareFooterDataResult.commentsDataMap;
    const commentThreads = (0, $cozmU.useMemo)(()=>{
        if (!wasFullyLoaded && !shouldShowComments) // no need to update if we haven't loaded, or aren't showing comments
        return [];
        return (0, $6lAIr.getVisibleCommentThreads)({
            commentsDataMap: commentsDataMap,
            includeGeneralComments: true,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        });
    }, [
        wasFullyLoaded,
        shouldShowComments,
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode
    ]);
    const hasComments = commentThreads.length > 0;
    // Handle add comment container animation and mounting
    (0, $cozmU.useEffect)(()=>{
        if (isArchived) return;
        const shouldHide = !!replyToCommentId && commentLocation === (0, $i6UMJ.LocationValue).FOOTER;
        if (shouldHide) // Start hiding animation
        setShouldShowAddComment(false);
        else {
            // Show component after a small delay to allow for animation
            const timer = setTimeout(()=>{
                setShouldShowAddComment(true);
            }, 50);
            return ()=>clearTimeout(timer);
        }
    }, [
        replyToCommentId,
        commentLocation,
        isArchived
    ]);
    // Track the start of comments loading and initialize performance metrics
    (0, $cozmU.useEffect)(()=>{
        const shouldStartExperience = !startedExperience.current && (isContentInViewport && loading || wasFullyLoaded && hasComments);
        if (shouldStartExperience) {
            // Start tracking the page comments experience with initial attributes
            experienceTracker.start({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    isConditionalRenderingOn: true,
                    isFocusedComment: Boolean(focusedCommentId || replyToComment),
                    contentId: contentId,
                    pageMode: pageMode
                }
            });
            startedExperience.current = true;
            // Initialize and mark the start of page comments rendering metrics
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).start();
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).mark('pageCommentsRenderStart');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldShowIncrementalLoadingPlaceholder,
        shouldShowGlobalPlaceholder,
        loading,
        isContentInViewport,
        wasFullyLoaded,
        hasComments
    ]);
    // Track any errors that occur during comments loading
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if ((0, $i6UMJ.onlyHasReactionsSummaryErrors)(error)) {
                experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                    attributes: {
                        ignoredReactionsSummaryErrors: true
                    }
                });
                // Comments may still be displayed without reactions, so do not
                // fail or abort the experience but just return here.
                return;
            }
            const translatedError = (0, $lFkRf.getTranslatedError)(error);
            // The experiment is evaluated first so the broader abortable-error set (which also
            // covers the step-up-auth and IP-allowlist access-policy errors) is only used while
            // the experiment is on; when it is off the behaviour is unchanged.
            if ((0, $6mKj3.expValEquals)('confluence_fe_abort_comment_on_access_policy_err', 'isEnabled', true) ? (0, $lFkRf.isCommentAbortableError)(translatedError) : (0, $lFkRf.isViewNotPermittedError)(translatedError)) {
                // If the error is a permission or access-policy error, show a warning flag and abort the experience
                flags.showWarningFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                    reason: translatedError.id
                });
                (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).cancel();
                return;
            }
            if ((0, $lFkRf.isNetworkError)(translatedError)) // Show flag for network error
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $FBfum.i18n).unableToLoadCommentsTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
            });
            // Mark the experience as failed/aborted and include the error details
            experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                error: error
            });
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error
    ]);
    // Track successful completion of comments rendering
    (0, $cozmU.useEffect)(()=>{
        if (allCommentsRendered && wasFullyLoaded && hasComments) {
            // Mark the experience as successful and include total comments count
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    totalComments: data?.comments?.totalCount,
                    totalCommentThreads: commentThreads.length
                }
            });
            // Mark key performance metrics:
            // - pageCommentsRenderEnd: End of comments rendering
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).mark('pageCommentsRenderEnd');
            // Stop the metric tracking and include final data
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).stop({
                customData: {
                    contentId: contentId || '',
                    totalComments: data?.comments?.totalCount || 0
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allCommentsRendered,
        wasFullyLoaded,
        hasComments
    ]);
    // Track successful completion of first comment batch rendering
    (0, $cozmU.useEffect)(()=>{
        if (commentBatchRendered) {
            // Mark key performance metrics:
            // - fmp: First Meaningful Paint
            // - tti: Time to Interactive
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).markFMP();
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).mark('tti');
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE));
            if (experienceState?.startTime && typeof experienceState.startTime === 'number') experienceTracker.updateAttributes({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    firstMeaningfulPaint: window.performance.now() - experienceState.startTime
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentBatchRendered
    ]);
    // Handle case when there are no comments to render
    (0, $cozmU.useEffect)(()=>{
        if (data?.comments?.totalCount === 0) {
            // Abort the experience tracking since there are no comments to render
            experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                reason: 'No page comments'
            });
            (0, $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17).cancel();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data
    ]);
    const handleAllCommentsRendered = (0, $cozmU.useCallback)(()=>setAllCommentsRendered(true), []);
    const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
        pageMode: pageMode,
        pageWidthType: pageWidthType,
        hasEndOfPageRecommendations: hasRecs ?? false
    });
    const shouldRenderFixedStyle = (0, $cozmU.useMemo)(()=>{
        if (expanded && footerEditorEntry === (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT) return true;
        return false;
    }, [
        expanded,
        footerEditorEntry
    ]);
    const pageContentDimensions = (0, $cozmU.useMemo)(()=>({
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        }), [
        pageContentWidth,
        pageContentLeft,
        pageContentRight
    ]);
    // AgentSessionsFetcher is only mounted when the experiment is on — this guarantees
    // zero Relay queries and zero Suspense when the gate is off.
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: wrapperRef,
        xcss: $0606d9a810dabf91$var$wrapperStyle,
        testId: "object-comment-wrapper",
        style: {
            top: commentSectionTop,
            width: computedWidths.width,
            maxWidth: computedWidths.maxWidth
        },
        "data-vc": `object-comment-wrapper-${pageMode}-${hasComments ? 'has-comments' : 'no-comments'}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90365d58d6587547$export$1e65952d87b47593), {
        hasLoadedObjectComments: !!shouldShowComments,
        allObjectCommentsRendered: allCommentsRendered || noOpenObjectComments || wasFullyLoaded,
        commentBatchRendered: commentBatchRendered,
        commentBatchCount: commentBatchCount,
        setForceLoadComments: setForceLoadComments
    }), shouldReturnNull ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldShowGlobalPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$placeholderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deTj5.CommentPlaceholder), {
        showPlaceholder: true
    })), shouldShowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
        contentId: contentId ?? ''
    }, // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    showLabels && (0, $6mKj3.expValEquals)('confluence_footer_reactions_redesign', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$footerLabelsRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0606d9a810dabf91$var$FooterLabelsLoader, null)), hasComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f06f6da515cf7544$export$32c2c28e641d3a4f), {
        isOffline: editorIsUserOffline,
        showReactions: isEmbeddedConfluence ? hasReactions : true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $0606d9a810dabf91$var$commentPanelContainerStyles
    }, !shouldShowIncrementalLoadingPlaceholderOnServer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd40026d890a9ac0$export$b05be82c52775010), {
        commentThreads: commentThreads,
        supportedTopLevelActions: [
            'edit',
            'resolve',
            'delete'
        ],
        flags: flags,
        onAllCommentsRendered: handleAllCommentsRendered,
        onCommentBatchRendered: ()=>{
            setCommentBatchRendered(true);
            setCommentBatchCount((prev)=>prev + 1);
        },
        isOffline: editorIsUserOffline
    }), shouldShowIncrementalLoadingPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$incrementalLoadingPlaceholderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $deTj5.CommentPlaceholder), {
        showPlaceholder: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $0606d9a810dabf91$var$addCommentContainerStyles,
            !!replyToCommentId && commentLocation === (0, $i6UMJ.LocationValue).FOOTER ? $0606d9a810dabf91$var$addCommentContainerAnimationHiddenStyles : $0606d9a810dabf91$var$addCommentContainerAnimationShowStyles
        ]
    }, !shouldShowGlobalPlaceholder && !shouldShowIncrementalLoadingPlaceholder && shouldShowAddComment && !isArchived && !expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2998c7377d5266d6$export$f3a35a1c0e5d2996), {
        showReactions: !hasComments && (isEmbeddedConfluence ? hasReactions : true),
        showLabels: showLabels,
        isOffline: editorIsUserOffline,
        optimisticReactions: true
    }))))), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $0606d9a810dabf91$var$footerStickyWrapperStyle,
            shouldRenderFixedStyle ? $0606d9a810dabf91$var$fixedEditorStyles : $0606d9a810dabf91$var$stickyEditorStyles,
            pageMode === (0, $cD1qu.PageMode).VIEW && $0606d9a810dabf91$var$viewPageFooterStyle,
            pageMode !== (0, $cD1qu.PageMode).VIEW && $0606d9a810dabf91$var$footerEditorStyle
        ],
        testId: "footerCommentEditor",
        style: pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: shouldRenderFixedStyle,
            pageContentDimensions: pageContentDimensions,
            fallbackWidth: width
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0606d9a810dabf91$var$baseEditorStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            width: width,
            maxWidth: computedWidths.maxWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f75a8a3cc0f80c1$export$b65ed37f0eb1c56b), {
        isOffline: editorIsUserOffline
    }))));
    // Mount the fetcher when the page-load marker says there are sessions OR an agent was
    // mentioned this session (the marker isn't yet reflected in the cached ContentUnifiedQuery).
    // hasCommentSessions already includes the experiment gate; gate the optimistic branch on the
    // experiment too so it stays a kill-switch. Ordered last per confluence-feature-gating rules.
    const renderWithAgentSessions = (renderedContent)=>{
        if (hasCommentSessions || agentMentionedThisSession && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) {
            const mountedFromLocalMention = agentMentionedThisSession && !hasCommentSessions;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac96fb5095c0413f$export$4d8c455866c22554), {
                pageId: contentId ?? '',
                refetchOnMount: mountedFromLocalMention,
                preserveEmptyMarker: mountedFromLocalMention
            }, renderedContent);
        }
        return renderedContent;
    };
    if (preloadCacheData?.content?.nodes?.[0] && preloadCacheData.conversationCurrentUser && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_data_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false)) return renderWithAgentSessions(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90hCa.ViewPageConversationDataProvider), {
        contentPermissionFragmentRef: preloadCacheData.content.nodes[0],
        currentUserFragmentRef: preloadCacheData.conversationCurrentUser
    }, content));
    return renderWithAgentSessions(content);
});
const $0606d9a810dabf91$export$82b49dda6ae20eb7 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})($0606d9a810dabf91$var$ObjectCommentContainerComponent);
module.exports["ObjectCommentContainer"] = $0606d9a810dabf91$export$82b49dda6ae20eb7;

});

parcelRegister("lFkRf", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $6fil2 = parcelRequire("6fil2");


var $CP0sd = parcelRequire("CP0sd");


var $FBfum = parcelRequire("FBfum");

const $ad3c53086a228972$export$510b853f2c2b5c4a = (message)=>{
    const urlStartIdx = message.search(/\bhttps?:\/\//);
    const delimiterSearchScope = urlStartIdx === -1 || !(0, $6mKj3.expValEquals)('confluence_fe_abort_comment_on_access_policy_err', 'isEnabled', true) ? message : message.slice(0, urlStartIdx);
    return delimiterSearchScope.lastIndexOf(':') + 1;
};
const $ad3c53086a228972$var$parseError = (error)=>{
    const { message: message } = error;
    let errorMessage;
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from queries/mutations always have the same format:
   * GraphQL error: <GUID>:[ <EXCEPTION>:] <REASON>
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = $ad3c53086a228972$export$510b853f2c2b5c4a(message);
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
    } else errorMessage = message;
    const parsedError = {
        message: errorMessage
    };
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
    return parsedError;
};
const $ad3c53086a228972$export$a67f8c1198066537 = (error)=>{
    if ((0, $6fil2.containsNetworkError)(error)) return (0, $FBfum.i18n).networkError;
    const parsedError = $ad3c53086a228972$var$parseError(error);
    const { message: message } = parsedError;
    switch(true){
        case message === (0, $CP0sd.ObjectCommentsError).VIEW_NOT_PERMITTED:
            return (0, $FBfum.i18n).viewNotPermitted;
        case message === (0, $CP0sd.ObjectCommentsError).NO_CREATE_PERMS:
            return (0, $FBfum.i18n).createNotPermitted;
        case $ad3c53086a228972$export$ecdfad00dc25b27e(message):
            return (0, $FBfum.i18n).contentNotFound;
        case message === (0, $CP0sd.ObjectCommentsError).STEP_UP_AUTH_REQUIRED:
            return (0, $FBfum.i18n).stepUpAuthRequired;
        case message === (0, $CP0sd.ObjectCommentsError).IP_ALLOWLIST_BLOCKED:
            return (0, $FBfum.i18n).ipAllowlistBlocked;
        default:
            return (0, $FBfum.i18n).unexpectedError;
    }
};
const $ad3c53086a228972$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).viewNotPermitted.id;
const $ad3c53086a228972$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).networkError.id;
const $ad3c53086a228972$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).createNotPermitted.id;
const $ad3c53086a228972$export$c572523773a0cf86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).contentNotFound.id;
const $ad3c53086a228972$export$60fba4117567a49b = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).stepUpAuthRequired.id;
const $ad3c53086a228972$export$55edbe8839167361 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).ipAllowlistBlocked.id;
const $ad3c53086a228972$export$d1e82e172a94f308 = (translatedMessage)=>$ad3c53086a228972$export$aa951ce6b8761d86(translatedMessage) || $ad3c53086a228972$export$c4a6c57f5b95da54(translatedMessage) || $ad3c53086a228972$export$c572523773a0cf86(translatedMessage) || // Only the add-page-comment path consumes isCommentAbortableError today, so gating the new
    // access-policy errors here keeps the abort/fail reclassification scoped to that experience
    // (the global getExperienceStopReason is intentionally left untouched). The experiment is
    // evaluated last so exposure is only fired for the access-policy errors it actually gates.
    ($ad3c53086a228972$export$60fba4117567a49b(translatedMessage) || $ad3c53086a228972$export$55edbe8839167361(translatedMessage)) && (0, $6mKj3.expValEquals)('confluence_fe_abort_comment_on_access_policy_err', 'isEnabled', true);
const $ad3c53086a228972$var$CONTENT_NOT_FOUND_PATTERNS = [
    /Content with id \S+ for comment container is not found/,
    /No content found with id\s*:\s*\S+/,
    /Cannot create a \[[^\]]+\] comment on content with \[(?:trashed|deleted|archived)\] status/
];
/**
 * The footer-comment flavour of the container NotFoundException, e.g.
 * `Attempted to create [FOOTER] comment, but container content with id 12345 and content status
 * [current] for comment container is not found.`
 *
 * The `[current]` status is matched explicitly: a non-`[current]` status (for example `[draft]`)
 * is not the "the page is gone" case this classification is for.
 *
 * Kept out of CONTENT_NOT_FOUND_PATTERNS because it is gated behind the
 * 'confluence_fe_comment_container_content_not_found' experiment — with the experiment off these
 * messages keep their previous `unexpectedError` classification.
 */ const $ad3c53086a228972$var$GATED_COMMENT_CONTAINER_NOT_FOUND_PATTERN = /content with id \S+ and content status \[current\] for comment container is not found/;
const $ad3c53086a228972$export$ecdfad00dc25b27e = (errorMessage)=>$ad3c53086a228972$var$CONTENT_NOT_FOUND_PATTERNS.some((pattern)=>pattern.test(errorMessage)) || // The experiment is evaluated last so exposure is only fired for the comment-container
    // messages it actually gates, not for every error that passes through here.
    $ad3c53086a228972$var$GATED_COMMENT_CONTAINER_NOT_FOUND_PATTERN.test(errorMessage) && (0, $6mKj3.expValEquals)('confluence_fe_comment_container_content_not_found', 'isEnabled', true);
module.exports["getGraphQLReasonStartIdx"] = $ad3c53086a228972$export$510b853f2c2b5c4a;
module.exports["getTranslatedError"] = $ad3c53086a228972$export$a67f8c1198066537;
module.exports["isRawContentNotFoundError"] = $ad3c53086a228972$export$ecdfad00dc25b27e;
module.exports["isViewNotPermittedError"] = $ad3c53086a228972$export$c4a6c57f5b95da54;
module.exports["isNetworkError"] = $ad3c53086a228972$export$476aa014e2fd89d5;
module.exports["isCommentAbortableError"] = $ad3c53086a228972$export$d1e82e172a94f308;

});

parcelRegister("CP0sd", function(module, exports) {
var $a1a7014f0329fe2c$export$37d35ac9f5bc0a58 = /*#__PURE__*/ function(ObjectCommentsError) {
    // view
    ObjectCommentsError["VIEW_NOT_PERMITTED"] = "403 Forbidden, current user not permitted to use Confluence.";
    // Create
    ObjectCommentsError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    ObjectCommentsError["CONTAINER_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    // Admin-configured access-policy rejections. Enforced per-request at the GraphQL gateway and
    // surfaced as the exact reason string (parsed out of the GraphQL error wrapper).
    ObjectCommentsError["STEP_UP_AUTH_REQUIRED"] = "Step-up authentication is required. https://support.atlassian.com/security-and-access-policies/docs/understand-external-user-security/";
    ObjectCommentsError["IP_ALLOWLIST_BLOCKED"] = "You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help.";
    return ObjectCommentsError;
}({});
module.exports["ObjectCommentsError"] = $a1a7014f0329fe2c$export$37d35ac9f5bc0a58;

});

parcelRegister("FBfum", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $93264f9de833f05e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    unableToLoadCommentsTitle: {
        id: "comments-util.error.unable.to.load.comments",
        defaultMessage: "Unable to load comments"
    },
    networkError: {
        id: "comments-util.error.network",
        defaultMessage: "A network error was encountered when loading comments. Please try refreshing the page."
    },
    viewNotPermitted: {
        id: "comments-util.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view comments on this page. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "comments-util.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    contentNotFound: {
        id: "comments-util.error.content.not.found",
        defaultMessage: "The page you are trying to comment on is no longer available. It may have been deleted or archived."
    },
    stepUpAuthRequired: {
        id: "comments-util.error.step.up.auth.required",
        defaultMessage: "You need to verify your identity again before you can comment. Refresh the page and try again."
    },
    ipAllowlistBlocked: {
        id: "comments-util.error.ip.allowlist.blocked",
        defaultMessage: "You can\u2019t comment because your IP address isn\u2019t on your organization\u2019s allowlist. Contact your admin for help."
    },
    unexpectedError: {
        id: "comments-util.error.unexpected",
        defaultMessage: "Something went wrong when loading comments on this page."
    }
});
module.exports["i18n"] = $93264f9de833f05e$export$a7357cdd1f0b0168;

});

parcelRegister("famWw", function(module, exports) {
/* AddCommentPromptButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $cY2bA = parcelRequire("cY2bA");


var $hBYtq = parcelRequire("hBYtq");


var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");

const $6aab88ace7ca0350$var$styles = {
    addCommentButtonStyle: "_4FKVYEPgdg _0bjKvDKxmn _2sNsIgmnOE _3iDTPbQ4SZ _4kiQYAUofl _2Zuz6Q8HPE _1Znuxb8HPE _37wbyuDIqT _0hPCNLDIqT _1UtDYzZpcK",
    enabledStyle: "_0KLXru66of _0ReiIH7zJH _1eOmH6o126",
    disabledStyle: "_0KLXruVrZW _0wOv4Qsyl5 _1UtDYzot27",
    fullWidthStyle: "_39xV02N91d"
};
const $6aab88ace7ca0350$var$i18n = (0, $kSwu1.defineMessages)({
    addCommentPromptText: {
        id: "comments-common.add-comment-prompt.text",
        defaultMessage: "Add a comment"
    },
    addCommentPromptAriaLabel: {
        id: "comments-common.add-comment-prompt.aria-label",
        defaultMessage: "Add a general comment"
    }
});
const $6aab88ace7ca0350$export$caf1bbdc1c7b1a40 = ({ onClick: onClick, autofocusRef: autofocusRef, shouldFitContainer: shouldFitContainer, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId || '');
    const buttonRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (autofocusRef.current) {
            buttonRef.current?.focus({
                preventScroll: true
            });
            autofocusRef.current = false;
        }
    }, [
        autofocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($6aab88ace7ca0350$var$styles.addCommentButtonStyle, !canAddComments ? $6aab88ace7ca0350$var$styles.disabledStyle : $6aab88ace7ca0350$var$styles.enabledStyle, shouldFitContainer && $6aab88ace7ca0350$var$styles.fullWidthStyle),
        isDisabled: !canAddComments,
        onClick: onClick,
        testId: testId,
        ref: buttonRef,
        "aria-label": formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptAriaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cY2bA))), {
        label: formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, formatMessage($6aab88ace7ca0350$var$i18n.addCommentPromptText))));
};
module.exports["AddCommentPromptButton"] = $6aab88ace7ca0350$export$caf1bbdc1c7b1a40;

});

parcelRegister("l3kuI", function(module, exports) {

let $f539c68e994d9320$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f539c68e994d9320$var$load("BbB4M").then(()=>parcelRequire('JSoWM'));

});

parcelRegister("3cu4A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $8i27m = parcelRequire("8i27m");


var $6eYRP = parcelRequire("6eYRP");

const $ba24a8cc7b954968$export$3577ba943a5537ec = 8;
// Binary search to find the transition point between inline/general comments
const $ba24a8cc7b954968$var$findTransitionIndex = (commentsList)=>{
    if (!commentsList.length) return 0;
    let low = 0;
    let high = commentsList.length - 1;
    // If all comments are of the same type, return 0
    const firstType = commentsList[0].type;
    const lastType = commentsList[high].type;
    if (firstType === lastType) return 0;
    while(low < high){
        const mid = Math.floor((low + high) / 2);
        if (commentsList[mid].type === (0, $8i27m.CommentType).INLINE) low = mid + 1;
        else high = mid;
    }
    return low;
};
const $ba24a8cc7b954968$var$CommentBatchListInner = ({ commentsList: commentsList, passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const batchCount = Math.ceil(commentsList.length / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const batches = (0, $cozmU.useMemo)(()=>new Array(batchCount).fill(0), [
        batchCount
    ]);
    const [batch, setBatch] = (0, $cozmU.useState)(0);
    const onBatchRendered = (0, $cozmU.useCallback)((batchIndex)=>{
        if (passThroughProps) {
            passThroughProps.onCommentBatchRendered && passThroughProps.onCommentBatchRendered();
            if (batches.length && batchIndex === batches.length - 1) passThroughProps.onLastThreadRendered && passThroughProps.onLastThreadRendered();
        }
        setBatch(batchIndex + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const globalTransitionIndex = (0, $cozmU.useMemo)(()=>$ba24a8cc7b954968$var$findTransitionIndex(commentsList), [
        commentsList
    ]);
    const transitionBatchIndex = Math.floor(globalTransitionIndex / $ba24a8cc7b954968$export$3577ba943a5537ec);
    const transitionIndexWithinBatch = globalTransitionIndex % $ba24a8cc7b954968$export$3577ba943a5537ec;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, batches.map((_, index)=>{
        const isTransitionBatch = index === transitionBatchIndex && globalTransitionIndex !== 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eYRP.CommentBatch), {
            key: `${contentId}-batch-${index}`,
            commentsList: commentsList,
            canRenderBatch: index <= batch,
            batchIndex: index,
            passThroughProps: passThroughProps,
            Component: Component,
            getElementsToBatch: getElementsToBatch,
            onBatchRendered: onBatchRendered,
            transitionIndexWithinBatch: isTransitionBatch ? transitionIndexWithinBatch : undefined
        });
    }));
};
const $ba24a8cc7b954968$export$69f1296a446ecce6 = /*#__PURE__*/ (0, $cozmU.memo)($ba24a8cc7b954968$var$CommentBatchListInner);
module.exports["BATCH_SIZE"] = $ba24a8cc7b954968$export$3577ba943a5537ec;
module.exports["CommentBatchList"] = $ba24a8cc7b954968$export$69f1296a446ecce6;

});

parcelRegister("6eYRP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $lfoFx = parcelRequire("lfoFx");


var $3cu4A = parcelRequire("3cu4A");

const $4d6840eb7d00cd1a$var$spinnerContainerStyles = (0, $buxP3.xcss)({
    margin: 'auto',
    position: 'sticky',
    bottom: '1px'
});
const $4d6840eb7d00cd1a$export$f7f1256703956fe = 100;
const $4d6840eb7d00cd1a$var$CommentBatchInner = ({ passThroughProps: passThroughProps, Component: Component, getElementsToBatch: getElementsToBatch, commentsList: commentsList, canRenderBatch: canRenderBatch, batchIndex: batchIndex, onBatchRendered: onBatchRendered, transitionIndexWithinBatch: transitionIndexWithinBatch })=>{
    const [showSpinner, setShowSpinner] = (0, $cozmU.useState)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (canRenderBatch) {
            setShowSpinner(true);
            setTimeout(()=>{
                onBatchRendered(batchIndex);
                setShowSpinner(false);
            }, $4d6840eb7d00cd1a$export$f7f1256703956fe);
        }
    }, [
        canRenderBatch,
        batchIndex,
        onBatchRendered
    ]);
    if (!canRenderBatch) return null;
    const batchOffset = batchIndex * (0, $3cu4A.BATCH_SIZE);
    const batchedList = commentsList.slice(batchOffset, batchOffset + (0, $3cu4A.BATCH_SIZE));
    const elements = getElementsToBatch(batchedList, passThroughProps, Component, transitionIndexWithinBatch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, elements, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4d6840eb7d00cd1a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "comment-batch",
        size: "medium"
    })) : null);
};
const $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe = /*#__PURE__*/ (0, $cozmU.memo)($4d6840eb7d00cd1a$var$CommentBatchInner);
module.exports["CommentBatch"] = $4d6840eb7d00cd1a$export$a484c9e4bd05c9fe;

});

parcelRegister("i8TeS", function(module, exports) {
/* BaseCommentThread.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $4ez2K = parcelRequire("4ez2K");


var $hMaHH = parcelRequire("hMaHH");


var $kgNLQ = parcelRequire("kgNLQ");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $3mVfX = parcelRequire("3mVfX");


var $cAdj8 = parcelRequire("cAdj8");


var $fHAwL = parcelRequire("fHAwL");


var $ibqdE = parcelRequire("ibqdE");

const $74b51dc92462c104$var$styles = {
    threadBoxStyles: "_1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0wOv4Q7zJH _1mT5xdRAKS _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r25zaO _1wydGW5zaO _3iDTPbQ4SZ _0aFT5vbt8w",
    selectedThreadStyles: "_0KLXruqWX3",
    commentTypeSeperatorStyle: "_2mHwu81Y8M _2bqfgdOeNX _0Of8r2NHnM _1ZnuxbNHnM _1wydGW8HPE _2Zuz6Q5zaO",
    commentBodyBoxStyles: "_1LMyvKYbGa _1mT5xdRAKS"
};
const $74b51dc92462c104$var$i18n = (0, $kSwu1.defineMessages)({
    commentTypeSeperatorText: {
        id: "comments-common.comment.thread.type-seperator",
        defaultMessage: "General comments"
    },
    threadContentAriaLabelWithName: {
        // COMMENTS-5979: ObjectCommentThread doesn't have timestamp, but it probably should
        id: "comments-common.thread.content.aria-label.with-name",
        defaultMessage: "{name}\u2019s comment thread, {timestamp}"
    }
}); // This component renders the parent comment and its replies.
const $74b51dc92462c104$export$a9ce751de1bf208f = ({ commentThreadRef: commentThreadRef, commentComponent: commentComponent, commentRepliesComponent: commentRepliesComponent, parentComment: parentComment, pageMode: pageMode, shouldRenderCommentTypeSeparator: shouldRenderCommentTypeSeparator, canAddComments: canAddComments, handleCommentThreadClick: handleCommentThreadClick, handleCommentThreadMouseDown: onCommentThreadMouseDown, testIdPrefix: testIdPrefix, isEditorExpanded: isEditorExpanded, forceShowRepliesSection: forceShowRepliesSection = false, parentHasAgentSession: parentHasAgentSession = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { currentlySelectedThreadKey: currentlySelectedThreadKey, isCurrentlySelectedThreadOptimisticallyAdded: isCurrentlySelectedThreadOptimisticallyAdded } = (0, $3mVfX.useCommentsPanelState)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const threadKey = parentComment.type === (0, $kgNLQ.CommentType).INLINE ? parentComment.location.inlineMarkerRef ?? '' : parentComment.id;
    const [isThreadPressed, setIsThreadPressed] = (0, $cozmU.useState)(false);
    const isCurrentSelectedComment = currentlySelectedThreadKey === threadKey || // Special handling to avoid UI flicker when optimistically adding a footer comment.
    // See comments in `next/packages/comments-panel-utils/src/useCommentsPanel.ts` for details.
    parentComment.type === (0, $kgNLQ.CommentType).GENERAL && !!isCurrentlySelectedThreadOptimisticallyAdded && threadKey === (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID);
    (0, $cozmU.useEffect)(()=>{
        const parentIdOfSelectedReply = parentComment?.replies?.find((reply)=>reply?.id === currentlySelectedThreadKey);
        if (isCurrentSelectedComment || parentIdOfSelectedReply) setIsThreadPressed(true);
        else setIsThreadPressed(false);
    }, [
        currentlySelectedThreadKey,
        isCurrentSelectedComment,
        parentComment?.replies
    ]);
    const handleCommentThreadMouseDown = (0, $cozmU.useCallback)(()=>{
        onCommentThreadMouseDown?.(); /**
                                   * Limiting executions of this function because updating isThreadPressed
                                   * rerenders every component in this tree. Most notably, a user clicking into
                                   * the reply comment editor will call this function every time (and really any sibling component).
                                   * 1. isThreadPressed is only used as a style variable alongside isCurrentSelectedComment
                                   * 2. if clicking doesn't change threadKey then currentlySelectedThreadKey never changes either
                                   * which are the two variables isCurrentSelectedComment compares. We should only call this function
                                   * if threadKey has changed.
                                   */ 
        if (!isCurrentSelectedComment) setIsThreadPressed(true);
    }, [
        onCommentThreadMouseDown,
        isCurrentSelectedComment
    ]);
    const resolveProperties = parentComment.location?.inlineResolveProperties || parentComment.location?.commentResolveProperties || undefined;
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: resolveProperties
    });
    const timestamp = (0, $6faGq.formatTimestampForAriaLabel)({
        intl: intl,
        dateString: parentComment.createdAtNonLocalized,
        commentStatus: commentStatus,
        resolveProperties: resolveProperties
    });
    const testIdPrefixWithDelimiter = testIdPrefix ? `${testIdPrefix}-` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRenderCommentTypeSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $74b51dc92462c104$var$styles.commentTypeSeperatorStyle,
        testId: "comment-section-separator",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        testId: "general-comment-page-icon",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage($74b51dc92462c104$var$i18n.commentTypeSeperatorText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: commentThreadRef,
        id: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        testId: `${testIdPrefixWithDelimiter}comment-thread-${threadKey}-container`,
        xcss: (0, $w6R6I.cx)($74b51dc92462c104$var$styles.threadBoxStyles, (isCurrentSelectedComment || isThreadPressed) && $74b51dc92462c104$var$styles.selectedThreadStyles),
        "data-selected-comment-thread": isCurrentSelectedComment && parentComment.location?.inlineMarkerRef ? parentComment.location.inlineMarkerRef : undefined,
        onClick: handleCommentThreadClick,
        onMouseDown: handleCommentThreadMouseDown,
        onMouseUp: ()=>setIsThreadPressed(false),
        onKeyDown: ()=>{},
        tabIndex: 0,
        "aria-label": formatMessage($74b51dc92462c104$var$i18n.threadContentAriaLabelWithName, {
            name: parentComment.author?.displayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            timestamp: timestamp
        }),
        role: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: `${testIdPrefixWithDelimiter}comment-thread-${parentComment.id}-parent`,
        xcss: $74b51dc92462c104$var$styles.commentBodyBoxStyles
    }, commentComponent({
        comment: parentComment,
        pageInfo: pageInfo,
        pageMode: pageMode,
        isUnread: unreadCommentIDSet.has(parentComment.id),
        threadKey: threadKey,
        hideBranchingStyle: !parentHasAgentSession && parentComment.replies.length === 0 && !isEditorExpanded,
        canAddComments: canAddComments
    })), ((0, $ibqdE.getShouldShowRepliesSection)({
        replies: parentComment.replies,
        isEditorExpanded: isEditorExpanded
    }) || forceShowRepliesSection) && commentRepliesComponent({
        parentComment: parentComment,
        pageInfo: pageInfo,
        pageMode: pageMode,
        parentCommentId: parentComment.id,
        canAddComments: canAddComments,
        isEditorExpanded: isEditorExpanded
    })));
};
module.exports["BaseCommentThread"] = $74b51dc92462c104$export$a9ce751de1bf208f;

});

parcelRegister("7wP5b", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3mVfX = parcelRequire("3mVfX");


var $i6UMJ = parcelRequire("i6UMJ");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $189731c52bd04a36$var$createInlineMarkerMatcher = (parentLocation)=>(reply)=>{
        if (!reply) return false;
        const replyLocation = reply.location;
        return parentLocation.inlineMarkerRef === replyLocation.inlineMarkerRef;
    };
const $189731c52bd04a36$export$ea659f9ae26b6c6b = (parentComment, location)=>{
    const { hasNestedComments: hasNestedComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    const { replyToCommentId: replyToCommentId, location: commentLocation } = (0, $3mVfX.useCommentsPanelState)();
    return (0, $cozmU.useMemo)(()=>{
        if (location === (0, $i6UMJ.LocationValue).FOOTER) {
            if (commentLocation === (0, $i6UMJ.LocationValue).FOOTER) return parentComment.id === replyToCommentId || // Editor management depends on reply nesting configuration:
            // - With nested replies: ObjectCommentNestableReplies handles the Editor
            // - Without nested replies: Open Editor when replyToComment query parameter
            //   matches a reply's ID
            !hasNestedComments && parentComment.replies.some((reply)=>reply?.id === replyToCommentId);
            return false;
        }
        const inlineMarkerMatcher = $189731c52bd04a36$var$createInlineMarkerMatcher(parentComment.location);
        const parentReplies = parentComment.replies || [];
        const matchedReplies = parentReplies.filter(inlineMarkerMatcher);
        if (commentLocation === (0, $i6UMJ.LocationValue).PANEL) {
            const isReplyingToParent = replyToCommentId === parentComment.id;
            const isReplyingToChild = matchedReplies.some((reply)=>reply?.id === replyToCommentId);
            const canExpandForChildReply = isReplyingToChild && (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true);
            return isReplyingToParent || canExpandForChildReply;
        }
        return false;
    }, [
        commentLocation,
        hasNestedComments,
        location,
        parentComment.id,
        parentComment.location,
        parentComment.replies,
        replyToCommentId
    ]);
};
module.exports["useIsEditorExpanded"] = $189731c52bd04a36$export$ea659f9ae26b6c6b;

});

parcelRegister("g8bbY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $bGjLa = parcelRequire("bGjLa");

const $ed6d952ef1a68788$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $ed6d952ef1a68788$export$4153d6fbc2386422;

});

parcelRegister("hXzKU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("2CmnC"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: true
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("2CmnC"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: true
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("2CmnC"))).CommentEditor,
    waitForNetworkOnline: true
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE1Y8M _30huDKOeNX _0bjKvDzXzM _2sNsIgmnOE _0jFU0VuNcX _24h04i2Njc _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("2CmnC", function(module, exports) {

let $1e807d9359cac992$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1e807d9359cac992$var$load("9NKkm"),
    $1e807d9359cac992$var$load("7TMgc"),
    $1e807d9359cac992$var$load("khIi2"),
    $1e807d9359cac992$var$load("eEjUf"),
    $1e807d9359cac992$var$load("eYE9w"),
    $1e807d9359cac992$var$load("gHnIB"),
    $1e807d9359cac992$var$load("9LDVS"),
    $1e807d9359cac992$var$load("kiMHu"),
    $1e807d9359cac992$var$load("05hOp"),
    $1e807d9359cac992$var$load("h1KXn"),
    $1e807d9359cac992$var$load("6uAwN"),
    $1e807d9359cac992$var$load("bLJlF"),
    $1e807d9359cac992$var$load("7I4uK"),
    $1e807d9359cac992$var$load("hUbK8"),
    $1e807d9359cac992$var$load("6wr18"),
    $1e807d9359cac992$var$load("5cIMo"),
    $1e807d9359cac992$var$load("2xYWc"),
    $1e807d9359cac992$var$load("8JTmC"),
    $1e807d9359cac992$var$load("fOcPG"),
    $1e807d9359cac992$var$load("fb8QM"),
    $1e807d9359cac992$var$load("6pJOz"),
    $1e807d9359cac992$var$load("2cIiG"),
    $1e807d9359cac992$var$load("kQBNY"),
    $1e807d9359cac992$var$load("l7n3D"),
    $1e807d9359cac992$var$load("2j57H"),
    $1e807d9359cac992$var$load("aVpwX"),
    $1e807d9359cac992$var$load("cGwzL"),
    $1e807d9359cac992$var$load("gsHot"),
    $1e807d9359cac992$var$load("03zSE"),
    $1e807d9359cac992$var$load("b9Ivi"),
    $1e807d9359cac992$var$load("lPKve"),
    $1e807d9359cac992$var$load("dmzjI"),
    $1e807d9359cac992$var$load("jrIva"),
    $1e807d9359cac992$var$load("7OhMs"),
    $1e807d9359cac992$var$load("1cObh"),
    $1e807d9359cac992$var$load("5SsDI"),
    $1e807d9359cac992$var$load("aKpCc"),
    $1e807d9359cac992$var$load("fRhcd"),
    $1e807d9359cac992$var$load("ctjb9"),
    $1e807d9359cac992$var$load("8bbHb"),
    $1e807d9359cac992$var$load("VXbA1"),
    $1e807d9359cac992$var$load("kfGHh"),
    $1e807d9359cac992$var$load("lIiD7"),
    $1e807d9359cac992$var$load("bJbqV"),
    $1e807d9359cac992$var$load("hLB9K"),
    $1e807d9359cac992$var$load("hpDuu"),
    $1e807d9359cac992$var$load("lWstc"),
    $1e807d9359cac992$var$load("dxcsb"),
    $1e807d9359cac992$var$load("gQrOI"),
    $1e807d9359cac992$var$load("fYx6U"),
    $1e807d9359cac992$var$load("botpL"),
    $1e807d9359cac992$var$load("7SteV"),
    $1e807d9359cac992$var$load("Msrsx"),
    $1e807d9359cac992$var$load("cGkFm"),
    $1e807d9359cac992$var$load("3o22b"),
    $1e807d9359cac992$var$load("64USq"),
    $1e807d9359cac992$var$load("ffEVr"),
    $1e807d9359cac992$var$load("98mMk"),
    $1e807d9359cac992$var$load("8jD8D"),
    $1e807d9359cac992$var$load("cZjWF"),
    $1e807d9359cac992$var$load("lIK0s"),
    $1e807d9359cac992$var$load("gaUhx"),
    $1e807d9359cac992$var$load("9TOep"),
    $1e807d9359cac992$var$load("bncmK"),
    $1e807d9359cac992$var$load("YPUYk"),
    $1e807d9359cac992$var$load("hhss7"),
    $1e807d9359cac992$var$load("7EorR"),
    $1e807d9359cac992$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("b4BfG", function(module, exports) {

var $hMac6 = parcelRequire("hMac6");


var $cozmU = parcelRequire("cozmU");


var $g8bbY = parcelRequire("g8bbY");


var $koEBx = parcelRequire("koEBx");


var $jMyy4 = parcelRequire("jMyy4");


var $hXzKU = parcelRequire("hXzKU");


var $emtVP = parcelRequire("emtVP");


var $gurMq = parcelRequire("gurMq");


var $4rKYp = parcelRequire("4rKYp");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

const $a75b2138c8eb75e6$export$b9905c4f8315d0a1 = ({ mode: mode, saveHandler: saveHandler, cancelHandler: cancelHandler, onEditorLoaded: onEditorLoaded, onEditorReady: onEditorReady, onEditorContentChanged: onEditorContentChanged, onEditorContentChangedWithData: onEditorContentChangedWithData, afterActivate: afterActivate, content: content, useNewExperienceAbort: useNewExperienceAbort, expandEditor: expandEditor, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment = false, isOffline: isOffline = false, showAgentMentionFyiNudge: showAgentMentionFyiNudge = true })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: showAgentMentionFyiNudge && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    });
    // Track whether the FYI component has ever been shown, so we only load the
    // chunk on first mention but keep it mounted for the collapse animation.
    const hasShownFyiRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const handleContentChangeWithData = (0, $cozmU.useCallback)((hasChanges, adf)=>{
        onEditorContentChangedWithData?.(hasChanges, adf);
        onAgentMentionContentChange(adf);
    }, [
        onEditorContentChangedWithData,
        onAgentMentionContentChange
    ]);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hMac6.default), {
        variables: {
            contentId: contentId ?? ''
        },
        skip: !contentId,
        __callerPackage__: "comment-simple"
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const operations = (0, $cozmU.useMemo)(()=>data?.content?.nodes?.[0]?.operations ?? [], [
        data
    ]);
    // User space permissions - only access when feature gate is on
    const spaceOperations = (0, $cozmU.useMemo)(()=>// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? data?.content?.nodes?.[0]?.space?.operations || [] : [], [
        data
    ]);
    const canAddComment = (0, $cozmU.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment'), [
        operations
    ]);
    const canAddAttachment = (0, $cozmU.useMemo)(()=>operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'), [
        operations,
        spaceOperations
    ]);
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    // Simulate the unmount function for the other editor
    (0, $cozmU.useEffect)(()=>()=>{
            cancelHandler({
                isEditorAborted: false
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $cozmU.useEffect)(()=>{
        const handleExperienceAbort = ()=>{
            const reason = 'Navigated away from page';
            if (mode === 'edit') experienceTracker.abort({
                name: (0, $irVI7.EDIT_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else if (mode === 'reply') experienceTracker.abort({
                name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
            else experienceTracker.abort({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                reason: reason
            });
        };
        if (useNewExperienceAbort) window.addEventListener('beforeunload', handleExperienceAbort);
        return ()=>{
            if (useNewExperienceAbort) window.removeEventListener('beforeunload', handleExperienceAbort);
        };
    }, [
        experienceTracker,
        mode,
        useNewExperienceAbort
    ]);
    const handleSave = (0, $cozmU.useCallback)((adf, onSuccess)=>saveHandler({
            adf: adf
        }, onSuccess).then((result)=>{
            if ((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) {
                // `result` is { id: comment.id } returned by the parent saveHandler
                // (ObjectAddCommentEditor or CommentsPanelFooter) after the mutation resolves.
                const commentId = result?.id ?? '';
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, contentId ?? '', commentId, userId ?? undefined, 'footer');
            }
            return result;
        }).catch((err)=>{
            // There is another handler higher up to re-enable the buttons, throw the error to allow for that
            throw err;
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        saveHandler,
        cloudId,
        contentId,
        userId
    ]);
    const handleCancel = (0, $cozmU.useCallback)((params)=>{
        // handleCancel() is invoked by CommentEditor on its destruction, with
        // `destroy` set to true. In this case, `isEditorAborted` should be
        // false since user didn't explicitly abort commenting. If user did
        // abort, `destroy` will be false, and we should pass `isEditorAborted`
        // as true into cancelHandler().
        cancelHandler({
            isEditorAborted: !params?.destroy
        });
    }, [
        cancelHandler
    ]);
    const handleEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        onEditorLoaded();
        onEditorReady?.(editorActions);
    }, [
        onEditorLoaded,
        onEditorReady
    ]);
    const agentMentionFyiNudge = showAgentMentionFyiNudge && (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
        visible: showFyi,
        agent: agent
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, agentMentionFyiNudge, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXzKU.LazyCommentEditorWithoutSpinner), {
        pageId: contentId,
        pageType: contentType,
        appearance: isCommentsPanel ? 'chromeless' : 'comment',
        EditorComponent: isCommentsPanel ? (0, $koEBx.ChromelessEditor) : (0, $g8bbY.CommentEditor),
        commentMode: mode,
        commentType: "page",
        spaceId: spaceId,
        onSaveComment: handleSave,
        content: content,
        onCancelComment: handleCancel,
        onEditorReady: handleEditorReady,
        onContentChange: onEditorContentChanged,
        onContentChangeWithData: handleContentChangeWithData,
        afterActivation: afterActivate,
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        shouldWarnOnInternalNavigation: true,
        expandEditor: expandEditor,
        showCancelButton: isCommentsPanel || isFooterComment,
        useNewWarningModal: isCommentsPanel || isFooterComment,
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isOffline: isOffline
    }));
};
module.exports["PageCommentEditor"] = $a75b2138c8eb75e6$export$b9905c4f8315d0a1;

});

parcelRegister("hMac6", function(module, exports) {
/**
 * @generated SignedSource<<559b8c3f2a1f2883141ee4463673d17c>>
 * @relayHash 84a9c75863296610fb60639c2398b5f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608
const $e6c37684dc7bdb3d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageCommentEditorContentOperationsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "84a9c75863296610fb60639c2398b5f3",
            "id": "f321b87f1a8e3715be97d9ac819a91c2907f9e50ea59fc606e85f9a1eb716608",
            "metadata": {},
            "name": "PageCommentEditorContentOperationsQuery",
            "operationKind": "query",
            "text": "query PageCommentEditorContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}}}"
        }
    };
}();
$e6c37684dc7bdb3d$var$node.hash = "84986896d9e1b1e2bb0707f822adf359";
var $e6c37684dc7bdb3d$export$2e2bcd8739ae039 = $e6c37684dc7bdb3d$var$node;
module.exports["default"] = $e6c37684dc7bdb3d$export$2e2bcd8739ae039;

});

parcelRegister("koEBx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $eJlpI = parcelRequire("eJlpI");

const $6173d76fe85d4dd6$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $eJlpI.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $eJlpI.default)
    });
};
module.exports["ChromelessEditor"] = $6173d76fe85d4dd6$export$5252bd745392dcde;

});

parcelRegister("gurMq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emtVP = parcelRequire("emtVP");

function $c813792041e0815a$export$814a52618fb8e5d7({ enabled: enabled = true, cloudId: cloudId } = {}) {
    const [showFyi, setShowFyi] = (0, $cozmU.useState)(false);
    const [agent, setAgent] = (0, $cozmU.useState)();
    // Per-editor cache of mention-id → resolved agent identity (or null when the id
    // is not an agent). Guarantees each distinct id hits the agents endpoint at most
    // once. `inFlight` dedupes concurrent resolutions for the same id.
    const cacheRef = (0, $cozmU.useRef)(new Map());
    const inFlightRef = (0, $cozmU.useRef)(new Set());
    const abortControllersRef = (0, $cozmU.useRef)(new Set());
    // Ids of the latest non-fast-path mention candidates, so async resolutions can
    // re-evaluate visibility against the current doc.
    const latestCandidateIdsRef = (0, $cozmU.useRef)([]);
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        mountedRef.current = true;
        // Capture the (stable, never-reassigned) ref-held collections so the cleanup
        // operates on the same objects without reading `.current` at teardown
        // (satisfies react-hooks/exhaustive-deps).
        const abortControllers = abortControllersRef.current;
        const inFlight = inFlightRef.current;
        return ()=>{
            mountedRef.current = false;
            abortControllers.forEach((controller)=>controller.abort());
            abortControllers.clear();
            inFlight.clear();
        };
    }, []);
    // Re-derive showFyi/agent from the cache for the current doc's mention ids.
    const applyFromCache = (0, $cozmU.useCallback)(()=>{
        const knownAgent = latestCandidateIdsRef.current.map((id)=>cacheRef.current.get(id)).find((value)=>!!value);
        setShowFyi(!!knownAgent);
        setAgent((prev)=>{
            if (!knownAgent) return undefined;
            return prev?.id === knownAgent.id && prev?.name === knownAgent.name && prev?.agentNamedId === knownAgent.agentNamedId ? prev : knownAgent;
        });
    }, []);
    const onContentChange = (0, $cozmU.useCallback)((adf)=>{
        if (!enabled) return;
        // Fast path — a freshly-typed agent mention still carries userType==='APP'.
        const fastPath = (0, $emtVP.extractAgentMentionFromAdf)(adf);
        if (fastPath) {
            const id = fastPath.agentId;
            latestCandidateIdsRef.current = [];
            setShowFyi(true);
            // Show the name immediately; reuse any avatar key already resolved for this id.
            const cached = cacheRef.current.get(id);
            setAgent((prev)=>{
                const next = {
                    id: id,
                    name: fastPath.agentName,
                    agentNamedId: cached?.agentNamedId
                };
                return prev?.id === next.id && prev?.name === next.name && prev?.agentNamedId === next.agentNamedId ? prev : next;
            });
            // The fast path is otherwise network-free, so an OOTB agent (e.g. Canva) would render the
            // generic fallback avatar. Resolve once (cached) to enrich with the real avatar key. We
            // already KNOW this is an agent (userType==='APP'), so a failed/empty resolve keeps the
            // baseline rather than hiding the nudge.
            if (cloudId && !cacheRef.current.has(id) && !inFlightRef.current.has(id)) {
                inFlightRef.current.add(id);
                const controller = new AbortController();
                abortControllersRef.current.add(controller);
                (0, $emtVP.resolveAgentFromMentionId)(id, cloudId, controller.signal).then((resolved)=>{
                    abortControllersRef.current.delete(controller);
                    inFlightRef.current.delete(id);
                    if (!mountedRef.current) return;
                    // Cache the result — even null — so a failed/non-agent resolution isn't
                    // retried on every subsequent keystroke (the `.has(id)` guard short-circuits).
                    cacheRef.current.set(id, resolved);
                    if (!resolved) return;
                    setAgent((prev)=>prev?.id === id ? {
                            ...prev,
                            agentNamedId: resolved.agentNamedId
                        } : prev);
                }).catch(()=>{
                    abortControllersRef.current.delete(controller);
                    inFlightRef.current.delete(id);
                });
            }
            return;
        }
        // Fallback — userType may have been stripped (paste / reloaded comment).
        // Only mentions that have LOST their userType need id-resolution; live
        // mentions carry a userType (APP is handled by the fast path above, any
        // other type is not an agent), so they are skipped to avoid wasted calls.
        const candidateIds = (0, $emtVP.extractUnresolvedMentionIds)(adf);
        latestCandidateIdsRef.current = candidateIds;
        // Reflect anything already cached immediately (no flicker, no refetch).
        applyFromCache();
        // The async fallback needs a cloudId to call the agents endpoint.
        if (!cloudId) return;
        for (const id of candidateIds){
            if (cacheRef.current.has(id) || inFlightRef.current.has(id)) continue; // already resolved, or a resolution is already in flight
            inFlightRef.current.add(id);
            const controller = new AbortController();
            abortControllersRef.current.add(controller);
            (0, $emtVP.resolveAgentFromMentionId)(id, cloudId, controller.signal).then((resolved)=>{
                abortControllersRef.current.delete(controller);
                inFlightRef.current.delete(id);
                if (!mountedRef.current) return;
                cacheRef.current.set(id, resolved);
                applyFromCache();
            }).catch(()=>{
                // resolveAgentFromMentionId is not expected to reject (it catches
                // internally), but guard defensively so a future refactor — or a
                // throw from applyFromCache — can't surface an unhandled rejection
                // or leave the id stuck in-flight. The nudge is best-effort.
                abortControllersRef.current.delete(controller);
                inFlightRef.current.delete(id);
            });
        }
    }, [
        enabled,
        cloudId,
        applyFromCache
    ]);
    return (0, $cozmU.useMemo)(()=>({
            showFyi: showFyi,
            agent: agent,
            onContentChange: onContentChange
        }), [
        showFyi,
        agent,
        onContentChange
    ]);
}
module.exports["useAgentMentionFyiNudge"] = $c813792041e0815a$export$814a52618fb8e5d7;

});

parcelRegister("4rKYp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $016f78fedc012cce$export$c82fcdcb4a4bd17 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YwMBi",
    name: "AgentMentionFyiNudgeAsync",
    loader: async ()=>(await (parcelRequire("3mLV0"))).AgentMentionFyiNudge
});
module.exports["AgentMentionFyiNudgeAsync"] = $016f78fedc012cce$export$c82fcdcb4a4bd17;

});

parcelRegister("3mLV0", function(module, exports) {

let $273898c62ad6016a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $273898c62ad6016a$var$load("7EorR"),
    $273898c62ad6016a$var$load("jqoep"),
    $273898c62ad6016a$var$load("l64sb")
]).then(()=>parcelRequire('kz0zp'));

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            // This preloader explicitly opts in to reactions above, so its nodes satisfy the legacy
            // Comment model even though Relay correctly makes conditionally selected fields optional.
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("llqlc", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

function $64e7b9256d090f27$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $64e7b9256d090f27$export$3dea766d36a8935f;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$export$2512ab5eef87236d = [
    'attachments',
    'blog-posts',
    'change-history',
    'contributors',
    'detailssummary',
    'iframe',
    'include',
    'pagetree',
    'pagetreesearch',
    'profile',
    'profile-picture',
    'recently-updated',
    'viewpdf',
    'viewxls',
    'widget',
    'contentbylabel',
    'listlabels',
    'popular-labels',
    'tasks-report-macro'
];
const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'blog-posts':
        case 'change-history':
        case 'contentbylabel':
        case 'detailssummary':
        case 'iframe':
        case 'include':
        case 'popular-labels':
        case 'profile':
        case 'profile-picture':
        case 'viewxls':
        case 'viewpdf':
        case 'widget':
            return true;
        case 'listlabels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_listlabels_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return true;
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'attachments':
            return (0, $6mKj3.expValEquals)('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
        case 'tasks-report-macro':
            return (0, $6mKj3.expValEquals)('cc_rewrite_tasks_report_macro', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>$c9f3102bc65ac225$export$2512ab5eef87236d.includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["MIGRATED_MACRO_EXTENSION_KEYS"] = $c9f3102bc65ac225$export$2512ab5eef87236d;
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("3g6pL"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("3g6pL"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("3g6pL", function(module, exports) {

let $25f7d787f0a0db11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $25f7d787f0a0db11$var$load("05hOp"),
    $25f7d787f0a0db11$var$load("h1KXn"),
    $25f7d787f0a0db11$var$load("6wr18"),
    $25f7d787f0a0db11$var$load("jYRaq"),
    $25f7d787f0a0db11$var$load("7G12e"),
    $25f7d787f0a0db11$var$load("io0qR"),
    $25f7d787f0a0db11$var$load("ffEVr"),
    $25f7d787f0a0db11$var$load("9TOep"),
    $25f7d787f0a0db11$var$load("bncmK"),
    $25f7d787f0a0db11$var$load("7EorR"),
    $25f7d787f0a0db11$var$load("hhss7"),
    $25f7d787f0a0db11$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("6RucW"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("6RucW"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("6RucW", function(module, exports) {

let $4fef1ff26d1aa4b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4fef1ff26d1aa4b2$var$load("7Rf3l"),
    $4fef1ff26d1aa4b2$var$load("ctjb9"),
    $4fef1ff26d1aa4b2$var$load("8bbHb"),
    $4fef1ff26d1aa4b2$var$load("cZjWF"),
    $4fef1ff26d1aa4b2$var$load("lIK0s"),
    $4fef1ff26d1aa4b2$var$load("gaUhx"),
    $4fef1ff26d1aa4b2$var$load("fWCBZ"),
    $4fef1ff26d1aa4b2$var$load("6wr18"),
    $4fef1ff26d1aa4b2$var$load("5EJB0"),
    $4fef1ff26d1aa4b2$var$load("bqdgP"),
    $4fef1ff26d1aa4b2$var$load("i7NGK"),
    $4fef1ff26d1aa4b2$var$load("fYx6U"),
    $4fef1ff26d1aa4b2$var$load("botpL"),
    $4fef1ff26d1aa4b2$var$load("excC5"),
    $4fef1ff26d1aa4b2$var$load("8bEF3"),
    $4fef1ff26d1aa4b2$var$load("gRItA"),
    $4fef1ff26d1aa4b2$var$load("cGkFm"),
    $4fef1ff26d1aa4b2$var$load("3o22b"),
    $4fef1ff26d1aa4b2$var$load("64USq"),
    $4fef1ff26d1aa4b2$var$load("ffEVr"),
    $4fef1ff26d1aa4b2$var$load("f6ZVy"),
    $4fef1ff26d1aa4b2$var$load("20wSi"),
    $4fef1ff26d1aa4b2$var$load("9LDVS"),
    $4fef1ff26d1aa4b2$var$load("kiMHu"),
    $4fef1ff26d1aa4b2$var$load("05hOp"),
    $4fef1ff26d1aa4b2$var$load("h1KXn"),
    $4fef1ff26d1aa4b2$var$load("fwbNS"),
    $4fef1ff26d1aa4b2$var$load("ckGjo"),
    $4fef1ff26d1aa4b2$var$load("gFeoL"),
    $4fef1ff26d1aa4b2$var$load("YPUYk"),
    $4fef1ff26d1aa4b2$var$load("hhss7"),
    $4fef1ff26d1aa4b2$var$load("9NKkm"),
    $4fef1ff26d1aa4b2$var$load("aAWLw"),
    $4fef1ff26d1aa4b2$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("jrCh2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27e3a4c5ffdab0c$export$2e2bcd8739ae039);
function $e27e3a4c5ffdab0c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("cJomY", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $284f81bf601d8436$var$editedContentStyles = {
    root: "_1UtDYzKGUX"
};
const $284f81bf601d8436$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $hekY6.default)([
            $284f81bf601d8436$var$editedContentStyles.root
        ]),
        children: children
    });
$284f81bf601d8436$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $284f81bf601d8436$export$2e2bcd8739ae039 = $284f81bf601d8436$var$Edited;
module.exports["default"] = $284f81bf601d8436$export$2e2bcd8739ae039;

});

parcelRegister("gQEZd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4414baec8e12e18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7D31j = parcelRequire("7D31j");


var $3yGK6 = parcelRequire("3yGK6");

function $c4414baec8e12e18$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $3yGK6.default)(1, arguments);
    var originalDate = (0, $dkBOe.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $7D31j.default)(originalDate.getDate(), 2);
        var month = (0, $7D31j.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $7D31j.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7D31j.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7D31j.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $7D31j.default)(originalDate.getHours(), 2);
        var minute = (0, $7D31j.default)(originalDate.getMinutes(), 2);
        var second = (0, $7D31j.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_iconNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("dlR4F", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $3116f884d3c1f788$export$19044a29afb3da0c = (0, $dSoGR.createCommand)('start-background-agent-conversation-command');
module.exports["StartBackgroundAgentConversationCommand"] = $3116f884d3c1f788$export$19044a29afb3da0c;

});

parcelRegister("cbxPV", function(module, exports) {
/// <reference lib="dom" />
/* eslint-env browser */ const $8df0c25ce2bb715f$var$element = document.createElement('i');
function $8df0c25ce2bb715f$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $8df0c25ce2bb715f$var$element.innerHTML = characterReference;
    const char = $8df0c25ce2bb715f$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}
module.exports["decodeNamedCharacterReference"] = $8df0c25ce2bb715f$export$289b6a6320f709b4;

});

parcelRegister("6x5cj", function(module, exports) {
const $4c19db43d4ebe254$var$tab = 9 /* `\t` */ ;
const $4c19db43d4ebe254$var$space = 32 /* ` ` */ ;
function $4c19db43d4ebe254$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($4c19db43d4ebe254$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($4c19db43d4ebe254$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $4c19db43d4ebe254$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $4c19db43d4ebe254$var$tab || code === $4c19db43d4ebe254$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $4c19db43d4ebe254$var$tab || code === $4c19db43d4ebe254$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}
module.exports["trimLines"] = $4c19db43d4ebe254$export$a771f20bdd13def9;

});

parcelRegister("hoXSS", function(module, exports) {
/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $cab3214b6aa77065$var$own = {}.hasOwnProperty;
function $cab3214b6aa77065$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $cab3214b6aa77065$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $cab3214b6aa77065$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}
module.exports["zwitch"] = $cab3214b6aa77065$export$d6a12bfbbedf6185;

});

parcelRegister("3UYxt", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");

var $6fil2 = parcelRequire("6fil2");


var $7W8i8 = parcelRequire("7W8i8");

// Console diagnostics for local and dogfooding debugging. Opt in per session with
// sessionStorage.setItem('confluence.enable-logging', 'true') — silent for everyone else, and
// a no-op under NODE_ENV=testing.
//
// Never log identifiers. Not prompt content, and not contentId or agentIdentityAccountId either:
// the console is copied into tickets and screenshots, so keep it to the categorical shape of what
// happened — reason and status code. The identifiers are already visible in the network panel to
// anyone debugging a specific request.
const $ce75296042250ccb$var$logger = (0, $7W8i8.getLogger)('recordAgenticView');
// Served by conversational-ai-platform (ConfluenceAgenticViewV1Controller). Convo AI makes
// the ASAP S2S hop to Confluence's /wiki/api/v2/pages/{id}/agentic/view endpoint; the browser
// cannot call that endpoint directly.
const $ce75296042250ccb$var$AGENTIC_VIEW_URL = '/gateway/api/assist/api/confluence/v1/agentic-views';
var $ce75296042250ccb$export$3bdc8aca6e4e8d8f = /*#__PURE__*/ function(AgenticViewFailureReason) {
    /** 400 — the request violated the service contract. A bug on our side, not a service fault. */ AgenticViewFailureReason["BAD_REQUEST"] = "badRequest";
    /** 401 / 403 — the user may not record presence for this page. */ AgenticViewFailureReason["FORBIDDEN"] = "forbidden";
    /**
   * 404 — no route matched. Until CEPS-13034 adds this path to the Stargate service policy
   * allowlist, *every* call fails this way; afterwards it means the page no longer exists.
   * Expect this reason to dominate until that ticket lands.
   */ AgenticViewFailureReason["NOT_FOUND"] = "notFound";
    /** 429 — Stargate or Convo AI is shedding load. */ AgenticViewFailureReason["RATE_LIMITED"] = "rateLimited";
    /** 5xx — Convo AI or NCS is unhealthy. */ AgenticViewFailureReason["SERVER_ERROR"] = "serverError";
    /** No response at all — the user's connectivity, not a service fault. */ AgenticViewFailureReason["NETWORK"] = "network";
    /** Anything else, including a non-Error throw. */ AgenticViewFailureReason["UNKNOWN"] = "unknown";
    return AgenticViewFailureReason;
}({});
/**
 * Emits one operational event, absorbing anything it throws. Reporting is best-effort: the
 * call site voids this client's promise, so a throw while reporting would surface as an
 * unhandled rejection rather than as a report.
 */ const $ce75296042250ccb$var$fireOperationalEvent = (createAnalyticsEvent, action, attributes)=>{
    try {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: action,
                actionSubject: 'agenticViewPresence',
                source: 'AIMate',
                tags: [
                    'aiMate'
                ],
                ...attributes && {
                    attributes: attributes
                }
            }
        }).fire();
    } catch  {
    // Intentionally swallowed — see above.
    }
};
/**
 * The status codes that have a dedicated reason, as data. 5xx is deliberately absent: it is a
 * range rather than a set of codes, so it stays a comparison in `reasonForStatusCode`.
 *
 * `Partial<Record<…>>` rather than `Record<…>` on purpose. Confluence does not enable
 * `noUncheckedIndexedAccess`, so a total `Record` would type every lookup as already resolved and
 * make the fallback below read as unreachable — when in fact it is what handles every 5xx.
 */ const $ce75296042250ccb$var$REASON_BY_STATUS_CODE = {
    400: "badRequest",
    // One reason for two codes: whether the caller is unauthenticated or merely unauthorised is not
    // a distinction worth its own failure bucket here.
    401: "forbidden",
    403: "forbidden",
    404: "notFound",
    // Reached by RateLimitedError as well as a plain BadStatusError — see `classifyFailure`.
    429: "rateLimited"
};
const $ce75296042250ccb$var$reasonForStatusCode = (statusCode)=>$ce75296042250ccb$var$REASON_BY_STATUS_CODE[statusCode] ?? (statusCode >= 500 ? "serverError" : "unknown");
const $ce75296042250ccb$var$classifyFailure = (error)=>{
    // Checked before the generic network case because BadStatusError extends NetworkError.
    // RateLimitedError extends BadStatusError and does not override `name`, so 429 lands here too.
    if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) {
        const statusCode = error.response.status;
        return {
            reason: $ce75296042250ccb$var$reasonForStatusCode(statusCode),
            statusCode: statusCode
        };
    }
    if (error instanceof Error && (0, $6fil2.containsNetworkError)(error)) return {
        reason: "network"
    };
    return {
        reason: "unknown"
    };
};
const $ce75296042250ccb$export$925de989b5b3a909 = async (payload, cloudId, createAnalyticsEvent, telemetryAttributes)=>{
    // The denominator. Emitted before the request rather than after a 2xx, because a 204 cannot
    // distinguish "presence recorded" from "Convo AI's own gate is off" — an `attempted` count is
    // something this client can honestly assert, a success count is not. Paired with `failed`
    // it yields a failure rate; compared against platform's `aiMate onPromptSentInvoked` it
    // shows how many invocations this package's guards and experiment filtered out.
    $ce75296042250ccb$var$fireOperationalEvent(createAnalyticsEvent, 'attempted', telemetryAttributes);
    $ce75296042250ccb$var$logger.debug`Recording agent view presence for pageContext=${payload.pageContext}`;
    try {
        await (0, $f7B1p.cfetch)($ce75296042250ccb$var$AGENTIC_VIEW_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Product': 'confluence',
                // Not free text. Convo AI resolves this against a closed enum (`Experience.kt` in
                // conversational-ai-platform) in a request filter, before the controller deserialises
                // the body; an unregistered id throws `ExperienceIdNotFoundException`, which extends
                // `BadRequestException`, so it 400s. A descriptive
                // `confluence-agent-chat-view-presence` was rejected exactly that way.
                //
                // `ai-mate` is registered for all products and describes this surface accurately: the
                // write is a side effect of a Rovo Chat prompt. The cost is attribution — these calls
                // are indistinguishable from the rest of Rovo Chat in experience-level metrics, so the
                // `agenticViewPresence` operational events above are how this path gets measured.
                // A dedicated experience needs a conversational-ai-platform change: an `Experience`
                // entry plus a branch in `FeatureConfigServiceImpl`, whose `when` is exhaustive.
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': cloudId
            },
            body: JSON.stringify(payload),
            // Presence is a background side effect. Without this, a genuine connectivity failure
            // flips the global connection status to OFFLINE via the cfetch subscriber in
            // graphql/src/createClient.ts, showing an offline indicator for something the user
            // never initiated. Non-2xx responses take a different path and cannot do this.
            ignoreNoNetworkError: true
        });
        // Not "recorded" — the service also 204s when its own gate is off. See above.
        $ce75296042250ccb$var$logger.debug`Request accepted. A 2xx does not confirm presence was recorded: Convo AI returns 204 with CONFLUENCE_AGENTIC_VIEW_PRESENCE off too.`;
    } catch (error) {
        const { reason: reason, statusCode: statusCode } = $ce75296042250ccb$var$classifyFailure(error);
        // Mirrors the operational event exactly, and deliberately nothing more. The raw error
        // object is not logged: it carries the Response, and the full detail plus a stack trace
        // already reaches on-call through submitError below.
        $ce75296042250ccb$var$logger.error`Failed to record agent view presence: reason=${reason} statusCode=${statusCode}`;
        $ce75296042250ccb$var$fireOperationalEvent(createAnalyticsEvent, 'failed', {
            ...telemetryAttributes,
            reason: reason,
            ...statusCode !== undefined && {
                statusCode: statusCode
            }
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).AI_MATE
        });
    }
};
module.exports["recordAgenticView"] = $ce75296042250ccb$export$925de989b5b3a909;

});

parcelRegister("lvJqX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_4bt5LAIZbP _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _1EqgXlhPwX _0NUa3rhPwX",
    rootStyles: "_3iDTPbvbI6 _1EqgXlN91d _4GplSjDF1i _2fqI0W7iY9",
    pressableStyles: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL4Pgdg _3iDTPbccYA _0KLXru66of _1UtDYzZpcK _1ANEUSLRg7 _1mT5xdRAKS _0hPCNLQame _1EqgXlN91d _0jFU0VIZbP _39xV02IZbP _1RrJLiQame _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_2bHMMpZFWO",
    confirmation: "_2bHMMpfyEX",
    info: "_2bHMMpTNil",
    warning: "_2bHMMpspgB",
    error: "_2bHMMp7j8z"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles,
                children: children
            });
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    as: "span",
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            as: "span",
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            });
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            className: t9,
            children: t13
        });
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $7c29b2adacb89176$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_1UtDYzZFWO",
    confirmation: "_1UtDYzfyEX",
    info: "_1UtDYzTNil",
    warning: "_1UtDYzspgB",
    error: "_1UtDYz7j8z"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_1UtDYzDF1i"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("6hmtW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $cozmU.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $cozmU.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $cozmU.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $cozmU.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $cozmU.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
        this.syncActiveCommentMarkersHandler = undefined;
        this.focusCommentHandler = undefined;
        this.pendingFocusCommentId = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    /**
   * Register a handler for active comment marker updates (called by CFE)
   * @param handler - Receives the `inlineMarkerRef` of each inline comment in the
   * content, in display order
   * @see syncActiveCommentMarkers for the counterpart method
   */ registerSyncActiveCommentMarkers(handler) {
        this.syncActiveCommentMarkersHandler = handler;
    }
    /**
   * Replaces the active comment markers (fired by content types) Content Types -> CFE
   * @param markerRefs - The `inlineMarkerRef` of each inline comment in the content, in
   * display order
   * @see registerSyncActiveCommentMarkers for the counterpart method
   */ syncActiveCommentMarkers(markerRefs) {
        this.syncActiveCommentMarkersHandler?.(markerRefs);
    }
    /**
   * Register a handler for focus comment requests (called by CFE). A request made before a
   * handler was registered is delivered to the new handler.
   * @param handler - Receives the ID of the comment or reply to focus
   * @see focusComment for the counterpart method
   */ registerFocusCommentHandler(handler) {
        this.focusCommentHandler = handler;
        if (handler && this.pendingFocusCommentId) {
            const commentId = this.pendingFocusCommentId;
            this.pendingFocusCommentId = undefined;
            handler(commentId);
        }
    }
    /**
   * Opens the comments panel on a comment or reply (fired by content types) Content Types -> CFE
   * @param commentId - The ID of the comment or reply to focus
   * @see registerFocusCommentHandler for the counterpart method
   */ focusComment(commentId) {
        if (this.focusCommentHandler) {
            this.focusCommentHandler(commentId);
            return;
        }
        this.pendingFocusCommentId = commentId;
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.syncActiveCommentMarkersHandler = void 0;
        this.focusCommentHandler = void 0;
        // The content type may ask to focus a comment before Confluence has registered the handler
        // (for example straight after the content loads), so the latest request is kept until then.
        this.pendingFocusCommentId = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
        this.syncActiveCommentMarkersHandler = undefined;
        this.focusCommentHandler = undefined;
        this.pendingFocusCommentId = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("7B9wr", function(module, exports) {

var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $4fcnd = parcelRequire("4fcnd");

const $e0dcf0245d0f4db8$export$8ee67841592dfd9f = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const hasReceivedActiveCommentMarkers = (0, $4fcnd.useHasReceivedActiveCommentMarkers)(contentId);
    if (contentType === (0, $1ggpj.ContentType).SLIDE) // Slides supply orderedActiveAnnotationIdList after their iframe loads, so the list
    // is empty until then. Returning true while the list is empty would show every
    // thread under "Deleted content", so this hook returns false until the list has
    // arrived.
    return hasReceivedActiveCommentMarkers;
    // Databases and the other canvas content types never populate
    // orderedActiveAnnotationIdList.
    return contentType !== (0, $1ggpj.ContentType).DATABASE && !(0, $1ggpj.isCanvasContentType)(contentType);
};
module.exports["useIsNewDanglingCommentExperienceEnabled"] = $e0dcf0245d0f4db8$export$8ee67841592dfd9f;

});

parcelRegister("4fcnd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Tracks whether an embedded content type, such as Slides, has supplied
 * `orderedActiveAnnotationIdList` for the current content.
 *
 * Pages fill that list while rendering, so it is complete as soon as the page appears.
 * Content types rendered in an iframe send it over the bridge after the iframe loads.
 * Before that, the list is empty because it has not arrived yet, not because the content
 * has no comments, so the comments panel must not classify every thread as dangling.
 */ // Only one content is mounted at a time, so the most recent content ID is enough.
let $1b7637b30ec05411$var$receivedForContentId;
const $1b7637b30ec05411$var$subscribers = new Set();
const $1b7637b30ec05411$var$notifySubscribers = ()=>{
    $1b7637b30ec05411$var$subscribers.forEach((callback)=>{
        callback();
    });
};
const $1b7637b30ec05411$var$subscribe = (callback)=>{
    $1b7637b30ec05411$var$subscribers.add(callback);
    return ()=>{
        $1b7637b30ec05411$var$subscribers.delete(callback);
    };
};
const $1b7637b30ec05411$export$e9ddda3d887e104 = (contentId)=>{
    if ($1b7637b30ec05411$var$receivedForContentId === contentId) return;
    $1b7637b30ec05411$var$receivedForContentId = contentId;
    $1b7637b30ec05411$var$notifySubscribers();
};
const $1b7637b30ec05411$export$500ace78cfb4fcb9 = (contentId)=>{
    const getSnapshot = (0, $cozmU.useCallback)(()=>contentId !== undefined && $1b7637b30ec05411$var$receivedForContentId === contentId, [
        contentId
    ]);
    return (0, $cozmU.useSyncExternalStore)($1b7637b30ec05411$var$subscribe, getSnapshot, getSnapshot);
};
const $1b7637b30ec05411$export$132d646a1c8fd5be = ()=>{
    $1b7637b30ec05411$var$receivedForContentId = undefined;
    $1b7637b30ec05411$var$subscribers.clear();
};
module.exports["markActiveCommentMarkersReceived"] = $1b7637b30ec05411$export$e9ddda3d887e104;
module.exports["useHasReceivedActiveCommentMarkers"] = $1b7637b30ec05411$export$500ace78cfb4fcb9;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<600f249b6150b2ccef97c67793fc3512>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $a6t12 = parcelRequire("a6t12");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== style || $[13] !== teamsAppPersonProfileUrl || $[14] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: teamsAppPersonProfileUrl,
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = style;
        $[13] = teamsAppPersonProfileUrl;
        $[14] = userId;
        $[15] = t7;
    } else t7 = $[15];
    const renderNameComponent = t7;
    let t8;
    if ($[16] !== fullName || $[17] !== hasViewUserProfilePermission || $[18] !== isAnonymous || $[19] !== renderNameComponent || $[20] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[16] = fullName;
        $[17] = hasViewUserProfilePermission;
        $[18] = isAnonymous;
        $[19] = renderNameComponent;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    let t0;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== to || $[8] !== url) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: url,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = to;
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    return t0;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("apWEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7959bd06e7aba5a6$export$2e2bcd8739ae039);

var $jb2R2 = parcelRequire("jb2R2");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $7959bd06e7aba5a6$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $jb2R2.default)(dateLeft, dateRight) / 7;
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("kuBT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78d4ea938dacc68aef819972e5f69c40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeb3ffb0a3d9112d$var$_react = $eeb3ffb0a3d9112d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $eeb3ffb0a3d9112d$var$_iconNew = $eeb3ffb0a3d9112d$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $eeb3ffb0a3d9112d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/reply-left
 * Usage guidance:
 * Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eeb3ffb0a3d9112d$var$ReplyLeftIcon = (props)=>/*#__PURE__*/ $eeb3ffb0a3d9112d$var$_react.default.createElement($eeb3ffb0a3d9112d$var$_iconNew.default, Object.assign({
        name: "ReplyLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.78 2.28 2.56 5.498H7.5a8.5 8.5 0 0 1 8.5 8.5h-1.5a7 7 0 0 0-7-7H2.56l3.22 3.22-1.06 1.06-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5z"/>`
    }, props));
$eeb3ffb0a3d9112d$var$ReplyLeftIcon.displayName = 'ReplyLeftIcon';
var $eeb3ffb0a3d9112d$var$_default = module.exports.default = $eeb3ffb0a3d9112d$var$ReplyLeftIcon;

});

parcelRegister("7P5ob", function(module, exports) {
var $a0476e60d46954e4$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $a0476e60d46954e4$export$5fc610914b028d97;

});

parcelRegister("gYQp3", function(module, exports) {
// create separate utils folder if need to export more utils
const $e7e00ee1b8f0e7bd$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e7e00ee1b8f0e7bd$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e7e00ee1b8f0e7bd$var$extractContent = (data, flatMap)=>{
    if ($e7e00ee1b8f0e7bd$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e7e00ee1b8f0e7bd$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e7e00ee1b8f0e7bd$var$validMarks(data)) flatMap.push(data);
};
const $e7e00ee1b8f0e7bd$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e7e00ee1b8f0e7bd$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e7e00ee1b8f0e7bd$export$4cf5403beffb0fc1;

});

parcelRegister("eIO9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $zzZbq = parcelRequire("zzZbq");


var $jXbsB = parcelRequire("jXbsB");


var $8Yi0A = parcelRequire("8Yi0A");


var $e9Hlq = parcelRequire("e9Hlq");


const $22c6369f6e85adc5$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $22c6369f6e85adc5$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $22c6369f6e85adc5$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$22c6369f6e85adc5$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $22c6369f6e85adc5$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : (0, $e9Hlq.KeyPhraseCategory).AUTO;
};
const $22c6369f6e85adc5$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: (0, $e9Hlq.KeyPhraseCategory).AUTO,
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $22c6369f6e85adc5$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $cozmU.useState)($22c6369f6e85adc5$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $cozmU.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $jXbsB.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $jXbsB.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $iDrrr.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $8Yi0A.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $22c6369f6e85adc5$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                keyPhraseCategory: $22c6369f6e85adc5$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $cozmU.useCallback)(()=>{
        setState($22c6369f6e85adc5$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $cozmU.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $cozmU.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $cozmU.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $cozmU.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["getHighlightRegex"] = $22c6369f6e85adc5$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $22c6369f6e85adc5$export$52e9ff9bfbb65046;

});

parcelRegister("jXbsB", function(module, exports) {
const $3d17a38e3ddac80f$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $3d17a38e3ddac80f$export$39b2bc657daf065 = `
	query ${$3d17a38e3ddac80f$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $3d17a38e3ddac80f$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $3d17a38e3ddac80f$export$39b2bc657daf065;

});

parcelRegister("8Yi0A", function(module, exports) {

var $kJQMD = parcelRequire("kJQMD");

const $cac433bd7344ad2b$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $kJQMD.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
module.exports["onShownAutoDefinitionHighlights"] = $cac433bd7344ad2b$export$42897f8f02baa658;

});

parcelRegister("kJQMD", function(module, exports) {
const $6456db9229e50d9f$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $6456db9229e50d9f$export$f600f3124ea5916b;

});

parcelRegister("e9Hlq", function(module, exports) {
var $83451bfb10f50104$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
module.exports["KeyPhraseCategory"] = $83451bfb10f50104$export$17a511c5c23509af;

});

parcelRegister("6JEx2", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

const $37713e14e82d0a4d$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $37713e14e82d0a4d$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $37713e14e82d0a4d$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $37713e14e82d0a4d$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $37713e14e82d0a4d$var$getWindow = ()=>{
    if (typeof window === 'undefined') return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof window.sessionStorage === 'undefined') return null;
    return window;
};
const $37713e14e82d0a4d$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return null;
    return (0, $iDrrr.fg)('search_page_use_bsc_session_storage') ? (0, $7dBf8.AtlBrowserStorageSession).getItem(key) : $37713e14e82d0a4d$var$getWindow()?.sessionStorage.getItem(key);
};
const $37713e14e82d0a4d$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $iDrrr.fg)('search_page_use_bsc_session_storage')) (0, $7dBf8.AtlBrowserStorageSession).setItem(key, value);
        else $37713e14e82d0a4d$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $37713e14e82d0a4d$export$5896963da935fdc4 = (key)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return;
    if ((0, $iDrrr.fg)('search_page_use_bsc_session_storage')) (0, $7dBf8.AtlBrowserStorageSession).removeItem(key);
    else $37713e14e82d0a4d$var$getWindow()?.sessionStorage.removeItem(key);
};
module.exports["SEARCH_QUERY_KEY"] = $37713e14e82d0a4d$export$240cb7dc75f6cac2;
module.exports["SEARCH_FILTERS_KEY"] = $37713e14e82d0a4d$export$978fb20afa14aaa7;
module.exports["SEARCH_SHOW_AI_DIALOG_KEY"] = $37713e14e82d0a4d$export$f4dca218ecb5824a;
module.exports["getSessionItem"] = $37713e14e82d0a4d$export$fdf7104ff19cc288;
module.exports["setSessionItem"] = $37713e14e82d0a4d$export$a5376dd4adeb0fbf;
module.exports["deleteSessionItem"] = $37713e14e82d0a4d$export$5896963da935fdc4;

});

parcelRegister("7zn5c", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $2wiZs = parcelRequire("2wiZs");

const $bd707cc6f6ee43a7$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError, fireExperimentExposure: fireExperimentExposure = true })=>{
    try {
        const cohort = (0, $cXtTj.default).getExperiment(abTestId, {
            fireExperimentExposure: fireExperimentExposure
        }).get('cohort', (0, $2wiZs.Cohort).Default);
        const serveExperiment = cohort === (0, $2wiZs.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $2wiZs.Cohort).Default
    };
};
const $bd707cc6f6ee43a7$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    if (!overrides) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $bd707cc6f6ee43a7$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$var$defaultCheckGate;
    }
};
const $bd707cc6f6ee43a7$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    if (!overrides) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError, fireExperimentExposure: fireExperimentExposure })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError,
                fireExperimentExposure: fireExperimentExposure
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $2wiZs.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $bd707cc6f6ee43a7$var$defaultCheckGate = (name)=>(0, $cXtTj.default).checkGate(name);
const $bd707cc6f6ee43a7$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $cXtTj.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $bd707cc6f6ee43a7$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $bd707cc6f6ee43a7$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $bd707cc6f6ee43a7$export$b8cc3cdd046fba93;

});

parcelRegister("2wiZs", function(module, exports) {
var $695dfb69bc28d28c$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $695dfb69bc28d28c$export$b76685d1b5a37732;

});

parcelRegister("8tNXq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $zzZbq = parcelRequire("zzZbq");

const $a273dd7aa35752e1$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $a273dd7aa35752e1$export$e955abb82869dc84;

});

parcelRegister("hsCD1", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");

const $e508769d540061ba$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $e508769d540061ba$export$5b2a28beea8d66c3 = new (0, $34VCg.UFOExperience)(`${$e508769d540061ba$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $e508769d540061ba$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $e508769d540061ba$export$5b2a28beea8d66c3;

});

parcelRegister("lmNXu", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $dOBRD.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("bD3fd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57a3a98d1c0cdf17dca67c7ba0624f0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8775da7cfc706ac1$var$_react = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8775da7cfc706ac1$var$_iconNew = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8775da7cfc706ac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Jira".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/jira
 * Usage guidance:
 * Representing JIRA
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8775da7cfc706ac1$var$JiraIcon = (props)=>/*#__PURE__*/ $8775da7cfc706ac1$var$_react.default.createElement($8775da7cfc706ac1$var$_iconNew.default, Object.assign({
        name: "JiraIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.25A.75.75 0 0 1 7.75.5h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-1.625A2.6 2.6 0 0 1 12 8.747v3.003a.75.75 0 0 1-.75.75H9.625a2.6 2.6 0 0 1-1.125-.253v3.003a.75.75 0 0 1-.75.75H6.125A2.625 2.625 0 0 1 3.5 13.375V12.5h-.875A2.625 2.625 0 0 1 0 9.875V8.25a.75.75 0 0 1 .75-.75h3.003A2.6 2.6 0 0 1 3.5 6.375V4.75A.75.75 0 0 1 4.25 4h3.003A2.6 2.6 0 0 1 7 2.875zM9.625 4h1.625a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H14V2H8.5v.875C8.5 3.496 9.004 4 9.625 4m.875 1.5H5v.875C5 6.996 5.504 7.5 6.125 7.5H7.75a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125h.875zM7 9H1.5v.875c0 .621.504 1.125 1.125 1.125H4.25a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H7z" clip-rule="evenodd"/>`
    }, props));
$8775da7cfc706ac1$var$JiraIcon.displayName = 'JiraIcon';
var $8775da7cfc706ac1$var$_default = module.exports.default = $8775da7cfc706ac1$var$JiraIcon;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("dF6Hu", function(module, exports) {
const $c19c056402cab920$export$aacbed104b7824d = {
    version: 1,
    type: 'doc',
    content: []
};
const $c19c056402cab920$export$92be905df4143632 = (adf)=>({
        version: 1,
        type: 'doc',
        content: adf
    });
const $c19c056402cab920$export$d287f5fb15383464 = (adfString)=>{
    try {
        const parsed = JSON.parse(adfString ?? '');
        return Array.isArray(parsed.content) ? $c19c056402cab920$export$92be905df4143632(parsed.content) : $c19c056402cab920$export$aacbed104b7824d;
    } catch  {
        return $c19c056402cab920$export$aacbed104b7824d;
    }
};
const $c19c056402cab920$export$6952557fbb0fdd5b = (adf)=>({
        content: {
            nodes: [
                {
                    body: {
                        dynamic: {
                            representation: 'atlas_doc_format',
                            value: JSON.stringify({
                                content: adf,
                                type: 'doc'
                            })
                        }
                    }
                }
            ]
        }
    });
module.exports["createNestedAdfDocument"] = $c19c056402cab920$export$92be905df4143632;
module.exports["parseNestedAdfDocument"] = $c19c056402cab920$export$d287f5fb15383464;
module.exports["createNestedRendererData"] = $c19c056402cab920$export$6952557fbb0fdd5b;

});

parcelRegister("9rgEf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $730c064714609652$export$4842845a3bdb74f6 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $730c064714609652$export$aa899bf2529ccb2 = $730c064714609652$export$4842845a3bdb74f6.Provider;
module.exports["PageDocumentContext"] = $730c064714609652$export$4842845a3bdb74f6;
module.exports["PageDocumentProvider"] = $730c064714609652$export$aa899bf2529ccb2;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");


var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");


var $kkFbH = parcelRequire("kkFbH");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $hekY6.default)([
            "_4xdlr0chRC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $cozmU.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_0aNu0LYbGa",
    classIconStyles: "_0bjKvDzXzM",
    iconStyles: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $cozmU.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_2QcWTwLoGj _2SqxC4BE2a _2JgCDVoynL",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0Of8r21Y8M _2fwxA5DIqT _0KLXrurxgm",
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("hHZWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("euF5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("eV0v4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});

parcelRegister("iIsSm", function(module, exports) {

var $dPH52 = parcelRequire("dPH52");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/comment/manifest.ts
var $da02bc2ca043e890$var$confluenceCommentAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPH52.ConfluenceCommentAriResourceOwner),
    resourceType: (0, $dPH52.ConfluenceCommentAriResourceType),
    resourceIdSlug: "{commentId}",
    resourceIdSegmentFormats: {
        commentId: /[0-9]+/
    }
};
// src/confluence/comment/index.ts
var $da02bc2ca043e890$export$38528441a3df7d9b = class _ConfluenceCommentAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get commentId() {
        return this._commentId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $da02bc2ca043e890$var$confluenceCommentAriStaticOpts.qualifier,
            platformQualifier: $da02bc2ca043e890$var$confluenceCommentAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $da02bc2ca043e890$var$confluenceCommentAriStaticOpts.resourceOwner,
            resourceType: $da02bc2ca043e890$var$confluenceCommentAriStaticOpts.resourceType,
            resourceId: `${opts.commentId}`,
            resourceIdSegmentValues: {
                commentId: opts.commentId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $da02bc2ca043e890$var$confluenceCommentAriStaticOpts);
        return new _ConfluenceCommentAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $da02bc2ca043e890$var$confluenceCommentAriStaticOpts);
        return new _ConfluenceCommentAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            commentId: this.commentId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._commentId = opts.resourceIdSegmentValues.commentId;
    }
};
module.exports["ConfluenceCommentAri"] = $da02bc2ca043e890$export$38528441a3df7d9b;

});

parcelRegister("dPH52", function(module, exports) {
// src/confluence/comment/types.ts
var $a121749c68bf2001$export$1b7a0d17a9cd6608 = "confluence", $a121749c68bf2001$export$cf3fa71671c6fc3b = "comment";
module.exports["ConfluenceCommentAriResourceOwner"] = $a121749c68bf2001$export$1b7a0d17a9cd6608;
module.exports["ConfluenceCommentAriResourceType"] = $a121749c68bf2001$export$cf3fa71671c6fc3b;

});


//# sourceMappingURL=ObjectCommentContainer.831321f6.js.map
